module.exports = {
  login: {
    'UserName': '用户名',
    'PassWord': '密\xa0\xa0\xa0\xa0码',
    'Login': '登\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0录',
    'Account cannot be empty': '账号不能为空'
  },
  homePage: {
    'Policy': '政策',
    'Product': '产品',
    'Order': '订单',
    'After-sales': '售后',
    'Audit': '稽核',
    'Finance and taxation': '财税',
    'Settings': '设置',
    'Announcement': '公告',
    'Please enter a keyword': '请输入关键字',
    'Publisher': '发布人',
    'Confirm deletion of selected records?': '确认删除选中记录吗？',
    'Notification': '通知',
    'Processed': '已处理',
    'Personal Information': '个人信息',
    'Change Password': '修改密码',
    'Edit Profile': '编辑个人资料',
    'Please enter the correct email format': '请输入正确的邮箱格式',
    'Phone': '电话',
    'Phone number must be a number': '电话号码必须是数字',
    'Original password': '原密码',
    'New password': '新密码',
    'Inconsistent password entered twice!': '两次输入密码不一致!',
    'Mobile phone number cannot be empty': '手机号不能为空',
    'Please enter the correct mobile phone number': '请输入正确的手机号',
    'Please enter your real name': '请输入真实姓名',
    'Mailbox format input error': '邮箱格式输入错误',
    'Personal data modified successfully': '个人资料修改成功',
    'Failed to modify state': '修改状态失败',
    'Password change is successful, please log in to the system again': '修改密码成功，请重新登录系统',
    'Pass': '通过',
    'Exit the system, whether to continue?': '退出该系统, 是否继续?',
    'Please change the login password first': '请先修改登录密码',
    'ws I was destroyed, remove monitor > > >': 'ws 我被销毁了, 移除监听>>>'
  },
  forgotPassword: {
    'Login': '登录',
    'Enter login name': '输入登录名',
    'Verify identity': '验证身份',
    'Next step': '下一步',
    'Retrieve password method': '找回密码方式',
    'Mailbox Retrieval': '邮箱找回',
    'Sent verification email': '发送验证邮箱',
    'Sent verification email To': '已发送验证邮箱致',
    'The verification email is valid for 48 hours please log in to the mailbox ASAP to complete the verification': '验证邮件48小时有效，请尽快登录邮箱完成验证。',
    'Password changed successfully, please re': '密码修改成功，请重新',
    'Automatically jump to the login page after seconds': '秒后自动跳转到登录页面',
    'Inconsistent password entered twice !': '两次输入密码不一致！',
    'Secret protection recovery': '密保找回',
    'If the password cannot be retrieved please contact the administrator': '无法找回密码，请联系管理员'
  },
  account: {
    'Login must be letters or numbers': '登录名必须是字母或数字',
    'Confidentiality': '保密',
    'Department': '部门',
    'Position': '岗位',
    'Please select a position': '请选择岗位',
    'Character Name': '角色名',
    'Please select a role': '请选择角色',
    'Please fill in the account number': '请填写账号',
    'The account number must be a combination of numbers and letters': '账号必须是由数字和字母组合',
    'Please fill in the mobile phone number': '请填写手机号',
    'Please fill in the correct mobile phone number': '请填写正确的手机号',
    'Please fill in the password': '请填写密码',
    'Please fill in the password again': '请再次填写密码',
    'Inconsistent password filled in twice': '两次填写密码不一致',
    'Please fill in your real name': '请填写真实姓名',
    'Please select a department name': '请选择部门名称',
    'Please select a job title': '请选择岗位名称',
    'Please select a role name': '请选择角色名称',
    'Enabled': '启用',
    'Deleted': '已删除',
    'Operation failed': '操作失败',
    'The mailbox format is incorrect': '邮箱格式不正确',
    'Added/modified account successfully': '新增/修改账号成功',
    'New account': '新增账号',
    'Edit account': '编辑账号',
    'Article': '条',
    ',Failed': '，失败： ',
    'Status Success': '状态成功',
    'Status Failed': '状态失败',
    'Are you sure the reset password is 123456 ?': '确定重置密码为123456吗？',
    'Reset password to 123456': '已重置密码为123456',
    'Failed to reset password': '重置密码失败',
    'Administrator account management': '管理员账号管理'
  },
  configuration: {
    'New system configuration': '新增系统配置',
    'Configuration name': '配置名称',
    'Configuration code': '配置代码',
    'Configuration value': '配置值'
  },
  operatelog: {
    'Operation date': '操作日期',
    'Clear data': '清除数据',
    'Please select start date and end date': '请选择开始日期和结束日期',
    'Confirm that the data is cleared according to the query conditions?': '确认按照查询条件清除数据吗？',
    'Deleted successfully': '删除成功',
    'Bar data': '条数据'
  },
  orderlist: {
    '已起飞航班不支持操作': '已起飞航班不支持操作',
    'System pending': '系统待处理',
    'System processing': '系统处理中',
    'Abnormal order': '异常订单',
    'Manual pending payment': '人工待支付',
    'Manual pending processing': '人工待处理',
    'Order status': '订单状态',
    'Start taking orders': '开始接单',
    'Stop taking orders': '停止接单',
    'Platform': '平台',
    'Please select a platform': '请选择平台',
    'Departure Date': '航班开始日期',
    'Arrival Date': '航班结束日期',
    'ID number': '证件号',
    'Order Start': '订单开始时间',
    'Creation start time': '创建开始时间',
    'Order End': '订单结束时间',
    'Creation end time': '创建结束时间',
    'Lock order type': '锁单类型',
    'Lock single person': '锁单人',
    'Auditor': '核账人',
    'Verification status': '核账状态',
    'Platform refund has been settled': '平台退款已结算',
    'Purchase rebate settled': '采购回款已结算',
    'Settlement completed': '结算完成',
    'Audit start date': '核账开始日期',
    'Audit end date': '核账结束日期',
    'Auto refresh': '自动刷新',
    'Enter ticket': '录入出票单',
    'Batch Re-Occupy': '批量重新占座',
    'Bulk Ticket Reset': '批量出票重置',
    'Batch modification class': '批量修改舱位',
    'Bulk Booking Instructions': '批量预订指令',
    'Batch platform collection verification account': '批量平台收款核账',
    'Bulk Purchase Payment Verification': '批量采购付款核账',
    'Latest Ticketing Time/Order Date': '最晚出票时间/订单日期',
    'Platform Information': '平台信息',
    'Platform order number': '平台订单号',
    'Exception': '异常',
    'Appeal': '申诉',
    'Urge': '催',
    'Order Status/Sub-Status': '订单状态',
    'Flight information': '航班信息',
    'Purchasing Information': '采购信息',
    'Expenditure Amount': '支出金额',
    'PNR/AV status': 'PNR',
    'Total price/number of people': '总价/人数',
    'Unlock': '解锁',
    'Drawer': '出票人',
    'Ticketing efficiency': '出票效率',
    'Latest ticket issuance': '最晚出票时间',
    'Auditor/Audit status': '核账人/核账状态',
    'Platform collection has been settled': '平台收款已结算',
    'Purchase payment settled': '采购付款已结算',
    'Are you sure to retake your seat?': '确定重新占座吗？',
    'Repay': '重新支付',
    'View': '查看',
    'Processing': '处理',
    'Are you sure to cancel the top?': '确定取消置顶吗？',
    'Logs': '日志',
    'Cancel the top': '取消置顶',
    'Order Details': '订单详情',
    'Order Information :': '订单信息:',
    'Original order number': '原始订单号',
    'Parent order number': '父订单号',
    'Sub-order number': '子订单号',
    'Brother order number': '兄弟订单号',
    'Small code': '小编码',
    'Child Code': '儿童编码',
    'Order Type': '订单类型',
    'Order source': '订单来源',
    'Total price': '总价',
    'Contact phone number': '联系人电话',
    'Voyage': '航程',
    'Nationality': '国籍',
    'Certificate valid period': '证件有效期',
    'Purchase Records': '采购记录',
    'Procurement channel': '采购渠道',
    'Automatic': '自动',
    'Labor': '人工',
    'Transaction record': '交易记录',
    'Transaction Channel': '交易渠道',
    'Transaction Amount': '交易金额',
    'Trading hours': '交易时间',
    'Ticket Log': '出票单日志',
    'Dispatch': '派单',
    'Account number': '账号',
    'Upload file': '上传文件',
    'Ticket channel': '出票渠道',
    'Unlimited entry 0': '不限时录入0',
    'No coupon required': '不用优惠券',
    'Coupon useful or not': '优惠券有用无不用',
    'Purchase payment verification details': '采购付款核账明细',
    'Purchase payment verification import': '采购付款核账导入',
    'Audit account type': '核账类型',
    'Purchase Receipt Audit Account': '采购回款核账',
    'Platform refund verification account': '平台退款核账',
    'Platform collection verification account': '平台收款核账',
    'Purchase payment verification': '采购付款核账',
    'Number of orders': '订单数',
    'Time consuming': '耗时',
    'File path': '文件路径',
    'Export': '导出',
    'Upload purchase payment verification details': '上传采购付款核账明细',
    'Directive': '指令',
    'Platform collection verification account details': '平台收款核账明细',
    'Platform collection and verification account import': '平台收款核账导入',
    'Upload platform collection verification details': '上传平台收款核账明细',
    'Class Code': '舱位代码',
    'Shared flights': '共享航班',
    'Child Booking Instructions': '儿童预订指令',
    'Please fill in the class': '请填写舱位',
    'Please select the verification type': '请选择核账类型',
    'Please select an account': '请选择账号',
    'Designated cabin code cannot be empty': '指定舱位代码不能为空',
    'Please select a reason for cancellation': '请选择取消原因',
    'Please select a store': '请选择店铺',
    'Batch booking codes cannot be booked for different flight segments': '不同航段无法批量预订编码',
    'Please select at least one order': '请至少选择一个订单',
    'The maximum number of people in the batch booking code can only be 9 people': '批量预订编码最大人数只能为9人',
    'Reservation code successful': '预订编码成功',
    'Bulk booking instructions cannot be made for different flight segments': '不同航段无法批量预订指令',
    'The maximum number of bulk booking orders can only be 9 people': '批量预订指令最大人数只能为9人',
    'Different airlines cannot modify in batches': '不同航司无法批量修改',
    'Failed to cancel the order, reason :': '取消订单失败，原因：',
    'The difference between the start date and the end date cannot be greater than 365 days': '开始日期和结束日期相差不能大于365天',
    'The difference between the start date and the end date cannot exceed 100 days': '开始日期和结束日期相差不能超过100天',
    'Added successfully View scan results later': '新增成功稍后查看扫描结果',
    'Are you sure to export the data?': '确定导出数据吗？',
    'Passenger Information not found': '未查询到乘机人信息',
    'Failed to query purchase records': '查询采购记录失败',
    'Airline code configuration not found': '未查询到航司代码配置',
    'Updated order remarks successfully!': '更新订单备注成功！',
    'Failed to fill': '补位失败',
    'Ticket issued has been approved': '出票单已被',
    'There are orders that do not meet the conditions for re-occupation because they are not ticketed and cancelled': '有订单不符合重新占座的条件，原因：未出票取消，',
    'The platform ticket number is:': '出票单号为：',
    'There are orders that do not meet the conditions for re-occupation,': '有订单不符合重新占座的条件，',
    'There are orders that do not meet the conditions for ticketing reset because they are not ticketed and cancelled': '有订单不符合出票重置的条件，原因：未出票取消，',
    'There are orders that do not meet the conditions for ticket reset,': '有订单不符合出票重置的条件，',
    'Different airlines cannot reset in batches': '不同航司无法批量重置',
    'System lock order': '系统锁单',
    'My lock list': '我的锁单',
    'Unlocked order': '未锁单',
    'The verification end date must be greater than or equal to the start date': '核账结束日期必须大于等于开始日期',
    'The current limit selects 2 files, this time it is selected': '当前限制选择 2 个文件，本次选择了',
    'Please select upload file': '请选择上传文件',
    'Confirm that the data is exported according to the condition?': '确认根据条件导出数据吗？',
    'Day': '天 ',
    'hours': '时 ',
    'minutes': '分 ',
    'seconds': '秒 ',
    'Remaining': '剩余',
    'Beyond': '超出 ',
    'Age': '年龄',
    'Number of exceptions:': '异常次数：',
    'Are you sure you want to start taking orders?': '确定开始接单吗？',
    'Query employee dispatch abnormality': '查询员工派单异常。',
    'Processing the refund order is full and cannot be dispatched': '正在处理退票单数已满，无法派单',
    'Are you sure you want to stop taking orders?': '确定停止接单吗？',
    'Successful delivery of the order': '派单成功',
    'Cancel the top successfully': '取消置顶成功',
    'ws I was destroyed, vue lifecycle>>>': 'ws我被销毁了,vue生命周期>>>'
  },
  'Record of Refunds and Changes': '退改记录',
  'Login timeout, please log in again!': '登录超时，请重新登录！',
  '首页': '首页',
  '出票': '出票',
  '机票': '机票',
  '出票单查询': '出票单查询',
  '待筛单': '待筛单',
  '已锁待处理': '已锁待处理',
  '全部待处理': '全部待处理',
  '出票完成': '出票完成',
  '订单取消': '订单取消',
  '票号验证': '票号验证',
  '异常客票': '异常客票',
  'OPEN票': 'OPEN票',
  '航变信息': '航变信息',
  '行程单': '行程单',
  '刷票订单': '刷票订单',
  '辅助下单': '辅助下单',
  '航变订阅': '航变订阅',
  '航班动态': '航班动态',
  '飞猪行李额解压': '飞猪行李额解压',
  '改签': '改签',
  '改签单查询': '改签单查询',
  '已锁结算异常处理': '已锁结算异常处理',
  '已锁结算异常': '已锁结算异常',
  '已锁改签中': '已锁改签中',
  '已锁未退票改签单': '已锁未退票改签单',
  '全部结算异常待处理': '全部结算异常待处理',
  '全部改签中': '全部改签中',
  '全部未退票改签单': '全部未退票改签单',
  '改签取消': '改签取消',
  '退票': '退票',
  '确认退票':'确认退票',
  '退票详情': '退票详情',
  '退票单查询': '退票单查询',
  '已锁异常回款待处理': '已锁异常回款待处理',
  '已锁退票异常': '已锁退票异常',
  '已锁结算异常待处理': '已锁结算异常待处理',
  '全部异常回款待处理': '全部异常回款待处理',
  '全部退票异常': '全部退票异常',
  '全部结算异常': '全部结算异常',
  '核销异常待处理': '核销异常待处理',
  '全部核销异常订单': '全部核销异常订单',
  '退票取消': '退票取消',
  '辅助退票': '辅助退票',
  '退票费确认': '退票费确认',
  '异常单': '异常单',
  '异常单查询': '异常单查询',
  '已锁异常回款': '已锁异常回款',
  '全部异常回款': '全部异常回款',
  '异常取消': '异常取消',
  '申诉单': '申诉单',
  '申诉订单': '申诉订单',
  '报表': '报表',
  '出票订单报表': '出票订单报表',
  '改签订单报表': '改签订单报表',
  '退票订单报表': '退票订单报表',
  '异常订单报表': '异常订单报表',
  '出票实时汇总报表': '出票实时汇总报表',
  '稽核': '稽核',
  '改签待结算': '改签待结算',
  '改签已结算': '改签已结算',
  '退票已锁核销异常待处理': '退票已锁核销异常待处理',
  '退票全部核销异常待处理': '退票全部核销异常待处理',
  '退票待结算': '退票待结算',
  '退票已结算': '退票已结算',
  '异常已锁核销异常待处理': '异常已锁核销异常待处理',
  '异常全部核销异常待处理': '异常全部核销异常待处理',
  '异常待结算': '异常待结算',
  '异常已结算': '异常已结算',
  '运价政策': '运价政策',
  '公布运价': '公布运价',
  '官网运价': '官网运价',
  '官网运价NEW': '官网运价NEW',
  '航班周期管理': '航班周期管理',
  '公布运价扫描': '公布运价扫描',
  'Eterm数据扫描': 'Eterm数据扫描',
  'Eterm指令查询': 'Eterm指定查询',
  '疫情订单匹配': '疫情订单匹配',
  '外部运价查询': '外部运价查询',
  '出票规则': '出票规则',
  '出票设置': '出票设置',
  '出票账号管理': '出票账号管理',
  '出票过滤': '出票过滤',
  '出票自动AV订座': '出票自动AV/订座',
  '出票渠道管理': '出票渠道管理',
  '付款渠道管理': '付款渠道管理',
  '派单设置': '派单设置',
  '退票规则': '退票规则',
  '改签规则': '改签规则',
  '退票提醒时间设置': '退票提醒时间设置',
  '退票提醒信息设置': '退票提醒信息设置',
  '退票处理时限设置': '退票处理时限设置',
  '航司退改规则': '航司退改规则',
  '自动退票规则': '自动退票规则',
  '产品管理': '产品管理',
  '航司调价': '航司调价',
  '航线调价': '航线调价',
  '产品日志': '产品日志',
  '投放日志': '投放日志',
  '航变国航': '航变国航',
  '航变东航': '航变东航',
  '系统监控': '系统监控',
  '报价接口查询': '报价接口查询',
  '直连接口状态': '直连接口状态',
  '比价查询': '比价查询',
  '短信查询': '短信查询',
  '系统配置': '系统配置',
  '店铺管理': '店铺管理',
  '系统设置': '系统设置',
  '代理费管理': '代理费管理',
  '机场信息': '机场信息',
  '设置': '设置',
  '账号管理': '账号管理',
  '角色管理': '角色管理',
  '部门管理': '部门管理',
  '岗位管理': '岗位管理',
  '公告管理': '公告管理',
  '操作日志': '操作日志',
  '渠道': '渠道',
  '扫舱政策': '扫舱政策',
  '产品': '产品',
  '调价设置': '调价设置',
  '产品监控': '产品监控',
  '直连监控': '直连监控',
  '订单': '订单',
  '出票订单': '出票订单',
  '国际机票': '国际机票',
  '售后管理': '售后管理',
  '退票订单': '退票订单',
  '改签订单': '改签订单',
  '改签详情': '改签详情',
  '异常订单': '异常订单',
  '账单': '账单',
  '商户现金明细': '商户现金明细',
  '资金交易明细': '资金交易明细',
  '财税': '财税',
  '业务报表': '业务报表',
  '财务报表': '财务报表',
  '权限控制': '权限控制',
  '基础配置': '基础配置',
  '导出': '导出',
  '查看': '查看',
  '日志': '日志',
  '解锁': '解锁',
  '导入': '导入',
  '处理': '处理',
  '批量确认': '批量确认',
  '批量结算': '批量结算',
  '批量异常': '批量异常',
  '重新占座': '重新占座',
  '重新支付': '重新支付',
  '核账': '核账',
  '订单详情': '订单详情',
  '标记验证通过': '标记验证通过',
  '标记验证不通过': '标记验证不通过',
  '忽略验证': '忽略验证',
  '核实通过': '核实通过',
  '重新回填': '重新回填',
  '已打印': '已打印',
  '已快递': '已快递',
  '已取消': '已取消',
  '已退票': '已退票',
  'Eterm指令': 'Eterm指令',
  '详情': '详情',
  '编辑': '编辑',
  '修改': '修改',
  '修改状态': '修改状态',
  '重新刷票': '重新刷票',
  '已出票': '已出票',
  '取消刷票': '取消刷票',
  '开启': '开启',
  '暂停': '暂停',
  '删除': '删除',
  'Back': '返回',
  '清除数据': '清除数据',
  '新增': '新增',
  '付款': '付款',
  '解压': '解压',
  '取消置顶': '取消顶置',
  '派单': '派单',
  '账号规则': '账号规则',
  '系统派单设置编辑': '系统派单设置编辑',
  '员工派单设置编辑': '员工派单设置编辑',
  '产品设置': '产品设置',
  '航线过滤': '航线过滤',
  '航线白名单': '航线白名单',
  '拉单规则': '拉单规则',
  '重置密码': '重置密码',
  '新增角色': '新增角色',
  '指定用户': '指定用户',
  '新增部门': '新增部门',
  '删除部门': '删除部门',
  '保存': '保存',
  '保存出票单': '保存出票单',
  '保存退票单': '保存退票单',
  '保存改签单': '保存改签单',
  '拒绝出票': '拒绝出票',
  '拒绝退票': '拒绝退票',
  '拒绝改签': '拒绝改签',
  '审核': '审核',
  '结算': '结算',
  '添加': '添加',
  '启用': '启用',
  '禁用': '禁用',
  '上线': '上线',
  '录入出票单': '录入出票单',
  '录入退票单': '录入退票单',
  '改签申请': '改签申请',
  '导出报表': '导出报表',
  '核销异常待结算': '核销异常待结算',
  '核销异常已结算': '核销异常已结算',
  '待确认': '待确认',
  '待结算': '待结算',
  '已结算': '已结算',
  '已锁核销异常待处理': '已锁核销异常待处理',
  '全部核销异常待处理': '全部核销异常待处理',
  '销售报表': '销售报表',
  '利润报表': '利润报表',
  '交易报表': '交易报表',
  '出票单乘机人报表': '出票单乘机人报表',
  '复制': '复制',
  '系统日志': '系统日志',
  '订单乘机人人电话CTM': '订单乘机人人电话CTM',
  '订单联系人电话CTCT': '订单联系人电话CTCT',
  '去哪儿票号验证接口': '去哪儿票号验证接口',
  '航变监控': '航变监控',
  '售后订单推送': '售后订单推送',
  '异常自动重试': '异常自动重试',
  '退票单票号验证': '退票单票号验证',
  '出票利润群推送': '出票利润群推送',
  '订单统计': '订单统计',
  '运营': '运营',
  '菜单管理': '菜单管理',
  '数据字典': '数据字典',
  '字典配置': '字典配置',
  '新增菜单': '新增菜单',
  '权限设置': '权限设置',
  '资源管理': '资源管理',
  '商家管理': '商家管理',
  '任务调度': '任务调度',
  '政策爬虫': '政策爬虫',
  '占座爬虫': '占座爬虫',
  '缓存管理': '缓存管理',
  '商家账号管理': '商家账号管理',
  '常旅客页面': '常旅客页面',
  '数据': '数据',
  '财务': '财务',
  '对账': '对账',
  '成人': '成人',
  '儿童': '儿童',
  '婴儿': '婴儿',
  '语言': '语言',
  '手提': '手提',
  '托运': '托运',
  'Please enter username': '请输入用户名',
  'Please enter password': '请输入密码',
  'Error': '错误',
  'Password cannot be empty': '密码不能为空',
  'Success': '通过',
  'Home': '首页',
  'Channel': '渠道',
  'Search': '查询',
  'Title': '标题',
  'Release time': '发布时间',
  'Operation': '操作',
  'Delete': '删除',
  'Announcement details': '公告详情',
  'Attachment': '附件',
  'Tip': '提示',
  'Login Name': '登录名',
  'Real Name': '真实姓名',
  'Gender': '性别',
  'Male': '男',
  'Female': '女',
  'Role Name': '角色名称',
  'Job Number': '工号',
  'Please fill in the job number': '请填写工号',
  'Mail': '邮箱',
  'Cancel': '取消',
  'Save': '保存',
  'Confirm Password': '确认密码',
  'Please enter the password again': '请再次输入密码',
  'Modified status successfully': '修改状态成功',
  'Yes': '确定',
  'Reset-pw': '重置密码',
  'Password': '密码',
  'Reset': '重置',
  'Failed': '失败',
  'Contact information': '联系方式',
  'Import': '导入',
  'Add': '新增',
  'Status': '状态',
  'administrator': '管理员',
  'No': '否',
  'Department Name': '部门名称',
  'Job Title': '岗位名称',
  'Creation time': '创建时间',
  'Edit': '编辑',
  'Are you sure to delete?': '确定删除吗？',
  'Please select a department': '请选择部门',
  'Normal': '正常',
  'Disable': '禁用',
  'Click to upload': '点击上传',
  'Only xlsx files can be uploaded': '只能上传xlsx文件',
  'Download Template': '下载模板',
  'The current limit selects 1 file, this time it is selected': '当前限制选择 1 个文件，本次选择了',
  'Files selected': '个文件，共选择了',
  'files': '个文件',
  'Please select a file to upload': '请选择上传的文件',
  'Modify': '修改',
  'OK': '确定',
  'Remarks': '备注',
  'Role Description': '角色描述',
  'Permission': '权限选择',
  'Time': '操作时间',
  'Operator': '操作人',
  'Start date': '开始日期',
  'End date': '结束日期',
  'End date must be greater than or equal to start date': '结束日期必须大于等于开始日期',
  'dateTips': '开始日期和结束日期相差不能大于 {days} 天',
  'The difference between the start date and the end date cannot be greater than 31 days': '开始日期和结束日期相差不能大于31天',
  'Merchant': '商家',
  'Shop': '店铺',
  'Order Status': '订单状态',
  'Policy Code': '政策代码',
  'Platform ticket number': '出票单号',
  'Arrival airport code': '到达机场代码',
  'Flight No': '航班号',
  'Class': '舱位',
  'Passenger Name': '乘机人姓名',
  'Ticket number': '票号',
  'Purchase Order Number': '采购订单号',
  'Change': '改签',
  'Refund': '退票',
  'Share': '共享',
  'Profit': '利润',
  'Passenger': '乘客',
  'Re-occupy the seat': '重新占座',
  'Ticket Reset': '出票重置',
  'Are you sure to pay again?': '确定重新支付吗？',
  'Audit account': '核账',
  'Order number': '订单号',
  'Booking no': '订单号',
  'Operation No': '单号',
  'Big Code': '大编码',
  'Policy Type': '政策类型',
  'Order Date': '订单日期',
  'Ticketing Date': '出票日期',
  'Exchange Date': '改签日期',
  'Departure Airline': '去程航司',
  'Contact Name': '联系人姓名',
  'Exception information': '异常信息',
  'Order Remarks': '订单备注',
  'Segment Information': '航段信息',
  'Segment': '航段',
  'Type': '类型',
  'Departure time': '起飞时间',
  'Arrival time': '到达时间',
  'Passenger Information': '乘客信息',
  'Birthday': '生日',
  'Fare': '票面价',
  'Sales Price': '销售价',
  'Taxes': '税费',
  'Purchase method': '采购方式',
  'Purchase account number': '采购账号',
  'Purchase password': '采购密码',
  'Payment Amount': '支付金额',
  'Offer Type': '优惠类型',
  'Discount Amount': '优惠金额',
  'Offer logo': '优惠标识',
  'Purchase time': '采购时间',
  'Trading serial number': '交易流水号',
  'Change Information': '改签信息',
  'Refund information': '退票信息',
  'Order Log': '订单日志',
  'Payment Channel': '付款渠道',
  'Ticketing office': '出票office',
  'Ticketing Class': '出票舱位',
  'Please select': '请选择',
  'Lowest cabin': '最低舱',
  'Same cabin': '同舱',
  'Downgrade': '降舱',
  'Designated class': '指定舱位',
  'Designated cabin code': '指定舱位代码',
  'Maximum loss amount': '最大亏损金额',
  'None': '无',
  'Direct subtraction': '直减',
  'Coupon': '优惠券',
  'Red Packet': '红包',
  'Coupon has no face value': '优惠券无面值',
  'Coupon Rules': '优惠券规则',
  'Product Type': '产品类型',
  'Select All': '全选',
  'Modify order status': '修改订单状态',
  'Reason for cancellation': '取消原因',
  'Payment timeout cancellation': '支付超时取消',
  'Intercept Ticket Cancellation': '拦截出票取消',
  'Unticketed Refund Cancellation': '未出票退款取消',
  'Manual Cancellation': '人工取消',
  'Unticketed Refund Purchased': '未出票退款已采购',
  'Rejected Cancellation': '驳回取消',
  'Booking Instructions': '预订指令',
  'Main flight': '主飞航班',
  'Adult Booking Instructions': '成人预订指令',
  'Copy': '复制',
  'Please enter content': '请输入内容',
  'Please select the ticketing class': '请选择出票舱位',
  'Please select the ticket channel': '请选择出票渠道',
  'Please select a payment channel': '请选择付款渠道',
  'Maximum loss amount cannot be empty': '最大亏损金额不能为空',
  'Please select the offer type': '请选择优惠类型',
  'Please select the coupon rule': '请选择优惠券规则',
  'Confirm cancellation of order?': '确认取消订单吗',
  'Submit': '提交',
  'Cancel the order successfully': '取消订单成功',
  'Children': '儿童',
  'There is a purchase record in processing, try again later': '存在处理中的采购记录，稍后重试',
  'Copied to paste board': '已复制到粘贴板',
  'To be screened': '待筛单',
  'Waiting for seat confirmation': '等待座位确认',
  'noPay': '待支付',
  'The payment is successful and waiting for the ticket to be issued': '待出票',
  'Ticketing': '出票中',
  'Purchasing': '采购中',
  'Purchase Completed': '采购完成',
  'Purchase Failed': '采购失败',
  'Ticket issued successfully': '出票完成',
  'Cancelled': '订单取消',
  'Pending': '待处理',
  'Wait for system payment': '等待系统支付',
  'Waiting for manual payment': '等待人工支付',
  'Ticket swiping': '刷票中',
  'Successful ticket swiping': '刷票成功',
  'Failed to swipe tickets': '刷票失败',
  'Filling in': '补位中',
  'Successful filling': '补位成功',
  'Pending appeal': '待申诉',
  'In appeal': '申诉中',
  'Appeal successful': '申诉成功',
  'Appeal failed': '申诉失败',
  'Gambling on the change': '赌航变',
  'Betting on the success of the flight': '赌航变成功',
  'Betting on the flight to fail': '赌航变失败',
  'Tickets issued': '已出票',
  'Downgraded': '已降舱',
  'Refunded': '已退票',
  'Changed': '已改签',
  'Intercepting ticket issuance': '拦截出票中',
  'Failed to intercept ticket issuance': '拦截出票失败',
  'Backfill failed': '回填失败',
  'Asynchronous ticketing': '异步出票中',
  'Asynchronous Seat Occupancy': '异步占座中',
  'Asynchronous payment in progress': '异步支付中',
  'Settlement': '已结算',
  'Lock': '锁定',
  'Unlocked successfully': '解锁成功',
  'Unlock failed': '解锁失败',
  'Unticketed Cancellation': '未出票取消',
  'Re-payment successful': '重新支付成功',
  'Re-payment failure': '重新支付失败',
  'Youth Special': '青年特惠',
  'Multi-person special offer': '多人特惠',
  'Self-selling price': '自销惠价',
  'Domestic surprise price': '国内惊喜价',
  'Economy Class': '经济舱',
  'Please fill in the correct number': '请填写正确的数字',
  'Please select a passenger': '请选择乘机人',
  'Start and end dates cannot be empty': '开始日期和结束日期不能为空',
  'Ticket number can only be 13 digits': '票号格式不对，只能是13位',
  'Order source configuration not found': '未查询到订单来源配置',
  'Query': '查询',
  'All': '全部',
  'Special Offer': '特价',
  'New': '新增',
  '充值余额': '充值余额',
  '使用充值余额': '使用充值余额',
  '充值余额结算': '充值余额结算',
  '充值余额不足': '充值余额不足',
  '资金变动': '资金变动',
  '充提审核': '充提审核',
  '结算管理': '结算管理',
  '资金账户': '资金账户',
  '出票费审核': '出票费审核',
  '改签费审核': '改签费审核',
  '退票费审核': '退票费审核',
  '现金账户明细': '现金账户明细',
  '供应商': '供应商',
  '采购商': '采购商',
  '一级': '一级',
  '二级': '二级',
  '三级': '三级',
  '异常': '异常',
  '正常': '正常',
  '授信结算': '授信结算',
  '授信结算明细': '授信结算明细',
  '授信结算单号': '授信结算单号',
  '授信': '授信',
  'Credit limit': '授信额度',
  'Credit settlement period': '授信结算周期',
  'Credit balance': '授信余额',
  'Settlement time': '结算时间',
  'Payment deadline': '还款截止时间',
  'Amount due': '结算金额',
  'Pay amount': '实付金额',
  'Payer': '还款人',
  'Bill Date': '账单日',
  'Settle': '结算',
  'digit': '数字',
  'nonnegative number': '非负数',
  'Supports up to': '不超过',
  'decimal places': '小数位',
  'integer': '整数',
  'positive': '正',
  '宝易': '宝易',
  '微信': '微信',
  '易宝': '易宝',
  '支付宝': '支付宝',
  '平安': '平安',
  '免审': '免审',
  '待审核': '待审核',
  '审核成功': '审核成功',
  '审核失败': '审核失败',
  '已拒绝': '已拒绝',
  '充值': '充值',
  '提现': '提现',
  '入账': '入账',
  '退票冻结现金': '退票冻结现金',
  '退票解冻现金': '退票解冻现金',
  '收款': '收款',
  '冻结': '冻结',
  '解冻': '解冻',
  '追加保证金': '追加保证金',
  '退款': '退款',
  '授信还款': '授信还款',
  '授信变更': '授信变更',
  '默认值': '默认值',
  '已支付未销账': '已支付未销账',
  '已支付已销账': '已支付已销账',
  '退款未销账': '退款未销账',
  '退款已销账': '退款已销账',
  '收入': '收入',
  '支出': '支出',
  '交易中': '交易中',
  '交易成功': '交易成功',
  '交易失败': '交易失败',
  '政策表': '政策表',
  '国内始发': '国内始发',
  '直飞SOTO程': '直飞SOTO程',
  '国内始发Add-On': '国内始发Add-On',
  '国外始发Add-On': '国外始发Add-On',
  '境外到境外': '境外到境外',
  '国内始发中转': '国内始发中转',
  '国外始发中转': '国外始发中转',
  '境外境外境外': '境外境外境外',
  '境外境内境外': '境外境内境外',
  '全球到全球': '全球到全球',
  '全球中转全球': '全球中转全球',
  '单程': '单程',
  '往返': '往返',
  '单程/往返': '单程/往返',
  '挂起': '挂起',
  '系统挂起': '系统挂起',
  '无法使用': '无法使用',
  '正在审核': '正在审核',
  '境外电子': '境外电子',
  '无需换编码': '无需换编码',
  '换编码出票': '换编码出票',
  '大编出票(无需换编)': '大编出票(无需换编)',
  '大编出票(需换编)': '大编出票(需换编)',
  '无需换编出票(外放无位)': '无需换编出票(外放无位)',
  '原编出票': '原编出票',
  '换编出票': '换编出票',
  '相同地区配置可原编出票': '相同地区配置可原编出票',
  '是': '是',
  '否': '否',
  '现金': '现金',
  '支票': '支票',
  '信用卡': '信用卡',
  'Abacus或Sabre': 'Abacus或Sabre',
  '留学生': '留学生',
  '移民': '移民',
  '劳工': '劳工',
  '海员': '海员',
  '青年': '青年',
  '老年': '老年',
  '探亲': '探亲',
  '港澳台': '港澳台',
  '外籍': '外籍',
  '非汉字姓名': '非汉字姓名',
  'Add-On': 'Add-On',
  '境外中转': '境外中转',
  'OPEN': 'OPEN',
  '三方协议': '三方协议',
  '套票': '套票',
  '整团': '整团',
  '小团': '小团',
  '政策信息': '政策信息',
  '政策': '政策',
  '政策管理': '政策管理',
  '数据预览': '数据预览',
  '供应商订单': '订单',
  '出票单报表': '出票单报表',
  '改签单报表': '改签单报表',
  '采购商订单': '订单',
  '退票单报表': '退票单报表',
  '交易记录': '交易记录',
  '订单支付页': '订单支付页',
  '改签支付': '改签支付',
  'Ticket Failed': '出票失败',
  '核账日期类型': '核账日期类型',
  '采购付款核账时间': '采购付款核账时间',
  '成功': '成功',
  '待处理': '待处理',
  '等待系统支付': '等待系统支付',
  '等待人工支付': '等待人工支付',
  '采购中': '采购中',
  '采购完成': '采购完成',
  '采购失败': '采购失败',
  '刷票中': '刷票中',
  '刷票成功': '刷票成功',
  '刷票失败': '刷票失败',
  '补位中': '补位中',
  '补位成功': '补位成功',
  '补位失败': '补位失败',
  '待申诉': '待申诉',
  '申诉中': '申诉中',
  '申诉成功': '申诉成功',
  '申诉失败': '申诉失败',
  '赌航变': '赌航变',
  '赌航变成功': '赌航变成功',
  '赌航变失败': '赌航变失败',
  '已降舱': '已降舱',
  '支付超时取消': '支付超时取消',
  '拦截出票取消': '拦截出票取消',
  '未出票退款取消': '未出票退款取消',
  '人工取消': '人工取消',
  '已改签': '已改签',
  '拦截出票中': '拦截出票中',
  '拦截出票失败': '拦截出票失败',
  '未出票退款已采购': '未出票退款已采购',
  '回填失败': '回填失败',
  '驳回取消': '驳回取消',
  '异步出票中': '异步出票中',
  '异步占座中': '异步占座中',
  '异步支付中': '异步支付中',
  '我的锁单': '我的锁单',
  '系统锁单': '系统锁单',
  '未锁单': '未锁单',
  '等待座位确认': '等待座位确认',
  '待支付': '待支付',
  '待出票': '待出票',
  '出票中': '出票中',
  '出票失败': '出票失败',
  '测试商家': '测试商家',
  '联程': '联程',
  '多程': '多程',
  '点击展开全部': '点击展开全部',
  '收起': '收起',
  '核账日期类型不为空': '核账日期类型不为空',
  '币种': '币种',
  '人民币': 'CNY-人民币',
  '马币': 'MYR-马币',
  '美元': 'USD-美元',
  '新加坡元': 'SGD-新加坡元',
  '印尼盾': 'IDR-印尼盾',
  '请选择币种': '请选择币种',
  '更换币种成功': '更换币种成功',
  '去程': '去程',
  '返程': '返程',
  '中转': '中转',
  '未查询到': '未查询到',
  '未开通': '未开通',
  '可用余额不足': '可用余额不足',
  '汇率': '汇率',
  '汇率表': '汇率表',
  '关闭': '关闭',
  '机票预订': '首页',
  '供应出票单查询': '出票单查询',
  '采购出票单查询': '出票单查询',
  '去支付': '支付',
  '国际机票查询': '国际机票查询',
  '出票单详情': '出票单详情',
  '国际机票预订': '首页',
  '订单管理': '订单管理',
  '调价规则': '调价规则',
  '低价看板': '低价看板',
  '联系我们': '联系我们',
  'Coffee And Meeting': '期待与您共饮一杯咖啡，或安排一次线上会谈',
  'Contact Us For Form': '如果您有任何问题，请随时与我们联系，您也可以使用下面的表格联系我们',
  'SUBMIT FORM': '提交',
  'Operating Hours': '营业时间',
  'Email': '邮箱',
  'WhatsApp': '联系我们',
  'Name': '姓名',
  'Your Message': '您的留言信息',
  'Type Of Enquiry': '问题类型',
  '北京': '北京',
  '巴黎': '巴黎',
  '东京': '东京',
  '首尔': '首尔',
  '纽约': '纽约',
  '香港': '中国香港',
  '中国香港': '中国香港',
  '中国澳门': '中国澳门',
  '深圳': '深圳',
  '广州': '广州',
  '上海': '上海',
  '阿伯丁': '阿伯丁',
  '阿布贾': '阿布贾',
  '阿比让': '阿比让',
  '阿布扎比': '阿布扎比',
  '爱丁堡': '爱丁堡',
  '阿德莱德': '阿德莱德',
  '埃德蒙顿': '埃德蒙顿',
  '阿尔及尔': '阿尔及尔',
  '阿尔山': '阿尔山',
  '阿瓜迪亚': '阿瓜迪亚',
  '艾哈迈达巴德': '艾哈迈达巴德',
  '安康': '安康',
  '阿克拉': '阿克拉',
  '奥克兰': '奥克兰',
  '安克雷奇': '安克雷奇',
  '阿克苏': '阿克苏',
  '埃克塞特': '埃克塞特',
  '阿里': '阿里',
  '奥兰多': '奥兰多',
  '阿拉尔': '阿拉尔',
  '阿拉木图': '阿拉木图',
  '阿拉善盟': '阿拉善盟',
  '阿勒泰': '阿勒泰',
  '安曼': '安曼',
  '埃默拉尔德': '埃默拉尔德',
  '阿姆利则': '阿姆利则',
  '阿姆斯特丹': '阿姆斯特丹',
  '阿皮亚': '阿皮亚',
  '安庆': '安庆',
  '鞍山': '鞍山',
  '安顺': '安顺',
  '奥什': '奥什',
  '阿什哈巴德': '阿什哈巴德',
  '奥斯陆': '奥斯陆',
  '奥斯汀': '奥斯汀',
  '安特卫普': '安特卫普',
  '安阳': '安阳',
  '博鳌': '博鳌',
  '蚌埠': '蚌埠',
  '槟城': '槟城',
  '保定': '保定',
  '班达伯格': '班达伯格',
  '布达佩斯': '布达佩斯',
  '波尔多': '波尔多',
  '贝尔法斯特': '贝尔法斯特',
  '贝尔格莱德': '贝尔格莱德',
  '伯恩茅斯': '伯恩茅斯',
  '布尔诺': '布尔诺',
  '波尔图': '波尔图',
  '布法罗': '布法罗',
  '波哥大': '波哥大',
  '巴格多格拉': '巴格多格拉',
  '北海': '北海',
  '宝鸡': '宝鸡',
  '毕节': '毕节',
  '班吉': '班吉',
  '班加罗尔': '班加罗尔',
  '布加勒斯特': '布加勒斯特',
  '北九州': '北九州',
  '巴库': '巴库',
  '别克斯': '别克斯',
  '巴林': '巴林',
  '巴里': '巴里',
  '柏林': '柏林',
  '博乐': '博乐',
  '巴厘巴板': '巴厘巴板',
  '布拉柴维尔': '布拉柴维尔',
  '巴罗达': '巴罗达',
  '布莱顿': '布莱顿',
  '巴厘岛': '巴厘岛',
  '布拉格': '布拉格',
  '不来梅': '不来梅',
  '博洛尼亚': '博洛尼亚',
  '布里斯班': '布里斯班',
  '布鲁塞尔': '布鲁塞尔',
  '布里斯托尔': '布里斯托尔',
  '贝鲁特': '贝鲁特',
  '巴伦西亚': '巴伦西亚',
  '伯明翰': '伯明翰',
  '巴马科': '巴马科',
  '巴拿马城': '巴拿马城',
  '博帕尔': '博帕尔',
  '百色': '百色',
  '保山': '保山',
  '比绍': '比绍',
  '比萨': '比萨',
  '巴斯': '巴斯',
  '波士顿': '波士顿',
  '巴塞尔巴登': '巴塞尔巴登',
  '比什凯克': '比什凯克',
  '巴塞罗那': '巴塞罗那',
  '包头': '包头',
  '波特兰': '波特兰',
  '巴特那': '巴特那',
  '芭提雅': '芭提雅',
  '本溪': '本溪',
  '巴亚尔塔港': '巴亚尔塔港',
  '巴彦淖尔': '巴彦淖尔',
  '布宜诺斯艾利斯': '布宜诺斯艾利斯',
  '滨州': '滨州',
  '亳州': '亳州',
  '巴中': '巴中',
  '博兹曼': '博兹曼',
  '赤壁': '赤壁',
  '茨城': '茨城',
  '昌都': '昌都',
  '承德': '承德',
  '常德': '常德',
  '成都': '成都',
  '昌迪加尔': '昌迪加尔',
  '赤峰': '赤峰',
  '冲绳': '冲绳',
  '楚雄': '楚雄',
  '朝阳': '朝阳',
  '沧源': '沧源',
  '滁州': '滁州',
  '潮州': '潮州',
  '常州': '常州',
  '沧州': '沧州',
  '池州': '池州',
  '郴州': '郴州',
  '大安': '大安',
  '杜阿拉': '杜阿拉',
  '德班': '德班',
  '迪拜': '迪拜',
  '大阪': '大阪',
  '都柏林': '都柏林',
  '第比利斯': '第比利斯',
  '稻城': '稻城',
  '丹东': '丹东',
  '达尔文': '达尔文',
  '丹佛': '丹佛',
  '东莞': '东莞',
  '敦煌': '敦煌',
  '多哈': '多哈',
  '敦化': '敦化',
  '德黑兰': '德黑兰',
  '达卡': '达卡',
  '达喀尔': '达喀尔',
  '德里': '德里',
  '大连': '大连',
  '大理': '大理',
  '都灵': '都灵',
  '多伦多': '多伦多',
  '德令哈': '德令哈',
  '德勒斯登': '德勒斯登',
  '达累斯萨拉姆': '达累斯萨拉姆',
  '达拉斯-沃斯堡': '达拉斯-沃斯堡',
  '达曼': '达曼',
  '达尼丁': '达尼丁',
  '迪庆': '迪庆',
  '大庆': '大庆',
  '大邱': '大邱',
  '杜尚别': '杜尚别',
  '杜塞尔多夫': '杜塞尔多夫',
  '大石桥': '大石桥',
  '大同': '大同',
  '底特律': '底特律',
  '德兴': '德兴',
  '德阳': '德阳',
  '东营': '东营',
  '都匀': '都匀',
  '达州': '达州',
  '儋州': '儋州',
  '德州': '德州',
  '恩德培': '恩德培',
  '鄂尔多斯': '鄂尔多斯',
  '恩贾梅纳': '恩贾梅纳',
  '额济纳旗': '额济纳旗',
  '二连浩特': '二连浩特',
  '恩施': '恩施',
  '鄂州': '鄂州',
  '费城': '费城',
  '防城港': '防城港',
  '福岛': '福岛',
  '福鼎': '福鼎',
  '福冈': '福冈',
  '富国岛': '富国岛',
  '奉化': '奉化',
  '凤凰城': '凤凰城',
  '费里敦': '费里敦',
  '符拉迪沃斯托克': '符拉迪沃斯托克',
  '法兰克福': '法兰克福',
  '佛罗伦萨': '佛罗伦萨',
  '法罗群岛': '法罗群岛',
  '弗雷斯诺': '弗雷斯诺',
  '福清': '福清',
  '佛山': '佛山',
  '釜山': '釜山',
  '富山': '富山',
  '阜新': '阜新',
  '阜阳': '阜阳',
  '抚远': '抚远',
  '富蕴': '富蕴',
  '福州': '福州',
  '抚州': '抚州',
  '广安': '广安',
  '哥本哈根': '哥本哈根',
  '关岛': '关岛',
  '广岛': '广岛',
  '关丹': '关丹',
  '哥德堡': '哥德堡',
  '哥打巴鲁': '哥打巴鲁',
  '哥打基纳巴卢': '哥打基纳巴卢',
  '瓜达拉哈拉': '瓜达拉哈拉',
  '格尔木': '格尔木',
  '贵港': '贵港',
  '广汉': '广汉',
  '古晋': '古晋',
  '果洛': '果洛',
  '桂林': '桂林',
  '哥伦布': '哥伦布',
  '格拉茨': '格拉茨',
  '瓜拉丁加奴': '瓜拉丁加奴',
  '格莱斯顿': '格莱斯顿',
  '格拉斯哥': '格拉斯哥',
  '桂平': '桂平',
  '冈山': '冈山',
  '古瓦哈蒂': '古瓦哈蒂',
  '高邮': '高邮',
  '广元': '广元',
  '固原': '固原',
  '贵阳': '贵阳',
  '瓜亚基尔': '瓜亚基尔',
  '甘孜': '甘孜',
  '赣州': '赣州',
  '光州': '光州',
  '淮安': '淮安',
  '汉堡': '汉堡',
  '鹤壁': '鹤壁',
  '淮北': '淮北',
  '哈巴罗夫斯克': '哈巴罗夫斯克',
  '哈博罗内': '哈博罗内',
  '霍巴特': '霍巴特',
  '汉川': '汉川',
  '河池': '河池',
  '海参崴': '海参崴',
  '邯郸': '邯郸',
  '海得拉巴': '海得拉巴',
  '哈尔滨': '哈尔滨',
  '赫尔辛基': '赫尔辛基',
  '合肥': '合肥',
  '黄冈': '黄冈',
  '黑河': '黑河',
  '怀化': '怀化',
  '呼和浩特': '呼和浩特',
  '皇后镇': '皇后镇',
  '黑角': '黑角',
  '黄金海岸': '黄金海岸',
  '海口': '海口',
  '哈科特港': '哈科特港',
  '葫芦岛': '葫芦岛',
  '惠灵顿': '惠灵顿',
  '海拉尔': '海拉尔',
  '哈里法克斯': '哈里法克斯',
  '哈拉雷': '哈拉雷',
  '哈密': '哈密',
  '海曼岛': '海曼岛',
  '哈密尔顿': '哈密尔顿',
  '汉密尔顿岛': '汉密尔顿岛',
  '海宁': '海宁',
  '河内': '河内',
  '淮南': '淮南',
  '火奴鲁鲁': '火奴鲁鲁',
  '汉诺威': '汉诺威',
  '黄石': '黄石',
  '衡水': '衡水',
  '黄山': '黄山',
  '华沙': '华沙',
  '华盛顿': '华盛顿',
  '和田': '和田',
  '哈特福德': '哈特福德',
  '红原': '红原',
  '海阳': '海阳',
  '衡阳': '衡阳',
  '华阴': '华阴',
  '杭州': '杭州',
  '惠州': '惠州',
  '菏泽': '菏泽',
  '汉中': '汉中',
  '贺州': '贺州',
  '湖州': '湖州',
  '胡占德': '胡占德',
  '胡志明市': '胡志明市',
  '吉安': '吉安',
  '金边': '金边',
  '贾巴尔普尔': '贾巴尔普尔',
  '吉布提': '吉布提',
  '金昌': '金昌',
  '晋城': '晋城',
  '吉达': '吉达',
  '基多': '基多',
  '基督城': '基督城',
  '加的夫': '加的夫',
  '吉大港': '吉大港',
  '加德满都': '加德满都',
  '景德镇': '景德镇',
  '杰尔': '杰尔',
  '加尔各答': '加尔各答',
  '基辅': '基辅',
  '静冈': '静冈',
  '巨港': '巨港',
  '加格达奇': '加格达奇',
  '井冈山': '井冈山',
  '金华': '金华',
  '景洪': '景洪',
  '九江': '九江',
  '晋江': '晋江',
  '基加利': '基加利',
  '旧金山': '旧金山',
  '杰克逊维尔': '杰克逊维尔',
  '吉林': '吉林',
  '加拉加斯': '加拉加斯',
  '基隆拿': '基隆拿',
  '吉隆坡': '吉隆坡',
  '甲米': '甲米',
  '佳木斯': '佳木斯',
  '济宁': '济宁',
  '金奈': '金奈',
  '济南': '济南',
  '建瓯': '建瓯',
  '剑桥': '剑桥',
  '酒泉': '酒泉',
  '句容': '句容',
  '金斯顿': '金斯顿',
  '建三江': '建三江',
  '金沙萨': '金沙萨',
  '焦特布尔': '焦特布尔',
  '鸡西': '鸡西',
  '嘉兴': '嘉兴',
  '江油': '江油',
  '揭阳潮汕': '揭阳潮汕',
  '嘉峪关': '嘉峪关',
  '济州': '济州',
  '晋州': '晋州',
  '锦州': '锦州',
  '晋中': '晋中',
  '焦作': '焦作',
  '荆州': '荆州',
  '九寨沟': '九寨沟',
  '喀布尔': '喀布尔',
  '库车': '库车',
  '康定': '康定',
  '卡迪夫': '卡迪夫',
  '卡尔加里': '卡尔加里',
  '库尔勒': '库尔勒',
  '凯恩斯': '凯恩斯',
  '开封': '开封',
  '科夫斯港': '科夫斯港',
  '卡胡卢伊': '卡胡卢伊',
  '克久拉霍': '克久拉霍',
  '坎昆': '坎昆',
  '科克': '科克',
  '开罗': '开罗',
  '科隆': '科隆',
  '凯里': '凯里',
  '库莱布拉': '库莱布拉',
  '克利夫兰': '克利夫兰',
  '克拉根福': '克拉根福',
  '克拉克': '克拉克',
  '克拉科夫': '克拉科夫',
  '卡利刻特': '卡利刻特',
  '克莱蒙费朗': '克莱蒙费朗',
  '克拉玛依': '克拉玛依',
  '科伦坡': '科伦坡',
  '库拉索': '库拉索',
  '昆明': '昆明',
  '卡诺': '卡诺',
  '科纳克里': '科纳克里',
  '喀纳斯': '喀纳斯',
  '开普敦': '开普敦',
  '堪培拉': '堪培拉',
  '科钦': '科钦',
  '喀什': '喀什',
  '昆山': '昆山',
  '卡萨布兰卡': '卡萨布兰卡',
  '奎屯': '奎屯',
  '喀土穆': '喀土穆',
  '科托努': '科托努',
  '卡塔尼亚': '卡塔尼亚',
  '考文垂': '考文垂',
  '科威特': '科威特',
  '六安': '六安',
  '里昂': '里昂',
  '罗安达': '罗安达',
  '来宾': '来宾',
  '荔波': '荔波',
  '赖布尔': '赖布尔',
  '卢布尔亚那': '卢布尔亚那',
  '拉巴特': '拉巴特',
  '利伯维尔': '利伯维尔',
  '莱比锡': '莱比锡',
  '列城': '列城',
  '澜沧': '澜沧',
  '临沧': '临沧',
  '林茨': '林茨',
  '娄底': '娄底',
  '伦敦': '伦敦',
  '罗德岱堡': '罗德岱堡',
  '伦敦(加拿大）': '伦敦(加拿大）',
  '鹿儿岛': '鹿儿岛',
  '廊坊': '廊坊',
  '临汾': '临汾',
  '泸沽湖': '泸沽湖',
  '拉各斯': '拉各斯',
  '临海': '临海',
  '漯河': '漯河',
  '拉合尔': '拉合尔',
  '丽江': '丽江',
  '里加': '里加',
  '雷焦卡拉布里亚': '雷焦卡拉布里亚',
  '里贾纳': '里贾纳',
  '罗克汉普顿': '罗克汉普顿',
  '勒克瑙': '勒克瑙',
  '兰卡威': '兰卡威',
  '雷克雅未克': '雷克雅未克',
  '吕梁': '吕梁',
  '罗利': '罗利',
  '拉罗汤加': '拉罗汤加',
  '洛美': '洛美',
  '利马': '利马',
  '罗马': '罗马',
  '拉梅齐亚': '拉梅齐亚',
  '陇南': '陇南',
  '拉纳卡': '拉纳卡',
  '黎平': '黎平',
  '六盘水': '六盘水',
  '乐清': '乐清',
  '兰契': '兰契',
  '列日': '列日',
  '乐山': '乐山',
  '拉萨': '拉萨',
  '丽水': '丽水',
  '里斯本': '里斯本',
  '卢森堡': '卢森堡',
  '洛杉矶': '洛杉矶',
  '卢萨卡': '卢萨卡',
  '里士满': '里士满',
  '莱斯特': '莱斯特',
  '拉斯维加斯': '拉斯维加斯',
  '莱阳': '莱阳',
  '龙岩': '龙岩',
  '辽阳': '辽阳',
  '洛阳': '洛阳',
  '临沂': '临沂',
  '溧阳': '溧阳',
  '耒阳': '耒阳',
  '利雅得': '利雅得',
  '里雅恩姆卡拉': '里雅恩姆卡拉',
  '连云港': '连云港',
  '里约热内卢': '里约热内卢',
  '利兹': '利兹',
  '兰州': '兰州',
  '柳州': '柳州',
  '泸州': '泸州',
  '林芝': '林芝',
  '迈阿密': '迈阿密',
  '蒙彼利埃': '蒙彼利埃',
  '麻城': '麻城',
  '曼彻斯特': '曼彻斯特',
  '梅德福': '梅德福',
  '牡丹江': '牡丹江',
  '马德里': '马德里',
  '麦地那': '麦地那',
  '墨尔本': '墨尔本',
  '米尔迪拉': '米尔迪拉',
  '莫尔斯比港': '莫尔斯比港',
  '密尔沃基': '密尔沃基',
  '孟菲斯': '孟菲斯',
  '曼谷': '曼谷',
  '名古屋': '名古屋',
  '漠河': '漠河',
  '麦凯': '麦凯',
  '麦夸里港': '麦夸里港',
  '棉兰': '棉兰',
  '米兰': '米兰',
  '马累': '马累',
  '马拉博': '马拉博',
  '马拉加': '马拉加',
  '马六甲': '马六甲',
  '马拉喀什': '马拉喀什',
  '毛里求斯': '毛里求斯',
  '蒙罗维亚': '蒙罗维亚',
  '孟买': '孟买',
  '茂名': '茂名',
  '明尼阿波利斯': '明尼阿波利斯',
  '慕尼黑': '慕尼黑',
  '马尼拉': '马尼拉',
  '木浦': '木浦',
  '眉山': '眉山',
  '芒市': '芒市',
  '马赛': '马赛',
  '莫斯科': '莫斯科',
  '明斯克': '明斯克',
  '马斯喀特': '马斯喀特',
  '明斯特': '明斯特',
  '芒特艾萨': '芒特艾萨',
  '蒙特雷': '蒙特雷',
  '蒙特利尔': '蒙特利尔',
  '蒙特雷(墨西哥)': '蒙特雷(墨西哥)',
  '墨西哥城': '墨西哥城',
  '绵阳': '绵阳',
  '梅州': '梅州',
  '满洲里': '满洲里',
  '南安普顿': '南安普顿',
  '宁波': '宁波',
  '内比都': '内比都',
  '那不勒斯': '那不勒斯',
  '纽波特': '纽波特',
  '南昌': '南昌',
  '南充': '南充',
  '纳迪': '纳迪',
  '宁德': '宁德',
  '诺丁汉': '诺丁汉',
  '努尔苏丹（阿斯塔纳）': '努尔苏丹（阿斯塔纳）',
  '那格浦尔': '那格浦尔',
  '内江': '内江',
  '南京': '南京',
  '牛津': '牛津',
  '努库阿洛法': '努库阿洛法',
  '纽卡斯尔(澳大利亚)': '纽卡斯尔(澳大利亚)',
  '纽卡斯尔(英国)': '纽卡斯尔(英国)',
  '宁蒗': '宁蒗',
  '内罗毕': '内罗毕',
  '纽伦堡': '纽伦堡',
  '诺里奇': '诺里奇',
  '那拉提': '那拉提',
  '南宁': '南宁',
  '南平': '南平',
  '尼斯': '尼斯',
  '纳什维尔': '纳什维尔',
  '南通': '南通',
  '努瓦克肖特': '努瓦克肖特',
  '诺维奇': '诺维奇',
  '南阳': '南阳',
  '尼亚美': '尼亚美',
  '平度': '平度',
  '平顶山': '平顶山',
  '普洱': '普洱',
  '普吉': '普吉',
  '盘锦': '盘锦',
  '帕拉马里博': '帕拉马里博',
  '普利茅斯': '普利茅斯',
  '普罗瑟派恩': '普罗瑟派恩',
  '浦那': '浦那',
  '普宁': '普宁',
  '平壤': '平壤',
  '珀斯': '珀斯',
  '蓬塞': '蓬塞',
  '莆田': '莆田',
  '浦项': '浦项',
  '萍乡': '萍乡',
  '匹兹堡': '匹兹堡',
  '攀枝花': '攀枝花',
  '青岛': '青岛',
  '琼海': '琼海',
  '秦皇岛': '秦皇岛',
  '黔江': '黔江',
  '潜江': '潜江',
  '曲靖': '曲靖',
  '清莱': '清莱',
  '乞力马扎罗': '乞力马扎罗',
  '清迈': '清迈',
  '且末': '且末',
  '齐齐哈尔': '齐齐哈尔',
  '庆阳': '庆阳',
  '清远': '清远',
  '清州': '清州',
  '衢州': '衢州',
  '青州': '青州',
  '泉州': '泉州',
  '钦州': '钦州',
  '乔治王子城': '乔治王子城',
  '赫米特': '赫米特',
  '日喀则': '日喀则',
  '日内瓦': '日内瓦',
  '若羌': '若羌',
  '荣市': '荣市',
  '日照': '日照',
  '沙巴': '沙巴',
  '塞班': '塞班',
  '圣芭芭拉': '圣芭芭拉',
  '圣彼得堡': '圣彼得堡',
  '斯波坎': '斯波坎',
  '圣保罗': '圣保罗',
  '莎车': '莎车',
  '斯德哥尔摩': '斯德哥尔摩',
  '圣地亚哥(美国)': '圣地亚哥(美国)',
  '圣地亚哥(智利)': '圣地亚哥(智利)',
  '萨尔斯堡': '萨尔斯堡',
  '索非亚': '索非亚',
  '韶关': '韶关',
  '萨格勒布': '萨格勒布',
  '四会': '四会',
  '圣胡安': '圣胡安',
  '圣何塞': '圣何塞',
  '石河子': '石河子',
  '沙迦': '沙迦',
  '石家庄': '石家庄',
  '萨克拉门托': '萨克拉门托',
  '圣克鲁斯岛': '圣克鲁斯岛',
  '萨勒诺': '萨勒诺',
  '斯利那加': '斯利那加',
  '苏黎世': '苏黎世',
  '圣路易斯': '圣路易斯',
  '三明': '三明',
  '厦门': '厦门',
  '苏梅岛': '苏梅岛',
  '三门峡': '三门峡',
  '萨那': '萨那',
  '神农架': '神农架',
  '圣珀尔滕': '圣珀尔滕',
  '商丘': '商丘',
  '宿迁': '宿迁',
  '上饶': '上饶',
  '松山': '松山',
  '泗水': '泗水',
  '汕头': '汕头',
  '斯图加特': '斯图加特',
  '司徒加特': '司徒加特',
  '斯特拉斯堡': '斯特拉斯堡',
  '圣托马斯': '圣托马斯',
  '宿务': '宿务',
  '汕尾': '汕尾',
  '斯温顿': '斯温顿',
  '斯旺西': '斯旺西',
  '绍兴': '绍兴',
  '沈阳': '沈阳',
  '三亚': '三亚',
  '十堰': '十堰',
  '邵阳': '邵阳',
  '松原': '松原',
  '朔州': '朔州',
  '随州': '随州',
  '苏州': '苏州',
  '宿州': '宿州',
  '泰安': '泰安',
  '廷布': '廷布',
  '太仓': '太仓',
  '塔城': '塔城',
  '腾冲': '腾冲',
  '通化': '通化',
  '天津': '天津',
  '通辽': '通辽',
  '塔林': '塔林',
  '铜陵': '铜陵',
  '铁岭': '铁岭',
  '吐鲁番': '吐鲁番',
  '特里凡得琅': '特里凡得琅',
  '特拉维夫': '特拉维夫',
  '图卢兹': '图卢兹',
  '天门': '天门',
  '图木舒克': '图木舒克',
  '塔那那利佛': '塔那那利佛',
  '突尼斯': '突尼斯',
  '坦帕': '坦帕',
  '铜仁': '铜仁',
  '台山': '台山',
  '天水': '天水',
  '唐山': '唐山',
  '塔什干': '塔什干',
  '塔什库尔干': '塔什库尔干',
  '汤斯维尔': '汤斯维尔',
  '太原': '太原',
  '台州': '台州',
  '泰州': '泰州',
  '文昌': '文昌',
  '乌代布尔': '乌代布尔',
  '温得和克': '温得和克',
  '五大连池': '五大连池',
  '维尔纽斯': '维尔纽斯',
  '潍坊': '潍坊',
  '温哥华': '温哥华',
  '威海': '威海',
  '芜湖': '芜湖',
  '乌海': '乌海',
  '武汉': '武汉',
  '瓦加杜古': '瓦加杜古',
  '温岭': '温岭',
  '乌兰察布': '乌兰察布',
  '乌兰浩特': '乌兰浩特',
  '乌鲁木齐': '乌鲁木齐',
  '维罗纳': '维罗纳',
  '瓦拉纳西': '瓦拉纳西',
  '渭南': '渭南',
  '万宁': '万宁',
  '温尼伯': '温尼伯',
  '威尼斯': '威尼斯',
  '乌戎潘当': '乌戎潘当',
  '文山': '文山',
  '巫山': '巫山',
  '渥太华': '渥太华',
  '万象': '万象',
  '无锡': '无锡',
  '万鸦老': '万鸦老',
  '维也纳': '维也纳',
  '武夷山': '武夷山',
  '温州': '温州',
  '梧州': '梧州',
  '万州': '万州',
  '吴忠': '吴忠',
  '西安': '西安',
  '新奥尔良': '新奥尔良',
  '许昌': '许昌',
  '西昌': '西昌',
  '宣城': '宣城',
  '锡尔赫特': '锡尔赫特',
  '岘港': '岘港',
  '孝感': '孝感',
  '夏河': '夏河',
  '新加坡': '新加坡',
  '暹粒': '暹粒',
  '锡林浩特': '锡林浩特',
  '夏洛特': '夏洛特',
  '咸宁': '咸宁',
  '悉尼': '悉尼',
  '西宁': '西宁',
  '小松': '小松',
  '西双版纳': '西双版纳',
  '休斯顿': '休斯顿',
  '仙台': '仙台',
  '湘潭': '湘潭',
  '仙桃': '仙桃',
  '新潟': '新潟',
  '新乡': '新乡',
  '新西伯利亚': '新西伯利亚',
  '辛辛那提': '辛辛那提',
  '兴义': '兴义',
  '信阳': '信阳',
  '襄阳': '襄阳',
  '新余': '新余',
  '西雅图': '西雅图',
  '忻州': '忻州',
  '徐州': '徐州',
  '延安': '延安',
  '雅安': '雅安',
  '宜宾': '宜宾',
  '银川': '银川',
  '伊春': '伊春',
  '运城': '运城',
  '宜春': '宜春',
  '宜昌': '宜昌',
  '盐城': '盐城',
  '雅典': '雅典',
  '印第安纳波利斯': '印第安纳波利斯',
  '亚的斯亚贝巴': '亚的斯亚贝巴',
  '伊尔库茨克': '伊尔库茨克',
  '云浮': '云浮',
  '仰光': '仰光',
  '盐湖城': '盐湖城',
  '约翰内斯堡': '约翰内斯堡',
  '阳江': '阳江',
  '延吉': '延吉',
  '雅加达': '雅加达',
  '营口': '营口',
  '榆林': '榆林',
  '玉林': '玉林',
  '伊宁': '伊宁',
  '蔚山': '蔚山',
  '玉树': '玉树',
  '伊斯兰堡': '伊斯兰堡',
  '伊斯坦布尔': '伊斯坦布尔',
  '鹰潭': '鹰潭',
  '烟台': '烟台',
  '于田': '于田',
  '亚特兰大': '亚特兰大',
  '义乌': '义乌',
  '雅温得': '雅温得',
  '宜兴': '宜兴',
  '玉溪': '玉溪',
  '岳阳': '岳阳',
  '永州': '永州',
  '芽庄': '芽庄',
  '扬州': '扬州',
  '伊兹密尔': '伊兹密尔',
  '朱巴': '朱巴',
  '淄博': '淄博',
  '长白山': '长白山',
  '长春': '长春',
  '中国高雄': '中国高雄',
  '中国金门': '中国金门',
  '台北': '台北',
  '中国台北': '中国台北',
  '中国台南': '中国台南',
  '中国台中': '中国台中',
  '札幌': '札幌',
  '珠海': '珠海',
  '湛江': '湛江',
  '镇江': '镇江',
  '芝加哥': '芝加哥',
  '张家界': '张家界',
  '张家口': '张家口',
  '周口': '周口',
  '扎兰屯': '扎兰屯',
  '驻马店': '驻马店',
  '斋浦尔': '斋浦尔',
  '重庆': '重庆',
  '长崎': '长崎',
  '肇庆': '肇庆',
  '长沙': '长沙',
  '中山': '中山',
  '舟山': '舟山',
  '昭苏': '昭苏',
  '昭通': '昭通',
  '中卫': '中卫',
  '张掖': '张掖',
  '资阳': '资阳',
  '遵义茅台': '遵义茅台',
  '遵义新舟': '遵义新舟',
  '郑州': '郑州',
  '长治': '长治',
  '株洲': '株洲',
  '枣庄': '枣庄',
  '涿州': '涿州',
  '漳州': '漳州',
  '热门城市（可直接选择城市或输入城市中文/拼音）': '热门城市（可直接选择城市或输入城市中文/拼音）',
  '热门': '热门',
  '输入中文/拼音/↑↓键选择': '输入中文/拼音/↑↓键选择',
  'ZIPAIR': 'ZIPAIR',
  '大溪地': '大溪地',
  '柳州白莲机场': '柳州白莲机场',
  '齐齐哈尔三家子机场': '齐齐哈尔三家子机场',
  '湛江机场': '湛江机场',
  '珠海三灶机场': '珠海三灶机场',
  '遵义机场': '遵义机场',
  '西双版纳机场': '西双版纳机场',
  '宁波栎社机场': '宁波栎社机场',
  '漠河机场': '漠河机场',
  '康定机场': '康定机场',
  '贵阳荔波机场': '贵阳荔波机场',
  '长白山机场': '长白山机场',
  '腾冲机场': '腾冲机场',
  '大庆机场': '大庆机场',
  '青海玉树机场': '青海玉树机场',
  '宁夏中卫机场': '宁夏中卫机场',
  '伊春林都机场': '伊春林都机场',
  '鸡西兴凯湖机场': '鸡西兴凯湖机场',
  '宁夏固原六盘山机场': '宁夏固原六盘山机场',
  '新疆吐鲁番机场': '新疆吐鲁番机场',
  '新疆博乐机场': '新疆博乐机场',
  '阿勒泰机场': '阿勒泰机场',
  '兴义机场': '兴义机场',
  '百色机场': '百色机场',
  '安康机场': '安康机场',
  '阿克苏机场': '阿克苏机场',
  '鞍山机场': '鞍山机场',
  '南京禄口机场': '南京禄口机场',
  '安庆天柱山机场': '安庆天柱山机场',
  '安顺黄果树机场': '安顺黄果树机场',
  '安阳北郊机场': '安阳北郊机场',
  '包头二里半机场': '包头二里半机场',
  '蚌埠机场': '蚌埠机场',
  '北海福成机场': '北海福成机场',
  '昌都邦达机场': '昌都邦达机场',
  '保山云端机场': '保山云端机场',
  '那拉提机场': '那拉提机场',
  '广州白云机场': '广州白云机场',
  '常德桃花源机场': '常德桃花源机场',
  '郑州新郑机场': '郑州新郑机场',
  '长春龙嘉机场': '长春龙嘉机场',
  '朝阳机场': '朝阳机场',
  '酒泉机场': '酒泉机场',
  '赤峰土城子机场': '赤峰土城子机场',
  '长治王村机场': '长治王村机场',
  '重庆江北机场': '重庆江北机场',
  '南宁吴圩机场': '南宁吴圩机场',
  '长海大长山岛机场': '长海大长山岛机场',
  '长沙黄花机场': '长沙黄花机场',
  '成都双流机场': '成都双流机场',
  '常州奔牛机场': '常州奔牛机场',
  '大同机场': '大同机场',
  '达县达川河市坝机场': '达县达川河市坝机场',
  '丹东浪头机场': '丹东浪头机场',
  '南阳姜营机场': '南阳姜营机场',
  '东莞机场': '东莞机场',
  '迪庆香格里拉机场': '迪庆香格里拉机场',
  '大连周水子机场': '大连周水子机场',
  '大理荒草坝机场': '大理荒草坝机场',
  '敦煌机场': '敦煌机场',
  '东营机场': '东营机场',
  '鄂尔多斯伊金霍洛机场': '鄂尔多斯伊金霍洛机场',
  '张家界大庸荷花机场': '张家界大庸荷花机场',
  '南通兴东机场': '南通兴东机场',
  '大足机场': '大足机场',
  '恩施许家坪机场': '恩施许家坪机场',
  '延安二十里铺机场': '延安二十里铺机场',
  '福州长乐机场': '福州长乐机场',
  '绥芬河机场': '绥芬河机场',
  '阜阳西关机场': '阜阳西关机场',
  '佛山机场': '佛山机场',
  '富蕴可可托海机场': '富蕴可可托海机场',
  '呼伦贝尔满洲里西郊机场': '呼伦贝尔满洲里西郊机场',
  '广汉机场': '广汉机场',
  '格尔木机场': '格尔木机场',
  '厦门高崎机场': '厦门高崎机场',
  '广元盘龙机场': '广元盘龙机场',
  '海口美兰机场': '海口美兰机场',
  '邯郸机场': '邯郸机场',
  '北京首都机场': '北京首都机场',
  '黑河机场': '黑河机场',
  '呼和浩特白塔机场': '呼和浩特白塔机场',
  '合肥新桥机场': '合肥新桥机场',
  '杭州萧山机场': '杭州萧山机场',
  '怀化芷江机场': '怀化芷江机场',
  '海拉尔东山机场': '海拉尔东山机场',
  '乌兰浩特依勒力特机场': '乌兰浩特依勒力特机场',
  '哈密机场': '哈密机场',
  '衡阳东江机场': '衡阳东江机场',
  '南竿机场': '南竿机场',
  '蓬莱机场': '蓬莱机场',
  '哈尔滨太平机场': '哈尔滨太平机场',
  '韶关机场': '韶关机场',
  '普陀山朱家尖机场': '普陀山朱家尖机场',
  '和田机场': '和田机场',
  '惠州惠东机场': '惠州惠东机场',
  '黄岩路桥机场': '黄岩路桥机场',
  '汉中西关机场': '汉中西关机场',
  '黎平机场': '黎平机场',
  '银川河东机场': '银川河东机场',
  '上海浦东机场': '上海浦东机场',
  '且末机场': '且末机场',
  '庆阳西峰镇机场': '庆阳西峰镇机场',
  '景德镇罗家机场': '景德镇罗家机场',
  '嘉峪关机场': '嘉峪关机场',
  '井冈山机场': '井冈山机场',
  '吉林二台子机场': '吉林二台子机场',
  '九江庐山机场': '九江庐山机场',
  '攀枝花保安营机场': '攀枝花保安营机场',
  '晋江机场': '晋江机场',
  '佳木斯东郊机场': '佳木斯东郊机场',
  '济宁机场': '济宁机场',
  '锦州小岭子机场': '锦州小岭子机场',
  '衢州机场': '衢州机场',
  '九寨沟黄龙机场': '九寨沟黄龙机场',
  '库车机场': '库车机场',
  '喀什机场': '喀什机场',
  '南昌昌北机场': '南昌昌北机场',
  '喀纳斯机场': '喀纳斯机场',
  '昆明长水机场': '昆明长水机场',
  '吉安机场': '吉安机场',
  '赣州黄金机场': '赣州黄金机场',
  '库尔勒机场': '库尔勒机场',
  '克拉玛依机场': '克拉玛依机场',
  '贵阳龙洞堡机场': '贵阳龙洞堡机场',
  '桂林两江机场': '桂林两江机场',
  '连城机场': '连城机场',
  '光化机场': '光化机场',
  '如皋机场': '如皋机场',
  '兰州中川机场': '兰州中川机场',
  '梁平机场': '梁平机场',
  '丽江三义机场': '丽江三义机场',
  '永州零陵机场': '永州零陵机场',
  '临沧机场': '临沧机场',
  '德宏芒市机场': '德宏芒市机场',
  '庐山机场': '庐山机场',
  '拉萨贡嘎机场': '拉萨贡嘎机场',
  '林西机场': '林西机场',
  '洛阳北郊机场': '洛阳北郊机场',
  '上海虹桥机场': '上海虹桥机场',
  '连云港白塔埠机场': '连云港白塔埠机场',
  '临沂沭埠岭机场': '临沂沭埠岭机场',
  '三女河机场': '三女河机场',
  '淮安机场': '淮安机场',
  '二连浩特赛乌苏机场': '二连浩特赛乌苏机场',
  '沈阳桃仙机场': '沈阳桃仙机场',
  '山海关机场': '山海关机场',
  '秦皇岛机场': '秦皇岛机场',
  '荆州沙市机场': '荆州沙市机场',
  '泸州云龙机场': '泸州云龙机场',
  '西安咸阳机场': '西安咸阳机场',
  '石家庄正定机场': '石家庄正定机场',
  '揭阳潮汕机场': '揭阳潮汕机场',
  '鄯善机场': '鄯善机场',
  '思茅机场': '思茅机场',
  '三亚凤凰机场': '三亚凤凰机场',
  '儋州西庆机场': '儋州西庆机场',
  '苏州机场': '苏州机场',
  '深圳宝安机场': '深圳宝安机场',
  '青岛流亭机场': '青岛流亭机场',
  '林芝机场': '林芝机场',
  '塔城机场': '塔城机场',
  '铜仁大兴机场': '铜仁大兴机场',
  '通辽机场': '通辽机场',
  '济南遥墙机场': '济南遥墙机场',
  '通化机场': '通化机场',
  '天津滨海机场': '天津滨海机场',
  '黄山屯溪机场': '黄山屯溪机场',
  '太原武宿机场': '太原武宿机场',
  '乌鲁木齐地窝堡机场': '乌鲁木齐地窝堡机场',
  '牡丹江海浪机场': '牡丹江海浪机场',
  '榆林西沙机场': '榆林西沙机场',
  '潍坊机场': '潍坊机场',
  '威海文登机场': '威海文登机场',
  '芜湖机场': '芜湖机场',
  '文山普者黑机场': '文山普者黑机场',
  '温州永强机场': '温州永强机场',
  '乌海机场': '乌海机场',
  '武汉天河机场': '武汉天河机场',
  '绵阳南郊机场': '绵阳南郊机场',
  '武夷山机场': '武夷山机场',
  '无锡硕放机场': '无锡硕放机场',
  '梧州长洲岛机场': '梧州长洲岛机场',
  '万州五桥机场': '万州五桥机场',
  '黄石机场': '黄石机场',
  '兴城机场': '兴城机场',
  '襄樊刘集机场': '襄樊刘集机场',
  '西昌青山机场': '西昌青山机场',
  '锡林浩特机场': '锡林浩特机场',
  '兴宁机场': '兴宁机场',
  '梅县机场': '梅县机场',
  '西宁曹家堡机场': '西宁曹家堡机场',
  '邢台机场': '邢台机场',
  '徐州观音机场': '徐州观音机场',
  '宜宾菜坝机场': '宜宾菜坝机场',
  '运城关公机场': '运城关公机场',
  '南充高坪机场': '南充高坪机场',
  '宜昌三峡机场': '宜昌三峡机场',
  '伊宁机场': '伊宁机场',
  '义乌机场': '义乌机场',
  '依兰机场': '依兰机场',
  '延吉朝阳川机场': '延吉朝阳川机场',
  '烟台莱山机场': '烟台莱山机场',
  '盐城南洋机场': '盐城南洋机场',
  '元谋机场': '元谋机场',
  '北京南苑机场': '北京南苑机场',
  '昭通机场': '昭通机场',
  '日喀则和平机场': '日喀则和平机场',
  '张掖机场': '张掖机场',
  '天吉泰机场': '天吉泰机场',
  '凯里黄平机场': '凯里黄平机场',
  '营口机场': '营口机场',
  '明月山机场': '明月山机场',
  '重庆黔江舟白机场': '重庆黔江舟白机场',
  '琼海博鳌机场': '琼海博鳌机场',
  '十堰武当山机场': '十堰武当山机场',
  '临汾乔李机场': '临汾乔李机场',
  '扬州泰州机场': '扬州泰州机场',
  '吕梁机场': '吕梁机场',
  '金昌金川机场': '金昌金川机场',
  '巴中恩阳机场': '巴中恩阳机场',
  '北京大兴机场': '北京大兴机场',
  '澜沧景迈机场': '澜沧景迈机场',
  '广州白云国际机场': '广州白云国际机场',
  '北京首都国际机场': '北京首都国际机场',
  '北京大兴国际机场': '北京大兴国际机场',
  '深圳宝安国际机场': '深圳宝安国际机场',
  '阿伯丁机场': '阿伯丁机场',
  '阿布贾国际机场': '阿布贾国际机场',
  '阿比让机场': '阿比让机场',
  '阿布扎比国际机场': '阿布扎比国际机场',
  '爱丁堡机场': '爱丁堡机场',
  '阿德莱德机场': '阿德莱德机场',
  '埃德蒙顿国际机场': '埃德蒙顿国际机场',
  '阿尔及尔胡阿里· 布迈丁机场': '阿尔及尔胡阿里· 布迈丁机场',
  '阿尔山伊尔施机场': '阿尔山伊尔施机场',
  '拉斐尔埃尔南德斯机场': '拉斐尔埃尔南德斯机场',
  '艾哈迈达巴德国际机场': '艾哈迈达巴德国际机场',
  '安康富强机场': '安康富强机场',
  '阿克拉科托卡国际机场': '阿克拉科托卡国际机场',
  '奥克兰机场': '奥克兰机场',
  '安克雷奇国际机场': '安克雷奇国际机场',
  '阿里昆莎机场': '阿里昆莎机场',
  '奥兰多国际机场': '奥兰多国际机场',
  '阿拉尔塔里木机场': '阿拉尔塔里木机场',
  '阿拉木图国际机场': '阿拉木图国际机场',
  '阿拉善右旗巴丹吉林机场': '阿拉善右旗巴丹吉林机场',
  '阿拉善左旗巴彦浩特机场': '阿拉善左旗巴彦浩特机场',
  '安曼阿莉娅王后国际机场': '安曼阿莉娅王后国际机场',
  '埃默拉尔德机场': '埃默拉尔德机场',
  '阿姆利则拉贾桑西机场': '阿姆利则拉贾桑西机场',
  '阿姆斯特丹史基浦机场': '阿姆斯特丹史基浦机场',
  '阿皮亚法莱奥洛国际机场': '阿皮亚法莱奥洛国际机场',
  '鞍山腾鳌机场': '鞍山腾鳌机场',
  '奥什机场': '奥什机场',
  '阿什哈巴德国际机场': '阿什哈巴德国际机场',
  '奥斯陆机场': '奥斯陆机场',
  '奥斯汀国际机场': '奥斯汀国际机场',
  '琼海博鳌国际机场': '琼海博鳌国际机场',
  '槟城机场': '槟城机场',
  '班达伯格机场': '班达伯格机场',
  '布达佩斯费里海吉国际机场': '布达佩斯费里海吉国际机场',
  '波尔多机场': '波尔多机场',
  '乔治· 贝斯特贝尔法斯特城市机场': '乔治· 贝斯特贝尔法斯特城市机场',
  '贝尔格莱德尼古拉· 特斯拉机场': '贝尔格莱德尼古拉· 特斯拉机场',
  '波尔图机场': '波尔图机场',
  '布法罗尼加拉机场': '布法罗尼加拉机场',
  '埃尔多拉多国际机场': '埃尔多拉多国际机场',
  '巴格多格拉机场': '巴格多格拉机场',
  '毕节飞雄机场': '毕节飞雄机场',
  '班吉机场': '班吉机场',
  '班加罗尔坎皮高达国际机场': '班加罗尔坎皮高达国际机场',
  '布加勒斯特亨利科安达机场': '布加勒斯特亨利科安达机场',
  '北九州机场': '北九州机场',
  '巴库盖达尔· 阿利耶夫国际机场': '巴库盖达尔· 阿利耶夫国际机场',
  '安东尼奥里维拉罗德里格斯机场': '安东尼奥里维拉罗德里格斯机场',
  '巴林国际机场': '巴林国际机场',
  '巴里国际机场': '巴里国际机场',
  '柏林泰格尔机场': '柏林泰格尔机场',
  '柏林舍内菲尔德机场': '柏林舍内菲尔德机场',
  '勃兰登堡机场': '勃兰登堡机场',
  '博乐阿拉山口机场': '博乐阿拉山口机场',
  '巴黎奥利机场': '巴黎奥利机场',
  '巴黎戴高乐机场': '巴黎戴高乐机场',
  '巴厘巴板塞平甘机场': '巴厘巴板塞平甘机场',
  '马亚马亚机场': '马亚马亚机场',
  '巴罗达机场': '巴罗达机场',
  '巴厘岛登巴萨努拉· 莱伊国际机场': '巴厘岛登巴萨努拉· 莱伊国际机场',
  '布拉格机场': '布拉格机场',
  '不来梅机场': '不来梅机场',
  '博洛尼亚 - 博格潘尼格尔机场': '博洛尼亚 - 博格潘尼格尔机场',
  '布里斯班机场': '布里斯班机场',
  '布鲁塞尔机场': '布鲁塞尔机场',
  '布里斯托尔机场': '布里斯托尔机场',
  '贝鲁特拉菲克· 哈里里国际机场': '贝鲁特拉菲克· 哈里里国际机场',
  '巴伦西亚机场': '巴伦西亚机场',
  '伯明翰机场': '伯明翰机场',
  '巴马科塞诺国际机场': '巴马科塞诺国际机场',
  '巴拿马城托库门国际机场': '巴拿马城托库门国际机场',
  '博帕尔机场': '博帕尔机场',
  '百色巴马机场': '百色巴马机场',
  '保山机场': '保山机场',
  '奥斯瓦尔多 - 维埃拉机场': '奥斯瓦尔多 - 维埃拉机场',
  '比萨伽利略· 伽利莱机场': '比萨伽利略· 伽利莱机场',
  '波士顿洛根国际机场': '波士顿洛根国际机场',
  '比什凯克马纳斯国际机场': '比什凯克马纳斯国际机场',
  '巴塞罗那机场': '巴塞罗那机场',
  '包头东河机场': '包头东河机场',
  '波特兰机场': '波特兰机场',
  '巴特那机场': '巴特那机场',
  '芭提雅乌塔堡机场': '芭提雅乌塔堡机场',
  '巴亚尔塔港机场': '巴亚尔塔港机场',
  '巴彦淖尔天吉泰机场': '巴彦淖尔天吉泰机场',
  '豪尔赫纽伯里机场': '豪尔赫纽伯里机场',
  '布宜诺斯艾利斯埃塞萨国际机场': '布宜诺斯艾利斯埃塞萨国际机场',
  '恩阳机场': '恩阳机场',
  '博兹曼机场': '博兹曼机场',
  '茨城机场': '茨城机场',
  '承德普宁机场': '承德普宁机场',
  '成都双流国际机场': '成都双流国际机场',
  '成都天府国际机场': '成都天府国际机场',
  '昌迪加尔机场': '昌迪加尔机场',
  '赤峰玉龙机场': '赤峰玉龙机场',
  '冲绳那霸机场': '冲绳那霸机场',
  '沧源佤山机场': '沧源佤山机场',
  '常州奔牛国际机场': '常州奔牛国际机场',
  '池州九华山机场': '池州九华山机场',
  '杜阿拉国际机场': '杜阿拉国际机场',
  '德班沙卡国王国际机场': '德班沙卡国王国际机场',
  '迪拜国际机场': '迪拜国际机场',
  '大阪国际机场': '大阪国际机场',
  '大阪关西机场': '大阪关西机场',
  '都柏林机场': '都柏林机场',
  '第比利斯机场': '第比利斯机场',
  '稻城亚丁机场': '稻城亚丁机场',
  '丹东浪头国际机场': '丹东浪头国际机场',
  '达尔文国际机场': '达尔文国际机场',
  '丹佛国际机场': '丹佛国际机场',
  '多哈哈马德国际机场': '多哈哈马德国际机场',
  '德黑兰伊玛目霍梅尼机场': '德黑兰伊玛目霍梅尼机场',
  '东京羽田国际机场': '东京羽田国际机场',
  '东京成田国际机场': '东京成田国际机场',
  '达卡国际机场': '达卡国际机场',
  '达喀尔布莱兹迪亚涅国际机场': '达喀尔布莱兹迪亚涅国际机场',
  '德里英迪拉· 甘地国际机场': '德里英迪拉· 甘地国际机场',
  '大连周水子国际机场': '大连周水子国际机场',
  '大理机场': '大理机场',
  '都灵机场': '都灵机场',
  '多伦多皮尔逊机场': '多伦多皮尔逊机场',
  '德令哈机场': '德令哈机场',
  '达累斯萨拉姆国际机场': '达累斯萨拉姆国际机场',
  '达拉斯 - 沃斯堡国际机场': '达拉斯 - 沃斯堡国际机场',
  '达拉斯拉夫菲尔德机场': '达拉斯拉夫菲尔德机场',
  '达曼法赫德国王国际机场': '达曼法赫德国王国际机场',
  '达尼丁机场': '达尼丁机场',
  '大庆萨尔图机场': '大庆萨尔图机场',
  '大邱机场': '大邱机场',
  '杜尚别国际机场': '杜尚别国际机场',
  '杜塞尔多夫机场': '杜塞尔多夫机场',
  '大同云冈机场': '大同云冈机场',
  '底特律韦内县大都会机场': '底特律韦内县大都会机场',
  '东营胜利机场': '东营胜利机场',
  '达州河市机场': '达州河市机场',
  '达州金垭机场': '达州金垭机场',
  '恩德培机场': '恩德培机场',
  '鄂尔多斯伊金霍洛国际机场': '鄂尔多斯伊金霍洛国际机场',
  '恩贾梅纳国际机场': '恩贾梅纳国际机场',
  '额济纳旗桃来机场': '额济纳旗桃来机场',
  '二连浩特赛乌苏国际机场': '二连浩特赛乌苏国际机场',
  '鄂州花湖机场': '鄂州花湖机场',
  '费城机场': '费城机场',
  '福岛机场': '福岛机场',
  '福冈机场': '福冈机场',
  '富国岛杜恩当机场': '富国岛杜恩当机场',
  '凤凰城空港国际机场': '凤凰城空港国际机场',
  '隆吉国际机场': '隆吉国际机场',
  '符拉迪沃斯托克机场': '符拉迪沃斯托克机场',
  '法兰克福机场': '法兰克福机场',
  '佩雷托拉机场': '佩雷托拉机场',
  '瓦加尔机场': '瓦加尔机场',
  '弗雷斯诺约塞米蒂国际机场': '弗雷斯诺约塞米蒂国际机场',
  '釜山金海国际机场': '釜山金海国际机场',
  '富山机场': '富山机场',
  '抚远东极机场': '抚远东极机场',
  '福州长乐国际机场': '福州长乐国际机场',
  '哥本哈根机场': '哥本哈根机场',
  '关岛国际机场': '关岛国际机场',
  '广岛机场': '广岛机场',
  '关丹机场': '关丹机场',
  '哥德堡兰德维特机场': '哥德堡兰德维特机场',
  '哥打巴鲁苏丹伊斯梅尔· 佩特拉机场': '哥打巴鲁苏丹伊斯梅尔· 佩特拉机场',
  '沙巴哥打基纳巴卢机场': '沙巴哥打基纳巴卢机场',
  '瓜达拉哈拉机场': '瓜达拉哈拉机场',
  '古晋机场': '古晋机场',
  '果洛玛沁机场': '果洛玛沁机场',
  '桂林两江国际机场': '桂林两江国际机场',
  '哥伦布港机场': '哥伦布港机场',
  '格拉茨机场': '格拉茨机场',
  '瓜拉丁加奴苏丹马哈茂德机场': '瓜拉丁加奴苏丹马哈茂德机场',
  '格莱斯顿机场': '格莱斯顿机场',
  '格拉斯哥国际机场': '格拉斯哥国际机场',
  '冈山机场': '冈山机场',
  '古瓦哈蒂机场': '古瓦哈蒂机场',
  '固原六盘山机场': '固原六盘山机场',
  '贵阳龙洞堡国际机场': '贵阳龙洞堡国际机场',
  '瓜亚基尔国际机场': '瓜亚基尔国际机场',
  '甘孜格萨尔机场': '甘孜格萨尔机场',
  '光州机场': '光州机场',
  '淮安涟水机场': '淮安涟水机场',
  '汉堡机场': '汉堡机场',
  '哈巴罗夫斯克诺维机场': '哈巴罗夫斯克诺维机场',
  '塞雷茨· 哈马爵士国际机场': '塞雷茨· 哈马爵士国际机场',
  '霍巴特机场': '霍巴特机场',
  '河池金城江机场': '河池金城江机场',
  '海得拉巴拉吉夫· 甘地国际机场': '海得拉巴拉吉夫· 甘地国际机场',
  '哈尔滨太平国际机场': '哈尔滨太平国际机场',
  '赫尔辛基万塔机场': '赫尔辛基万塔机场',
  '合肥新桥国际机场': '合肥新桥国际机场',
  '黑河瑷珲机场': '黑河瑷珲机场',
  '呼和浩特白塔国际机场': '呼和浩特白塔国际机场',
  '皇后镇机场': '皇后镇机场',
  '黑角机场': '黑角机场',
  '黄金海岸机场': '黄金海岸机场',
  '海口美兰国际机场': '海口美兰国际机场',
  '哈科特港机场': '哈科特港机场',
  '惠灵顿机场': '惠灵顿机场',
  '海拉尔东山国际机场': '海拉尔东山国际机场',
  '斯坦菲尔德国际机场': '斯坦菲尔德国际机场',
  '哈拉雷国际机场': '哈拉雷国际机场',
  '哈密尔顿机场': '哈密尔顿机场',
  '汉密尔顿岛机场': '汉密尔顿岛机场',
  '河内内排国际机场': '河内内排国际机场',
  '火奴鲁鲁檀香山国际机场': '火奴鲁鲁檀香山国际机场',
  '汉诺威机场': '汉诺威机场',
  '黄山屯溪国际机场': '黄山屯溪国际机场',
  '华沙萧邦机场': '华沙萧邦机场',
  '华盛顿里根国家机场': '华盛顿里根国家机场',
  '华盛顿杜勒斯国际机场': '华盛顿杜勒斯国际机场',
  '哈特福德布拉德利国际机场': '哈特福德布拉德利国际机场',
  '阿坝红原机场': '阿坝红原机场',
  '衡阳南岳机场': '衡阳南岳机场',
  '杭州萧山国际机场': '杭州萧山国际机场',
  '惠州平潭机场': '惠州平潭机场',
  '菏泽牡丹机场': '菏泽牡丹机场',
  '汉中城固机场': '汉中城固机场',
  '胡占德机场': '胡占德机场',
  '胡志明市新山一国际机场': '胡志明市新山一国际机场',
  '金边机场': '金边机场',
  '贾巴尔普尔机场': '贾巴尔普尔机场',
  '吉布提 - 安布利国际机场': '吉布提 - 安布利国际机场',
  '吉达阿卜杜勒阿齐兹国王国际机场': '吉达阿卜杜勒阿齐兹国王国际机场',
  '基多国际机场': '基多国际机场',
  '基督城国际机场': '基督城国际机场',
  '加的夫机场': '加的夫机场',
  '吉大港机场': '吉大港机场',
  '加德满都特里布万国际机场': '加德满都特里布万国际机场',
  '加尔各答机场': '加尔各答机场',
  '基辅茹良尼国际机场': '基辅茹良尼国际机场',
  '静冈机场': '静冈机场',
  '苏丹马赫穆德巴达鲁丁二世机场': '苏丹马赫穆德巴达鲁丁二世机场',
  '加格达奇机场': '加格达奇机场',
  '泉州晋江机场': '泉州晋江机场',
  '基加利国际机场': '基加利国际机场',
  '旧金山机场': '旧金山机场',
  '杰克逊维尔国际机场': '杰克逊维尔国际机场',
  '加拉加斯西蒙玻利瓦尔机场': '加拉加斯西蒙玻利瓦尔机场',
  '基隆拿国际机场': '基隆拿国际机场',
  '吉隆坡国际机场': '吉隆坡国际机场',
  '甲米机场': '甲米机场',
  '济宁曲阜机场': '济宁曲阜机场',
  '金奈国际机场': '金奈国际机场',
  '济南遥墙国际机场': '济南遥墙国际机场',
  '建三江湿地机场': '建三江湿地机场',
  '金沙萨恩吉利机场': '金沙萨恩吉利机场',
  '焦特布尔机场': '焦特布尔机场',
  '揭阳潮汕国际机场': '揭阳潮汕国际机场',
  '济州岛国际机场': '济州岛国际机场',
  '锦州锦州湾机场': '锦州锦州湾机场',
  '九寨黄龙机场': '九寨黄龙机场',
  '喀布尔国际机场': '喀布尔国际机场',
  '库车龟兹机场': '库车龟兹机场',
  '卡尔加里国际机场': '卡尔加里国际机场',
  '凯恩斯机场': '凯恩斯机场',
  '科夫斯港机场': '科夫斯港机场',
  '卡胡卢伊国际机场': '卡胡卢伊国际机场',
  '克久拉霍机场': '克久拉霍机场',
  '坎昆国际机场': '坎昆国际机场',
  '科克机场': '科克机场',
  '开罗国际机场': '开罗国际机场',
  '科隆波恩机场': '科隆波恩机场',
  '库莱布拉机场': '库莱布拉机场',
  '克利夫兰霍普金斯国际机场': '克利夫兰霍普金斯国际机场',
  '克拉克国际机场': '克拉克国际机场',
  '克拉科夫机场': '克拉科夫机场',
  '卡利卡特国际机场': '卡利卡特国际机场',
  '克莱蒙费朗奥弗涅机场': '克莱蒙费朗奥弗涅机场',
  '科伦坡班达拉奈克国际机场': '科伦坡班达拉奈克国际机场',
  '哈托国际机场': '哈托国际机场',
  '昆明长水国际机场': '昆明长水国际机场',
  '卡诺国际机场': '卡诺国际机场',
  '科纳克里机场': '科纳克里机场',
  '开普敦国际机场': '开普敦国际机场',
  '堪培拉机场': '堪培拉机场',
  '科钦国际机场': '科钦国际机场',
  '卡萨布兰卡穆罕默德五世国际机场': '卡萨布兰卡穆罕默德五世国际机场',
  '卡萨布兰卡安法机场': '卡萨布兰卡安法机场',
  '喀土穆国际机场': '喀土穆国际机场',
  '科托努机场': '科托努机场',
  '卡塔尼亚机场': '卡塔尼亚机场',
  '科威特机场': '科威特机场',
  '里昂机场': '里昂机场',
  '罗安达二月四日机场': '罗安达二月四日机场',
  '荔波机场': '荔波机场',
  '赖布尔机场': '赖布尔机场',
  '卢布尔亚那机场': '卢布尔亚那机场',
  '塞尔机场': '塞尔机场',
  '利伯维尔莱昂姆巴机场': '利伯维尔莱昂姆巴机场',
  '列城机场': '列城机场',
  '伦敦希思罗机场': '伦敦希思罗机场',
  '伦敦盖特威克机场': '伦敦盖特威克机场',
  '伦敦城机场': '伦敦城机场',
  '罗德岱堡好莱坞国际机场': '罗德岱堡好莱坞国际机场',
  '鹿儿岛机场': '鹿儿岛机场',
  '临汾尧都机场': '临汾尧都机场',
  '宁蒗泸沽湖机场': '宁蒗泸沽湖机场',
  '拉各斯机场': '拉各斯机场',
  '拉合尔阿拉马· 伊克巴勒国际机场': '拉合尔阿拉马· 伊克巴勒国际机场',
  '里加机场': '里加机场',
  '里贾纳机场': '里贾纳机场',
  '罗克汉普顿机场': '罗克汉普顿机场',
  '勒克瑙机场': '勒克瑙机场',
  '兰卡威国际机场': '兰卡威国际机场',
  '雷克雅未克国际机场': '雷克雅未克国际机场',
  '吕梁大武机场': '吕梁大武机场',
  '罗利达勒姆机场': '罗利达勒姆机场',
  '拉罗汤加机场': '拉罗汤加机场',
  '洛美机场': '洛美机场',
  '利马机场': '利马机场',
  '罗马菲乌米奇诺机场': '罗马菲乌米奇诺机场',
  '陇南成县机场': '陇南成县机场',
  '拉纳卡机场': '拉纳卡机场',
  '六盘水月照机场': '六盘水月照机场',
  '兰契机场': '兰契机场',
  '拉萨贡嘎国际机场': '拉萨贡嘎国际机场',
  '里斯本机场': '里斯本机场',
  '卢森堡机场': '卢森堡机场',
  '洛杉矶机场': '洛杉矶机场',
  '卢萨卡机场': '卢萨卡机场',
  '里士满国际机场': '里士满国际机场',
  '拉斯维加斯麦卡伦机场': '拉斯维加斯麦卡伦机场',
  '龙岩连城冠豸山机场': '龙岩连城冠豸山机场',
  '临沂启阳机场': '临沂启阳机场',
  '利雅得哈立德国王机场': '利雅得哈立德国王机场',
  '里雅恩姆卡拉机场': '里雅恩姆卡拉机场',
  '连云港花果山机场': '连云港花果山机场',
  '里约热内卢加利昂国际机场': '里约热内卢加利昂国际机场',
  '利兹机场': '利兹机场',
  '兰州中川国际机场': '兰州中川国际机场',
  '林芝米林机场': '林芝米林机场',
  '迈阿密机场': '迈阿密机场',
  '蒙彼利埃机场': '蒙彼利埃机场',
  '曼彻斯特机场': '曼彻斯特机场',
  '梅德福机场': '梅德福机场',
  '马德里机场': '马德里机场',
  '麦地那国际机场': '麦地那国际机场',
  '墨尔本机场': '墨尔本机场',
  '墨尔本爱华隆机场': '墨尔本爱华隆机场',
  '米尔迪拉机场': '米尔迪拉机场',
  '莫尔斯比港机场': '莫尔斯比港机场',
  '密尔沃基米切尔将军国际机场': '密尔沃基米切尔将军国际机场',
  '孟菲斯机场': '孟菲斯机场',
  '廊曼国际机场': '廊曼国际机场',
  '曼谷素万那普国际机场': '曼谷素万那普国际机场',
  '名古屋中部国际机场': '名古屋中部国际机场',
  '漠河古莲机场': '漠河古莲机场',
  '麦凯机场': '麦凯机场',
  '麦夸里港机场': '麦夸里港机场',
  '棉兰瓜拉纳穆国际机场': '棉兰瓜拉纳穆国际机场',
  '米兰利纳特机场': '米兰利纳特机场',
  '米兰马尔彭萨国际机场': '米兰马尔彭萨国际机场',
  '马累机场': '马累机场',
  '马拉博国际机场': '马拉博国际机场',
  '马拉加机场': '马拉加机场',
  '马六甲国际机场': '马六甲国际机场',
  '梅纳拉机场': '梅纳拉机场',
  '毛里求斯普莱桑斯国际机场': '毛里求斯普莱桑斯国际机场',
  '罗伯茨国际机场': '罗伯茨国际机场',
  '孟买贾特拉帕蒂· 希瓦吉国际机场': '孟买贾特拉帕蒂· 希瓦吉国际机场',
  '明尼阿波利斯圣保罗机场': '明尼阿波利斯圣保罗机场',
  '慕尼黑机场': '慕尼黑机场',
  '马尼拉机场': '马尼拉机场',
  '马赛普罗旺斯机场': '马赛普罗旺斯机场',
  '莫斯科谢诺梅杰沃机场': '莫斯科谢诺梅杰沃机场',
  '莫斯科伏努科沃机场': '莫斯科伏努科沃机场',
  '明斯克机场': '明斯克机场',
  '马斯喀特机场': '马斯喀特机场',
  '芒特艾萨机场': '芒特艾萨机场',
  '蒙特雷地区机场': '蒙特雷地区机场',
  '蒙特利尔特鲁多国际机场': '蒙特利尔特鲁多国际机场',
  '蒙特雷机场': '蒙特雷机场',
  '墨西哥城国际机场': '墨西哥城国际机场',
  '梅州梅县机场': '梅州梅县机场',
  '满洲里西郊机场': '满洲里西郊机场',
  '宁波栎社国际机场': '宁波栎社国际机场',
  '内比都国际机场': '内比都国际机场',
  '那不勒斯国际机场': '那不勒斯国际机场',
  '南昌昌北国际机场': '南昌昌北国际机场',
  '纳迪机场': '纳迪机场',
  '努尔苏丹纳扎尔巴耶夫国际机场': '努尔苏丹纳扎尔巴耶夫国际机场',
  '那格浦尔索内格翁机场': '那格浦尔索内格翁机场',
  '南京禄口国际机场': '南京禄口国际机场',
  '努库阿洛法费阿阿莫国际机场': '努库阿洛法费阿阿莫国际机场',
  '纽卡斯尔威廉姆顿机场': '纽卡斯尔威廉姆顿机场',
  '纽卡斯尔机场': '纽卡斯尔机场',
  '内罗毕乔莫· 肯雅塔机场': '内罗毕乔莫· 肯雅塔机场',
  '纽伦堡机场': '纽伦堡机场',
  '诺里奇机场': '诺里奇机场',
  '南宁吴圩国际机场': '南宁吴圩国际机场',
  '尼斯蓝色海岸机场': '尼斯蓝色海岸机场',
  '纳什维尔国际机场': '纳什维尔国际机场',
  '南通兴东国际机场': '南通兴东国际机场',
  '努瓦克肖特机场': '努瓦克肖特机场',
  '纽约拉瓜迪机场': '纽约拉瓜迪机场',
  '纽约纽瓦克机场': '纽约纽瓦克机场',
  '纽约肯尼迪机场': '纽约肯尼迪机场',
  '哈马尼迪奥里国际机场': '哈马尼迪奥里国际机场',
  '普洱思茅机场': '普洱思茅机场',
  '普吉机场': '普吉机场',
  '帕拉马里博国际机场': '帕拉马里博国际机场',
  '普罗瑟派恩机场': '普罗瑟派恩机场',
  '浦那机场': '浦那机场',
  '平壤顺安国际机场': '平壤顺安国际机场',
  '珀斯机场': '珀斯机场',
  '梅塞迪塔机场': '梅塞迪塔机场',
  '浦项机场': '浦项机场',
  '匹兹堡国际机场': '匹兹堡国际机场',
  '青岛胶东国际机场': '青岛胶东国际机场',
  '秦皇岛北戴河国际机场': '秦皇岛北戴河国际机场',
  '黔江武陵山机场': '黔江武陵山机场',
  '清莱国际机场': '清莱国际机场',
  '乞力马扎罗国际机场': '乞力马扎罗国际机场',
  '清迈国际机场': '清迈国际机场',
  '庆阳机场': '庆阳机场',
  '清州国际机场': '清州国际机场',
  '乔治王子城机场': '乔治王子城机场',
  '日内瓦机场': '日内瓦机场',
  '若羌楼兰机场': '若羌楼兰机场',
  '荣市机场': '荣市机场',
  '日照山字河机场': '日照山字河机场',
  '塞班机场': '塞班机场',
  '圣芭芭拉机场': '圣芭芭拉机场',
  '圣彼得堡机场': '圣彼得堡机场',
  '斯波坎国际机场': '斯波坎国际机场',
  '圣保罗国际机场': '圣保罗国际机场',
  '莎车机场': '莎车机场',
  '斯德哥尔摩阿兰达国际机场': '斯德哥尔摩阿兰达国际机场',
  '圣地亚哥机场': '圣地亚哥机场',
  '圣地亚哥（ 智利） 机场': '圣地亚哥（ 智利） 机场',
  '金浦国际机场': '金浦国际机场',
  '仁川机场': '仁川机场',
  '仁川国际机场': '仁川国际机场',
  '索非亚机场': '索非亚机场',
  '韶关丹霞机场': '韶关丹霞机场',
  '萨格勒布机场': '萨格勒布机场',
  '上海虹桥国际机场': '上海虹桥国际机场',
  '上海浦东国际机场': '上海浦东国际机场',
  '路易斯姆诺兹马灵国际机场': '路易斯姆诺兹马灵国际机场',
  '费尔南多路易斯里巴斯多米尼奇机场': '费尔南多路易斯里巴斯多米尼奇机场',
  '圣何塞机场': '圣何塞机场',
  '圣何塞安圣玛丽亚国际机场': '圣何塞安圣玛丽亚国际机场',
  '石河子花园机场': '石河子花园机场',
  '沙迦国际机场': '沙迦国际机场',
  '石家庄正定国际机场': '石家庄正定国际机场',
  '萨克拉门托国际机场': '萨克拉门托国际机场',
  '亨利洛尔森机场': '亨利洛尔森机场',
  '斯利那加国际机场': '斯利那加国际机场',
  '苏黎世机场': '苏黎世机场',
  '兰伯特圣路易斯国际机场': '兰伯特圣路易斯国际机场',
  '三明沙县机场': '三明沙县机场',
  '厦门高崎国际机场': '厦门高崎国际机场',
  '苏梅岛机场': '苏梅岛机场',
  '萨那机场': '萨那机场',
  '神农架红坪机场': '神农架红坪机场',
  '上饶三清山机场': '上饶三清山机场',
  '松山机场': '松山机场',
  '泗水机场': '泗水机场',
  '斯图加特机场': '斯图加特机场',
  '斯特拉斯堡机场': '斯特拉斯堡机场',
  '塞里尔金机场': '塞里尔金机场',
  '马克坦国际机场': '马克坦国际机场',
  '沈阳桃仙国际机场': '沈阳桃仙国际机场',
  '三亚凤凰国际机场': '三亚凤凰国际机场',
  '邵阳武冈机场': '邵阳武冈机场',
  '松原查干湖机场': '松原查干湖机场',
  '廷布机场': '廷布机场',
  '腾冲驼峰机场': '腾冲驼峰机场',
  '通化三源浦机场': '通化三源浦机场',
  '天津滨海国际机场': '天津滨海国际机场',
  '塔林伦纳特· 梅里塔林机场': '塔林伦纳特· 梅里塔林机场',
  '吐鲁番交河机场': '吐鲁番交河机场',
  '特里凡得琅国际机场': '特里凡得琅国际机场',
  '本古里安国际机场': '本古里安国际机场',
  '布拉格纳克机场': '布拉格纳克机场',
  '图木舒克唐王城机场': '图木舒克唐王城机场',
  '塔那那利佛伊瓦图国际机场': '塔那那利佛伊瓦图国际机场',
  '突尼斯机场': '突尼斯机场',
  '坦帕机场': '坦帕机场',
  '铜仁凤凰机场': '铜仁凤凰机场',
  '天水麦积山机场': '天水麦积山机场',
  '唐山三女河机场': '唐山三女河机场',
  '塔什干机场': '塔什干机场',
  '塔什库尔干红其拉甫机场': '塔什库尔干红其拉甫机场',
  '汤斯维尔机场': '汤斯维尔机场',
  '太原武宿国际机场': '太原武宿国际机场',
  '台州路桥机场': '台州路桥机场',
  '扬州泰州国际机场': '扬州泰州国际机场',
  '乌代布尔机场': '乌代布尔机场',
  '霍齐亚· 库塔科国际机场': '霍齐亚· 库塔科国际机场',
  '五大连池德都机场': '五大连池德都机场',
  '维尔纽斯机场': '维尔纽斯机场',
  '温哥华机场': '温哥华机场',
  '威海大水泊国际机场': '威海大水泊国际机场',
  '芜湖宣州机场': '芜湖宣州机场',
  '武汉天河国际机场': '武汉天河国际机场',
  '瓦加杜古国际机场': '瓦加杜古国际机场',
  '乌兰察布机场': '乌兰察布机场',
  '乌兰浩特机场': '乌兰浩特机场',
  '乌鲁木齐地窝堡国际机场': '乌鲁木齐地窝堡国际机场',
  '瓦拉纳西机场': '瓦拉纳西机场',
  '温尼伯国际机场': '温尼伯国际机场',
  '威尼斯机场': '威尼斯机场',
  '乌戎潘当苏丹哈桑丁机场': '乌戎潘当苏丹哈桑丁机场',
  '重庆巫山机场': '重庆巫山机场',
  '渥太华机场': '渥太华机场',
  '万象瓦岱机场': '万象瓦岱机场',
  '无锡苏南硕放国际机场': '无锡苏南硕放国际机场',
  '万鸦老美娜多机场': '万鸦老美娜多机场',
  '维也纳机场': '维也纳机场',
  '温州龙湾国际机场': '温州龙湾国际机场',
  '西安咸阳国际机场': '西安咸阳国际机场',
  '新奥尔良机场': '新奥尔良机场',
  '奥斯马尼国际机场': '奥斯马尼国际机场',
  '岘港国际机场': '岘港国际机场',
  '夏河机场': '夏河机场',
  '新加坡樟宜机场': '新加坡樟宜机场',
  '暹粒吴哥机场': '暹粒吴哥机场',
  '夏洛特道格拉斯国际机场': '夏洛特道格拉斯国际机场',
  '悉尼金斯福德· 史密斯机场': '悉尼金斯福德· 史密斯机场',
  '小松机场': '小松机场',
  '西双版纳嘎洒国际机场': '西双版纳嘎洒国际机场',
  '休斯顿霍比机场': '休斯顿霍比机场',
  '乔治· 布什洲际机场': '乔治· 布什洲际机场',
  '仙台机场': '仙台机场',
  '新潟机场': '新潟机场',
  '新西伯利亚机场': '新西伯利亚机场',
  '辛辛那提 - 北肯塔基国际机场': '辛辛那提 - 北肯塔基国际机场',
  '兴义万峰林机场': '兴义万峰林机场',
  '信阳明港机场': '信阳明港机场',
  '襄阳刘集机场': '襄阳刘集机场',
  '西雅图机场': '西雅图机场',
  '忻州五台山机场': '忻州五台山机场',
  '徐州观音国际机场': '徐州观音国际机场',
  '延安南泥湾机场': '延安南泥湾机场',
  '宜宾五粮液机场': '宜宾五粮液机场',
  '银川河东国际机场': '银川河东国际机场',
  '宜春明月山机场': '宜春明月山机场',
  '雅典国际机场': '雅典国际机场',
  '印第安纳波利斯国际机场': '印第安纳波利斯国际机场',
  '亚的斯亚贝巴博莱国际机场': '亚的斯亚贝巴博莱国际机场',
  '伊尔库茨克国际机场': '伊尔库茨克国际机场',
  '仰光国际机场': '仰光国际机场',
  '盐湖城国际机场': '盐湖城国际机场',
  '约翰内斯堡奥利弗· 雷金纳德· 坦博国际机场': '约翰内斯堡奥利弗· 雷金纳德· 坦博国际机场',
  '延吉朝阳川国际机场': '延吉朝阳川国际机场',
  '雅加达苏加诺 - 哈达国际机场': '雅加达苏加诺 - 哈达国际机场',
  '营口兰旗机场': '营口兰旗机场',
  '榆林榆阳机场': '榆林榆阳机场',
  '玉林福绵机场': '玉林福绵机场',
  '玉树巴塘机场': '玉树巴塘机场',
  '伊斯兰堡国际机场': '伊斯兰堡国际机场',
  '伊斯坦布尔机场': '伊斯坦布尔机场',
  '烟台蓬莱国际机场': '烟台蓬莱国际机场',
  '于田万方机场': '于田万方机场',
  '亚特兰大哈兹菲尔德 - 杰克逊国际机场': '亚特兰大哈兹菲尔德 - 杰克逊国际机场',
  '希马伦国际机场': '希马伦国际机场',
  '岳阳三荷机场': '岳阳三荷机场',
  '金兰国际机场': '金兰国际机场',
  '伊兹密尔机场': '伊兹密尔机场',
  '朱巴国际机场': '朱巴国际机场',
  '长春龙嘉国际机场': '长春龙嘉国际机场',
  '中国澳门国际机场': '中国澳门国际机场',
  '中国高雄国际机场': '中国高雄国际机场',
  '中国金门尚义机场': '中国金门尚义机场',
  '中国台北松山机场': '中国台北松山机场',
  '中国台北桃园国际机场': '中国台北桃园国际机场',
  '台南机场': '台南机场',
  '中国台中清泉岗机场': '中国台中清泉岗机场',
  '香港国际机场': '中国香港国际机场',
  '札幌新千岁机场': '札幌新千岁机场',
  '珠海金湾机场': '珠海金湾机场',
  '湛江吴川机场': '湛江吴川机场',
  '芝加哥米德威机场': '芝加哥米德威机场',
  '芝加哥奥黑尔机场': '芝加哥奥黑尔机场',
  '张家界荷花机场': '张家界荷花机场',
  '张家口宁远机场': '张家口宁远机场',
  '扎兰屯成吉思汗机场': '扎兰屯成吉思汗机场',
  '斋浦尔国际机场': '斋浦尔国际机场',
  '重庆江北国际机场': '重庆江北国际机场',
  '重庆武隆区仙女山机场': '重庆武隆区仙女山机场',
  '长崎机场': '长崎机场',
  '长沙黄花国际机场': '长沙黄花国际机场',
  '舟山普陀山机场': '舟山普陀山机场',
  '昭苏天马机场': '昭苏天马机场',
  '中卫沙坡头机场': '中卫沙坡头机场',
  '张掖甘州机场': '张掖甘州机场',
  '遵义茅台机场': '遵义茅台机场',
  '遵义新舟国际机场': '遵义新舟国际机场',
  '郑州新郑国际机场': '郑州新郑国际机场',
  '上海航空': '上海航空',
  '新西兰航空': '新西兰航空',
  '长城航空': '长城航空',
  '运营出票单查询': '出票单查询',
  '运营退票单查询': '退票单查询',
  '采购退票单查询': '退票单查询',
  '供应退票单查询': '退票单查询',
  '运营改签单查询': '改签单查询',
  '采购改签单查询': '改签单查询',
  '供应改签单查询': '改签单查询',
  '退票完成': '退票完成',
  '退票中': '退票中',
  '退票失败': '退票失败',
  '退票申请': '退票申请',
  '特殊': '特殊',
  '自愿': '自愿',
  '非自愿': '非自愿',
  '航变': '航变',
  '病退': '病退',
  '备降': '备降',
  '重构全退': '重构全退',
  '拒载': '拒载',
  '超售': '超售',
  '疫情': '疫情',
  '特殊事件': '特殊事件',
  '拒签': '拒签',
  '形式全退': '形式全退',
  '废票': '废票',
  '降舱': '降舱',
  '病改': '病改',
  '孕改': '孕改',
  '其他': '其他',
  '其它': '其它',
  '改签完成': '改签完成',
  '改签失败': '改签失败',
  '改签选择航班': '改签选择航班',
  '新增政策': '新增政策',
  '政策修改': '政策修改',
  '身份证': '身份证',
  '护照': '护照',
  '军官证': '军官证',
  '回乡证': '回乡证',
  '港澳通行证': '港澳通行证',
  '台湾通行证': '台湾通行证',
  '台胞证': '台胞证',
  '士兵证': '士兵证',
  '警官证': '警官证',
  'go trip': 'Depart',
  'depart': '去程',
  'return': '返程',
  'return trip': 'Return',
  '默认岗位': '默认岗位',
  '改姓名或称谓': '改姓名或称谓',
  '提现记录': '提现记录',
  rolemanage: {
    'Permission Control': '权限控制',
    'Add Role': '新增角色',
    'Modify role': '修改角色',
    'Specify user role': '指定用户角色',
    'User to be specified': '待指定用户',
    'Selected Designated User': '已选指定用户',
    'Permission': '权限选择',
    'Please enter a role name': '请输入角色名称',
    'Role management': '角色管理',
    '-Half selected': '-半选中',
    'Modify permission successfully': '修改权限成功',
    'New Character Success': '新增角色成功',
    'Assigned role success': '指派角色成功'
  },
  shortmsglist: {
    'Ticket SMS': '出票短信',
    'Change SMS': '改签短信',
    'Refund SMS': '退票短信',
    'Airchange SMS (including delay, cancellation, resumption)': '航变短信(包括延误 取消 恢复)',
    'Service SMS': '服务短信',
    'Receive number': '接收号码',
    'Send number': '发送号码',
    'Content': '内容',
    'Time': '时间',
    'The difference between the start date and the end date cannot be greater than 365 days': '开始日期和结束日期相差不能大于365天'
  },
  systemlog: {
    'HR file': 'HR档案',
    'Deactivated': '停用',
    'Real name': '真实姓名',
    'Date': '日期'
  },
  systemsetting: {
    'Setup name': '设置名称',
    'Set content': '设置内容',
    'Modification time': '修改时间',
    'Modifier': '修改人',
    'New system settings': '新增系统设置',
    'Please select a setting name': '请选择设置名称',
    'Please fill in the settings': '请填写设置内容',
    'Edit system settings': '编辑系统设置',
    'Added system settings successfully': '新增系统设置成功',
    'Modified successfully': '修改成功',
    'Delete system settings successfully': '删除系统设置成功',
    'System settings not found': '未查询到系统设置',
    'The difference between the start date and the end date cannot be greater than 31 days': '开始日期和结束日期相差不能大于31天'
  },
  orderdetail: {
    'Rescheduled Upgrade': '改期升舱',
    'Loading desperately': '拼命加载中...',
    'Ticket Details': '出票单详情',
    'Payment address': '支付地址',
    'Are you sure to issue a ticket?': '确定出票吗？',
    'Ticketing': '出票',
    'Booking Express Instructions': '预订快捷指令',
    'Aviation monitoring': '航变监控',
    'Ticket swipe': '刷票',
    'Cancel Order': '取消订单',
    'Convert to Appeal Form': '转为申诉单',
    'Exception entry': '异常录入',
    'Refund form entry': '退票单录入',
    'Early pick-up': '提前取位',
    'Unlock and close': '解锁并关闭',
    'Process and lock': '处理并锁定',
    'Close': '关闭',
    'Order information': '订单信息',
    'Store name': '店铺名称',
    'Ticket number': '出票单号',
    'Platform change order number': '改签单号',
    'Platform refund order number': '退票单号',
    'Exception order number': '异常单号',
    'Appeal number': '申诉单号',
    'Downloadable': '可降舱',
    'No downgrade': '不可降舱',
    'Order sub-status': '订单子状态',
    'Fill failed': '补位失败',
    'Unticketed Refund Purchased': '未出票退款已采购',
    'Reimbursement Type': '报销类型',
    'Price reduction': '降价',
    'Price can be reduced': '可降价',
    'No price reduction': '不可降价',
    'Latest ticket issuance time': '最晚出票时间',
    'Total Fare': '总票面价',
    'Total selling price': '总销售价',
    'Total Sales Price': '总销售价',
    'Total Tax': '总税费',
    'Total machine cost': '总机建费',
    'Total fuel cost': '总燃油费',
    'Airport Construction Fee': '机建费',
    'Fuel Surcharge': '燃油费',
    'Ticketing time': '出票时间',
    'ticketing time': '出票耗时',
    'Account verification time': '核账时间',
    'Mailing Itinerary': '邮寄行程单',
    'Ticket Notes': '出票备注',
    'Return and change instructions': '退改签说明',
    'Epidemics cannot enter': '疫情不可进',
    'Untrustworthy': '失信人',
    'No same cabin for external release': '外放无同舱',
    'Enter the single upgrade': '进单升舱',
    'Ticket reservation upgrade': '留票升舱',
    'The freight does not match': '运价不符',
    'Policy loss': '政策亏损',
    'Flight Cancellation': '航班取消',
    'Quick save': '快速保存',
    'Flight date': '航班日期',
    'Itinerary': '行程',
    'Flight number': '航班号',
    'Class': '舱位',
    'KN registration certification': 'KN注册认证',
    'Total sales price': '销售总价',
    'Purchase Amount': '采购金额',
    'Please enter the purchase amount': '请输入采购金额',
    'Please enter PNR': '请输入PNR',
    'Please enter large code': '请输入大编码',
    'Ticket number format': '票号格式',
    'Please enter ticket number': '请输入票号',
    'Ticket number verification': '票号验证',
    'Please enter profit': '请输入利润',
    'Are you sure to re-occupy the seat?': '确定重新占座吗？',
    'Re-occupy the seat': '重新占座',
    'Are you sure to pay again?': '确定重新支付吗？',
    'Re-pay': '重新支付',
    'Are you sure about the booking code?': '确定预订编码吗？',
    'Booking Code': '预订编码',
    'Out-of-pocket tickets': '外采出票',
    'Save Ticket': '保存出票单',
    'Unlock and deal with': '解锁并处理',
    'Ticket purchase record': '出票采购记录',
    'Expenditure': '支出',
    'Income': '收入',
    'Passenger': '乘机人',
    'Purchase channel': '采购渠道',
    'Payment Channel': '付款渠道',
    'Purchase Order Number': '采购订单号',
    'Procurement space': '采购舱位',
    'Purchase Remarks': '采购备注',
    'Agency Fee': '代理费',
    'Agency Rate': '代理费率',
    'Please select the procurement channel': '请选择采购渠道',
    'Purchase Type': '采购类型',
    'Please select type': '请选择类型',
    'Offer Type/Offer Logo': '优惠类型/优惠标识',
    'Stored Value Card': '储值卡',
    'Points': '积分',
    'Agency Fee/Agency Fee': '代理费/代理费率',
    'New purchase record': '新增采购记录',
    'Keep Purchase Records': '保存采购记录',
    'Contact Phone': '联系人电话',
    'Account verification information': '核账信息',
    'Platform collection and verification amount': '平台收款核账金额',
    'Platform collection and verification time': '平台收款核账时间',
    'Save the platform collection and verification information': '保存平台收款核账信息',
    'Purchase payment verification amount': '采购付款核账金额',
    'Purchase Payment Billing Time': '采购付款账单时间',
    'Save the purchase payment verification information': '保存采购付款核账信息',
    'Refund information': '退票信息',
    'Please select purchase status': '请选择采购状态',
    'Pending payment': '待支付',
    'Payment in progress': '付款中',
    'Edit Purchase Record': '编辑采购记录',
    'Purchase Fare': '采购票面价',
    'Edit Order Remarks': '编辑订单备注',
    'Shared flight': '共享航班',
    'Main flight': '主飞航班',
    'Childrens Booking Instructions': '儿童预订指令',
    'One-click AV': '一键AV',
    'Product Details': '产品详情',
    'Edit Product': '编辑产品',
    'Product name': '产品名称',
    'NFD': 'NFD',
    'Clearance Products': '清仓产品',
    'Business travel products': '商旅产品',
    'Transit': '中转',
    'Transit product': '中转产品',
    'Charter': '包机',
    'Cut position': '切位',
    'Airline VIP': '航司VIP',
    'General Policy': '普通政策',
    'Prepayment Policy': '预付政策',
    'Team Policy': '团队政策',
    'Special Offer Policy': '特价政策',
    'K-bit policy': 'K位政策',
    'Fixed price': '固定价格',
    'Applicable class': '适用舱位',
    'Sales Type': '销售类型',
    'Direct connection': '直连',
    'Fixed cabin': '固舱',
    'See cabin': '见舱',
    'Policy Code Format': '政策代码格式',
    'Additional airline code': '追加航司代码',
    'Additional delivery timetime and time': '追加投放时间（时分）',
    'Delivery Type': '投放类型',
    'Total + increment': '全量+增量',
    'Full amount only': '仅全量',
    'Increment only': '仅增量',
    'Delete policy on increment': '增量时删除政策',
    'Delete type': '删除类型',
    'By Policy Code': '按政策代码',
    'By delivery time': '按投放时间',
    'itinerary': '行程单',
    'Invoice': '发票',
    'Itinerary + difference invoice': '行程单+差额发票',
    'office number': 'office号',
    'IATA number': 'IATA号',
    'Drop the upper class': '投放上级舱位',
    'Reservation': '订位',
    'PAT': 'PAT',
    'Organic Wine Package': '机酒套餐',
    'Support stop': '支持经停',
    'Support children': '支持儿童',
    'Tariff rules': '运价规则',
    'Return and change ID': '退改签ID',
    'Placing Fare': '投放票面价',
    'Price Type': '票面价类型',
    'Official website price': '官网价',
    'Settlement price': '结算价',
    'Specified Fare': '指定票面价',
    'Y cabin discount': 'Y舱折扣',
    'Special Ticket Instructions': '特殊票务说明',
    'Minimum age limit': '最小年龄限制',
    'Maximum age limit': '最大年龄限制',
    'Airline': '航司',
    'Departure airport code': '出发机场代码',
    'Arrival airport code': '到达机场代码',
    'Adult cabin': '成人舱位',
    'Childrens Class': '儿童舱位',
    'Select flight date': '选择航班日期',
    'Select departure time': '选择起飞时间',
    'Select arrival time': '选择到达时间',
    'Get payment address': '获取支付地址',
    'Purchase status': '采购状态',
    'Go to pay': '去支付',
    'Ticket swiping rules': '刷票规则',
    'Ticket swiping frequency': '刷票频率',
    'Ticket source': '刷票源',
    'Official website': '官网',
    'Ticket swiping channel': '刷票渠道',
    'Whether to account for': '是否占编',
    'Brushing class': '刷票舱位',
    'Monitor the superior class': '监控上级舱位',
    'Superior class number reminder': '上级舱位数提醒',
    'Deadline for swiping tickets': '刷票截止时间',
    'Select datetime': '选择日期时间',
    'Appeal Type': '申诉类型',
    'Platform Refund': '平台补退',
    'Quality inspection': '质检',
    'Our appeal': '我司申诉',
    'Appeal amount': '申诉金额',
    'Appeal Remarks': '申诉备注',
    'reason': '原因',
    'Ticketing channel': '出票渠道',
    'Ticketing office': '出票office',
    'Lowest cabin': '最低舱',
    'No coupons': '不用优惠券',
    'Coupons are useful or not': '优惠券有用无不用',
    'Age': '年龄',
    'Invoicing': '开票',
    'Single settlement price': '单张结算价',
    'Ticketing gross profit': '出票毛利',
    'Cashback + Cashback': '返点+返现',
    'Rebate': '返点',
    'Cash back': '返现',
    'Par/Class': '票面价/舱位',
    'Adult': '成人',
    'Offer': '优惠',
    'Order and pay': '创单并支付',
    'WONIU': 'WONIU',
    'Select Flight Person': '选择乘机人',
    'Verification Channel': '验证渠道',
    'Where to go': '去哪儿',
    'Ticket number status': '票号状态',
    'Fare price': '票价',
    'Modify ticket number': '修改票号',
    'Purchasing channel cannot be empty': '采购渠道不能为空',
    'Purchase order number cannot be empty': '采购订单号不能为空',
    'The transaction serial number cannot be empty': '交易流水号不能为空',
    'Payment amount cannot be empty': '支付金额不能为空',
    'The preferential amount cannot be empty, it can be 0': '优惠金额不能为空,可为0',
    'Airline cannot be empty': '航司不能为空',
    'Departure airport code cannot be empty': '出发机场代码不能为空',
    'Arrival airport code cannot be empty ': '到达机场代码不能为空',
    'Flight number cannot be empty': '航班号不能为空',
    'Adult cabin cannot be empty': '成人舱位不能为空',
    'Childrens cabin cannot be empty': '儿童舱位不能为空',
    'Please select a flight date': '请选择航班日期',
    'Please select departure time': '请选择起飞时间',
    'Please select arrival time': '请选择到达时间',
    'Please select the reason for cancellation': '请选择取消原因',
    'Please select the frequency of swiping tickets': '请选择刷票频率',
    'Please select the brush ticket source': '请选择刷票源',
    'Please select the ticket swiping channel': '请选择刷票渠道',
    'Please select whether to account for': '请选择是否占编',
    'Please enter the swiping class': '请输入刷票舱位',
    'Please enter the monitoring superior class': '请输入监控上级舱位',
    'Please enter the superior class number reminder': '请输入上级舱位数提醒',
    'Please select the deadline for swiping tickets': '请选择刷票截止时间',
    'Please enter the order remarks': '请输入订单备注',
    'Please select the appeal type': '请选择申诉类型',
    'Please fill in the appeal amount': '请填写申诉金额',
    'The specified class code cannot be empty': '指定舱位代码不能为空',
    'Ticket number cannot be empty': '票号不能为空',
    'Easy to travel': '易旅行',
    'No Data': '暂无数据',
    'Flight Butler': '航班管家',
    'Snail': '蜗牛',
    'Return to the ticket list and try again after refreshing according to F5': '返回出票单列表按F5刷新后重试',
    'Please enter the platform collection and verification amount': '请输入平台收款核账金额',
    'Please enter the platform collection and verification time': '请输入平台收款核账时间',
    'Save the platform collection and verification successfully': '保存平台收款核账成功',
    'Failed to save the platform collection and verification account Reason:': '保存平台收款核账失败，原因：',
    'Please enter the purchase payment verification amount': '请输入采购付款核账金额',
    'Please enter the purchase payment billing time': '请输入采购付款账单时间',
    'Save the purchase payment verification successfully': '保存采购付款核账成功',
    'Failed to save the purchase payment verification account, Reason:': '保存采购付款核账失败，原因：',
    'Delete the platform collection and verification successfully': '删除平台收款核账成功',
    'Delete the platform collection and verification failed. Reason:': '删除平台收款核账失败，原因：',
    'Delete the purchase payment verification successfully': '删除采购付款核账成功',
    'Delete the purchase payment verification failed, reason:': '删除采购付款核账失败，原因：',
    'REFUNDED Refunded': 'REFUNDED已退票',
    'VOID voided': 'VOID已作废',
    'SUSPENDED Suspended': 'SUSPENDED已挂起',
    'CHECKED IN checked in': 'CHECKED IN已值机',
    'LIFT/BOARDED has left port': 'LIFT/BOARDED已离港',
    'USED/FLOWN Used': 'USED/FLOWN已使用',
    'OPENFORUSE': 'OPEN FOR USE',
    'Success~': '成功啦~',
    'Modify the segment information successfully': '修改航段信息成功',
    'Please enter the correct number': '请输入正确的数字',
    'The current limit selects 9 files, this time it is selected': '当前限制选择 9 个文件，本次选择了',
    'Files selected in total': '个文件，共选择了',
    'Converted to appeal form successfully': '转为申诉单成功',
    'Refund order number': '退票单号',
    'Successful early seat pick-up': '提前取位成功',
    'Failed to take place early, reason:': '提前取位失败，原因：',
    'Failed to cancel the order, reason:': '取消订单失败，原因：',
    'Modify the remarks successfully': '修改备注成功',
    'Senior Special': '长者特惠',
    'The order does not exist click OK to close the label': '订单不存在，点击确定关闭标签。',
    'Payment channel cannot be empty': '付款渠道不能为空',
    'Type cannot be empty': '类型不能为空',
    'Purchase account cannot be empty': '采购账号不能为空',
    'Purchase password cannot be empty': '采购密码不能为空',
    'New purchase record successful': '新增采购记录成功',
    'Modify the purchase record successfully!': '修改采购记录成功！',
    'Delete the purchase record successfully': '删除采购记录成功',
    'The new ticket swiping order was successful': '新增刷票订单成功',
    'Are you sure to close the current page?': '确定关闭当前页面吗？',
    'Are you sure to unlock and close?': '确定解锁并关闭吗？',
    'Unlocked and processed successfully': '解锁并处理成功',
    'Baby': '婴儿',
    'ID card': '身份证',
    'Passport': '护照',
    'Product information is empty': '产品信息为空',
    'Please fill in the passenger ticket number and try again': '请填写乘机人票号后重试',
    'Incorrect ticket number': '票号不正确',
    'Please fill in the passenger PNR and try again': '请填写乘机人PNR后重试',
    'PNR is incorrect': 'PNR不正确',
    'Big encoding incorrect': '大编码不正确',
    'Purchase amount must be greater than 0': '采购金额必须大于0',
    'Please enter': '请输入',
    'Successful ticket issuance!': '出票成功！',
    'The ticket has been issued': '出票单已被',
    'There is already a successful purchase record and the seat cannot be re-occupied. Please use ticketing to reset': '已存在成功的采购记录，无法重新占座，请使用出票重置',
    'Resumption Success': '重新占座成功',
    'Ticket reset successful': '出票重置成功',
    'Create an order and pay successfully, wait for asynchronous ticket issuance': '创单并支付成功，等待异步出票',
    'Ordinary standard': '普通标准',
    'Preferred': '优选',
    'special Offer': '特惠',
    'Special Products': '特殊产品',
    'Youth and Senior Special': '青老年特惠',
    'Multiplayer Offer': '多人优惠',
    'Travel worry-free': '出行无忧',
    'pa airline direct sales': 'pa航司直销',
    'pb standard official website': 'pb标准官网',
    'pd housekeeper self-operated': 'pd管家自营',
    'PE Agent Standard': 'pe代理商标准',
    'pj charter cut': 'pj包机切位',
    'PC official website special offer': 'pc官网特惠',
    'Ph Standard Special': 'ph标准特惠',
    'pf agent special offer': 'pf代理商特价',
    'Py special low price': 'py特惠低价',
    'pw shares the main flight': 'pw共享出主飞',
    'Official website this policy requires the passengers own mobile phone number': '官网(该政策需要乘客本人手机号)',
    'Other': '其他',
    'Not provided': '不提供',
    'Booking code successful': '预订编码成功',
    'PNR cannot be empty': 'PNR不能为空',
    'Save the ticket successfully!': '保存出票单成功！',
    'Unable to jump to the payment page, the payment address is empty!': '无法跳转支付页，支付地址为空！',
    'The payment address is in the wrong format, please try again!': '支付地址格式错误，请重试！',
    'Was the payment successful?': '是否支付成功？',
    'Payment result': '支付结果',
    'Payment successful': '支付成功',
    'International students': '留学生',
    'Date of Birth': '出生日期',
    'Main fly': '主飞',
    'Stop': '经停',
    'First Class': '头等舱',
    'Business Cabin': '公务舱',
    'walletPay': '钱包',
    'Alipay payment': '支付宝支付',
    'Online Banking Payment': '网银支付',
    'Credit Card Payment': '信用卡支付',
    'Total order price': '订单总价:',
    'Available Balance': '可用余额:',
    'The Deposit funds is insufficient please recharge': '充值余额不足，请充值',
    'Payment password': '支付密码:',
    'Confirm payment': '确认支付',
    'Are you sure you want to pay?': '确认支付吗？',
    'Paying': '支付中...',
    'Contact person': '联系人',
    'Passenger Name': '乘客姓名',
    'Order total': '订单合计',
    'Contact Information': '联系人信息',
    'Reason': '原因',
  },
  organizationalStructure: {
    'Affiliated organization': '所属组织',
    'Please enter department name': '请输入部门名称',
    'Superior department': '上级部门',
    'Please select the superior department': '请选择上级部门',
    'Note': '备\xa0\xa0\xa0\xa0注\xa0\xa0\xa0\xa0',
    'Please enter a note': '请输入备注',
    'Department Number': '部门编号',
    'Please enter department number': '请输入部门编号',
    'By department': '按部门',
    'Department Management': '部门管理',
    'Select Department': '选择部门',
    'This action will permanently delete departments(': '此作将永久删除部门（',
    '), whether to continue ?': '）, 是否继续?',
    'Deleted successfully!': '删除成功!',
    'Delete failed!': '删除失败!',
    'The highest level department cannot be deleted!': '最高级别部门不可删除!',
    'Please select the department to delete!': '请选择要删除的部门!',
    'Please fill in the department name': '请填写部门名称',
    'The new/modified department was successful!': '新增/修改部门成功!',
    'Failed to add/modify department (': '新增/修改部门失败（',
    '), please try again later !': '），请稍后重试!',
    'Department position': '部门正职',
    'Department Deputy': '部门副职',
    'Department Secretary': '部门秘书',
    'Department data initialization failed, please try again later': '部门数据初始化失败，请稍后重试',
    'Data initialization failed, please try again later': '数据初始化失败，请稍后重试'
  },
  generalManager: {
    'Description': '描述',
    'Please fill in the job title': '请填写岗位名称',
    'Up to 50 characters in length': '长度最多 50 个字符',
    'Confirm deletion of selected posts?': '确认删除选中岗位吗？',
    'Operation successful': '操作成功'
  },
  announcementManage: {
    'Please fill in the title': '请填写标题',
    'Sender': '发送人',
    'New announcement ': '新增公告',
    'Please fill in the sender': '请填写发件人',
    'Content': '内容',
    'Select file': '选择文件',
    'Only xlsx files can be uploaded, and each file does not exceed 20M ': '只能上传.xlsx文件,且每张不超过20M',
    'Please fill in the content': '请填写内容',
    'Announcement released successfully': '公告发布成功',
    'Delete announcement successful': '删除公告成功'
  },
  menu: {
    'Parent menu': '父菜单名称',
    'Menu name': '菜单名称',
    'Menu state': '菜单状态',
    'Menu Level ': '菜单等级',
    'Level One': '级别一',
    'Level Two': '级别二',
    'Level three ': '级别三',
    'Level Four': '级别四',
    'Menu type': '菜单类型',
    'Operations': '运营',
    'Supplier ': '供应商',
    'Buyer': '采购商',
    'Account Type': '账号类型',
    'Menu level': '菜单级别',
    'Node link': '节点链接',
    'Menu order': '菜单顺序',
    'Menu icon': '菜单图标',
    'Button ID': '按钮标识',
    'Please select account type': '请选择账号类型',
    'Administrator': '管理员',
    'Please select menu level': '请选择菜单级别',
    'Superior menu': '上级菜单',
    'Please select the superior menu': '请选择上级菜单',
    'New menu': '新增菜单',
    'Please fill in the menu name': '请填写菜单名称',
    'Please fill in the menu order': '请填写菜单顺序',
    'Node link cannot be empty, no connection can be filled in\\': '节点链接不可为空,无连接填写\\',
    'Edit menu': '编辑菜单',
    'New menu successful': '新增菜单成功',
    'Modified menu successfully': '修改菜单成功',
    'Level 1': '一级菜单',
    'Level 2': '二级菜单',
    'Level 3': '三级菜单',
    'Level 4': '四级菜单',
    'Level 5': '五级菜单',
    'Deleted menu successfully': '删除菜单成功',
    'Please select': '请选择'
  },
  dict: {
    'Encoding': '字典编码',
    'Dictionary name': '字典名称',
    'Open': '开启',
    'Close': '关闭',
    'Description': '描述',
    'Dictionary configuration': '字典配置',
    'Configure': '配置',
    'Dictionary list': '字典列表',
    'Data name': '数据名',
    'Data value': '数据值',
    'Sort': '排序',
    'Edit dictionary': '编辑字典',
    'The smaller the value, the higher it is': '数值越小越靠前',
    'New dictionary': '新增字典',
    'Add dictionary entry': '新增字典项',
    'Please fill in the dictionary code': '请填写字典编码',
    'Please fill in the dictionary name': '请填写字典名称',
    'Please fill in the data name': '请填写数据名',
    'Please fill in the data value': '请填写数据值',
    'New data dictionary successfully': '新增数据字典成功',
    'Modified data dictionary successfully': '修改数据字典成功',
    'Modified data dictionary status successfully': '修改数据字典状态成功',
    'Delete data dictionary data successfully': '删除数据字典数据成功',
    'Edit dictionary entry': '编辑字典项',
    'New data dictionary entry successful': '新增数据字典项成功',
    'Modified data dictionary entry successfully': '修改数据字典项成功'
  },
  oftenPassenger: {
    'Surname': '姓',
    'Given name': '名',
    'Nationality': '国籍',
    'Phone': '手机号',
    'Document type': '证件类型',
    'ID Number': '证件号码',
    'Sex': '性别',
    'Name': '姓名',
    'Man': '男',
    'Woman': '女',
    'Birthday': '生日',
    'Select date': '选择日期',
    'Passenger type': '旅客类型',
    'Please select passenger type': '请选择旅客类型',
    'Area code': '区号',
    'Expiry': '证件有效期',
    'Issuing Country': '证件签发国',
    'Please fill in the mobile phone number ': '请填写手机号',
    'Please fill in the correct mobile phone number': '请填写正确的手机号',
    'Please fill in your birthday': '请填写生日',
    'Birthday cannot be greater than current date': '生日不能大于当前日期',
    'Please fill in the valid period of the certificate': '请填写证件有效期',
    'Document expired': '证件过期',
    'ID number cannot be empty': '证件号码不能为空',
    'The format of the certificate number is incorrect': '证件号码格式不正确',
    'Please select nationality': '请选择国籍',
    'Please select the country issuing the certificate': '请选择证件签发国',
    'Please select area code': '请选择区号',
    'Last name cannot be empty': '姓不能为空',
    'Only enter English': '只能输入英文',
    'First Name cannot be empty': '名不能为空',
    'Adult': '成人',
    'Child': '儿童',
    'Infant': '婴儿',
    'Passport': '护照',
    'Please select gender': '请选择性别',
    'Please select document type': '请选择证件类型',
    'Operation failed': '操作失败',
    'Added/modified successfully': '新增/修改成功',
    'New frequent flyer': '新增常旅客',
    'Edit Frequent Flyer': '编辑常旅客',
    'Please enter ID number': '请输入证件号',
    'Please enter document type': '请输入证件类型'
  },
  wallet: {
    '应收账户': '应收账户',
    '应付账户': '应付账户',
    '现金账户': '现金账户',
    '退票冻结账户': '退票冻结账户',
    '出票冻结账户': '出票冻结账户',
    '风控冻结账户': '风控冻结账户',
    '应收金额': '应收金额',
    '应付金额': '应付金额',
    '预期结算日期': '预期结算日期',
    '结算日期': '结算日期',
    '结算周期': '结算周期',
    '操作类型': '操作类型',
    '款项类型': '款项类型',
    '操作金额': '操作金额',
    '批次号': '批次号',
    '冻结时间': '冻结时间',
    'Wallet': '钱包',
    '余额': '余额',
    '乘客人数': '乘客人数',
    '结算设置': '结算设置',
    '是否解冻': '是否解冻',
    '已解冻': '已解冻',
    '未解冻': '未解冻',
    '打款状态': '打款状态',
    '已打款': '已打款',
    '未打款': '未打款',
    '打款日期': '打款日期',
    '打款人': '打款人',
    'Deposit funds': '充值余额',
    'Total account assets': '账户总资产',
    'Note: Total account assets =(cash + frozen + red packet) amount': '注：账户总资产=(现金+冻结+红包)金额',
    'Available deposit balance': '可用充值余额',
    'Unwithdrawable amount': '不可提现金额',
    'Frozen Amount': '冻结金额',
    'red envelope balance': '红包余额',
    'type': '类型',
    'Level': '级别',
    'state': '状态',
    'query': '查询',
    'Reviewer id': '审核人id',
    'Balance': '钱包余额',
    'Withdrawn Amount': '已提现金额',
    'Freezing ratio': '冻结比例',
    'Security deposit': '保证金',
    'credit amount': '授信金额',
    'operation': '操作',
    'View': '查看',
    'DWR': '充提审核',
    '出票结算周期': '出票结算周期',
    '结算比例': '结算比例',
    '尾款结算周期': '尾款结算周期',
    '退票结算周期': '退票结算周期',
    '改签结算周期': '改签结算周期',
    '充提记录': '充提记录',
    'Please select': '请选择',
    'Exempt Auditor id': '免除审核人id',
    'Credit ratio': '授信比例',
    'Total credit balance': '总授信余额',
    'Pay password': '支付密码',
    'Bankcard': '银行卡数',
    'Please enter the recharge amount': '请输入充值金额,默认0',
    'Recharge amount must be a number with a maximum of two decimal places': '充值金额必须是数字并且小数最多两位',
    'Please fill in the amount withdrawn, default 0': '请填写已提现金额,默认0',
    'Please fill in the freeze ratio, default 0': '请填写冻结比例,默认0',
    'The amount withdrawn must be a number with a maximum of two decimal places': '已提现金额必须是数字并且小数最多两位',
    'The frozen proportion must be a number with a maximum of two decimal places': '冻结比例必须是数字并且小数最多两位',
    'Please fill in the frozen amount, default 0': '请填写冻结金额,默认0',
    'The frozen amount must be a number with a maximum of two decimal places': '冻结金额必须是数字并且小数最多两位',
    'Please fill in the total credit balance, default 0': '请填写总授信余额,默认0',
    'Please fill in margin, default 0': '请填写保证金,默认0',
    'The margin must be a number with a maximum of two decimal places': '保证金必须是数字并且小数最多两位',
    'Please fill in the credit amount, default 0': '请填写授信金额,默认0',
    'The credit amount must be a number with a maximum of two decimal places': '授信金额必须是数字并且小数最多两位',
    'Please fill in the credit scale, default 0': '请填写授信比例,默认0',
    'The credit proportion must be numerical and have a maximum of two decimal places': '授信比例必须是数字并且小数最多两位',
    'The total credit balance must be a number with a maximum of two decimal places': '总授信余额必须是数字并且小数最多两位',
    'Please fill in the payment password': '请填写支付密码',
    'Payment password must be a number': '支付密码必须是数字',
    'Please fill in the bank card number': '请填写银行卡数',
    'Card number must be a number': '银行卡数必须是数字',
    'Please select type': '请选择类型',
    'Please select level': '请选择级别',
    'Please select Status': '请选择状态',
    'Please fill in the reviewer id': '请填写审核人id',
    'Please fill in the audit Exemption id': '请填写免除审核人id',
    'Operation failed': '操作失败',
    'Added/modified successfully': '新增/修改成功',
    'New Details': '新增明细',
    'Edit Details': '编辑明细',
    'Transaction status': '交易状态',
    'Transaction type': '交易类型',
    'Income': '收入',
    'expenditure': '支出',
    'Transaction mode': '交易方式',
    'Payment method': '支付方式',
    'Audit status': '审核状态',
    'Order number': '订单号',
    'Trading hours': '交易时间',
    'Transaction No': '交易流水号',
    'Third party Transaction No': '第三方交易流水号',
    'Transaction Amount': '交易金额',
    'Deposit balance': '充值余额',
    'Operator': '操作人',
    'Original order Number': '原始订单号',
    'Third-Party Payee Id': '第三方收款方Id',
    'Third party Account': '第三方收款帐号',
    'Remarks': '备注',
    'Review': '审核',
    'isAudit': '已审核',
    'Transaction name': '交易名称',
    'Credit repayment status': '授信还款状态',
    'third-party payer Id': '第三方付款方Id',
    'third-party Payment Account': '第三方付款帐号',
    'Third party unrefunded amount': '第三方未退金额',
    'Please fill in the transaction amount': '请填写交易金额',
    'The transaction amount must be a number with a maximum of two decimal places': '交易金额必须是数字并且小数最多两位',
    'The third party unreturned amount must be a number with a maximum of two decimal places': '第三方未退金额必须是数字并且小数最多两位',
    'Third party payee Id must be numeric': '第三方收款方Id必须是数字',
    'Third Party payer Id must be numeric': '第三方付款方Id必须是数字',
    'Reviewer id cannot be empty': '审核人id不能为空',
    'Reviewer id must be a number': '审核人id必须是数字',
    'in trade': '交易中',
    'Transaction success': '交易成功',
    'deal failed': '交易失败',
    'Please fill in the transaction serial number': '请填写交易流水号',
    'Please select mode': '请选择方式',
    'Please select Audit status': '请选择审核状态',
    'Please select credit repayment status': '请选择授信还款状态',
    'Please select Transaction type': '请选择交易类型',
    'Please fill in the original order number': '请填写原始订单号',
    'Please select Transaction status': '请选择交易状态',
    'Please select trading time': '请选择交易时间',
    'Please fill in operator': '请填写操作人',
    'Please select operation type': '请选择操作类型',
    'Audit details': '审核明细',
    'accountId': '付款账号',
    'Add wallet': '新增钱包',
    'Return': '返回',
    'Details': '明细',
    'Recharge': '充值',
    'Withdrawal': '提现',
    'Recharge method': '充值方式',
    'Recharge amount': '充值金额',
    'Payment account name': '付款账户名称',
    'Payment serial number': '付款流水号',
    'Withdrawal amount': '提现金额',
    'Receiving account name': '收款账号名称',
    'Receiving account number': '收款账号',
    'Please select the recharge method': '请选择充值方式',
    'Please enter account name': '请输入账户名称',
    'Please enter account number': '请输入账号',
    'Please enter serial number': '请输入流水号',
    'Account Name': '账户名称',
    'Account number': '账号',
    'Pass': '通过',
    'Reject': '拒绝',
    'Are you sure to reject it?': '确定要拒绝吗？'
  },
  orderPolicy: {
    'Original Tax': '原始税费',
    'Sales Price Formula': '销售价计算公式',
    'Supplier Fare Formula': '供应商票面计算公式',
    'Supplier Tax Formula': '供应商税费计算公式',
    'Baggage Type': '行李类型',
    'Baggage Number': '行李件数',
    'Baggage Weight': '行李重量',
    'Route': '航线',
    'No matching policy': '未匹配到政策',
    'Adult Count': '成人人数',
    'Child Count': '儿童人数',
    'Total order price': '订单总价',
    'Supplier Fare': '供应商票面',
    'Supplier Tax': '供应商税费',
    'Total Supplier Fare': '总供应商票面',
    'Total Supplier Tax': '总供应商税费',
    'Policy Start Date': '政策开始日期',
    'Policy End Date': '政策结束日期',
    'Policy effective period': '政策有效期',
    'Countrys two-letter code': '国家二字码',
    'Example:FR/DE': '例:FR/DE',
    'People': '人',
    'The rebate supports both positive and negative values,Entering a positive value indicates a discount from the original price,while a negative value represents a price increase, For example:Inputting a rebate value of ‌10‌ adjusts the price to ‌90%‌ of the original；Inputting a rebate value of ‌10‌ adjusts the price to ‌90%‌ of the original': '返点支持输入正负数，输入正数代表在原价格基础上减价，输入负数代表在原价格基础上加价。例如：输入返点值为10时，调价为90%；输入返点值为-10，则调价为110%。',
    'Adult rebate': '成人返点',
    'Child rebate': '儿童返点',
    'Adult price increase': '成人留钱',
    'Child price increase': '儿童留钱',
    'Adult Tax rebate': '成人税返点',
    'Child Tax rebate': '儿童税返点',
    'Adult Tax increase': '成人税留钱',
    'Child Tax increase': '儿童税留钱',
    'Applicable fare basis': '仅适用于以下运价基础',
    'Lowest fare': '最低票价',
    'Highest fare': '最高票价',
    'Example: Suppose the travel date is filled in as 5/1 - 5/30, and the `Includes travel days` is set to 1-7, This means that the price adjustment only applies to tickets for travel dates that fall within the 7-day period starting from `the current day + 1` to `the current day + 7`, This 7-day window will be extended day by day until the calculated date falls outside the specified travel date range': '例：假设旅行日期填5/1-5/30,此时填写旅行适用天数为1-7，则表示该调价只卖当天时间+1到当天时间+7的7天旅行日期的票，每天顺延直到计算后的日期不在旅行日期范围内为止。',
    'Includes travel days': '旅行适用天数',
    'Identity': '身份',
    'Baggage Allowance': '指定行李额',
    'When left blank, it matches all flights, When set to 0, it matches all flights without baggage': '不填时匹配所有航班，适用为0匹配所有不带行李航班',
    'Exclude transit airports': '不适用转机机场',
    'Included': '适用',
    'Excluded': '除外',
    'Passenger type': '乘客类型',
    'Origin airport': '始发机场',
    'Arrival airport': '到达机场',
    'Transit airport': '中转机场',
    'Example:1/3/5': '例如:1/3/5',
    'Included flight schedule': '适用班期',
    'Exclude route': '不适用航线',
    'Exclude flights': '不适用航班',
    'Included flights': '适用航班',
    'Exclude travel date': '去除旅行日期',
    'Travel date': '旅行日期',
    'Stay duration': '停留天数',
    'Sales date': '销售日期',
    'Working hours': '工作时间',
    'Example:1-100, the larger the value, the higher the weight':'例如: 1-100,数值越大,权重越高',
    'Weight': '权重',
    'Stop sell time': '终止销售小时',
    'The stop sell time for this route is xx hours before departure': '航班起飞前 xx 小时禁止销售该航班',
    'All airports: ALL': '所有机场填:ALL',
    'Publication of Tariff Policy': '公布运价政策',
    'Private Configuration Policy': '私有配置政策',
    'B2T policy': 'B2T政策',
    'Travel type': '行程类型',
    'all': '全部',
    'Airlines': '航空公司',
    'Policy Code': '政策编码',
    'Point of departure': '出发地点',
    'arrival point': '到达地点',
    'Policy source': '政策来源',
    'Policy type': '航程类型',
    'Policy state': '政策状态',
    'Policy State': '政策状态',
    'Cabin': '舱位',
    'Invoicing OFFICE': '开票OFFICE号',
    'Automatic issue': '是否自动出票',
    'No Tickets Last Week': '上周没出票',
    'Start time': '开始时间',
    'End time': '结束时间',
    'End time cannot be less than start time': '结束时间不能小于开始时间',
    'ticket type': '票本类型',
    'Policy Alias': '政策别名',
    'Change Encoding': '是否换编码',
    'Same GDS code': '相同GDS编码导入',
    'Document Number': '文件编号',
    'Fare Lower': '票面略低',
    'Policy id/Policy Type': '政策编号/航程类型',
    'One way': '单程',
    'Round trip': '往返',
    'One way/round trip': '单程/往返',
    'Flight type': '航班类型',
    'Start & End': '起止日期',
    'To': '至',
    'return to': '返程延用至',
    'Originating': '始发',
    'arrive': '到达',
    'Deduction rate': '扣率',
    'Quick Fix': '快速修改',
    'state': '状态',
    'Automatic ticketing': '自动出票',
    'Last date': '最后日期',
    'Modify': '修改',
    'Enable': '启用',
    'Suspend': '挂起',
    'Agency fee': '代理费',
    'Reward': '奖励',
    'Billing fee': '开票费',
    'one-way direct reduction': '单程直减',
    'Round trip subtraction': '往返直减',
    'expiry date': '去程有效期',
    'Policy valid period': '政策有效期',
    'return expiry date': '返程有效期',
    'invoicing period': '开票有效期',
    'Method of issue': '出票方式',
    'par limit is higher than': '票面限制高于',
    'Appointed agency fee': '指定代理费',
    'Priority BSP': '优先BSP',
    'priority BOP': '优先BOP',
    'Designated baggage amount': '指定行李额',
    'Settlement method': '结算方式',
    'Please fill in the agency fee, default 0': '请填写代理费，默认0',
    'The agency fee must be a number with a maximum of two decimal places': '代理费必须是数字并且小数最多两位',
    'Please fill in reward, default 0': '请填写奖励，默认0',
    'Reward must be a number with a maximum of two decimal places': '奖励必须是数字并且小数最多两位',
    'Please fill in the billing fee, default 0': '请填写开票费，默认0',
    'Billing fee must be a number with a maximum of two decimal places': '开票费必须是数字并且小数最多两位',
    'Please fill in one-way direct deduction, default 0': '请填写单程直减，默认0',
    'One-way direct subtraction must be a number with a maximum of two decimal places': '单程直减必须是数字并且小数最多两位',
    'Please fill in round trip deduction, default 0': '请填写往返直减，默认0',
    'Round trip straight subtraction must be a number with a maximum of two decimal places': '往返直减必须是数字并且小数最多两位',
    'Face limit must be a number': '票面限制必须是数字',
    'The appointed agency fee must be a number with a maximum of two decimal places': '指定代理费必须是数字并且小数最多两位',
    'Specified baggage allowance must be a number': '指定行李额必须是数字',
    'domestic origin': '国内始发',
    'Direct SOTO': '直飞SOTO程',
    'Domestic origin Add-On': '国内始发Add-On',
    'Foreign origin Add-On': '国外始发Add-On',
    'From abroad to abroad': '境外到境外',
    'domestic originating transit': '国内始发中转',
    'foreign originating transit': '国外始发中转',
    'offshore offshore': '境外境外境外',
    'outside China': '境外境内境外',
    'Globe to globe': '全球到全球',
    'Global to global': '全球中转全球',
    'System hang': '系统挂起',
    'Unusable': '无法使用',
    'Pending review': '待审核',
    'Audit failed': '审核失败',
    'under review': '正在审核',
    'Offshore electron': '境外电子',
    'No need to change code': '无需换编码',
    'change code issue': '换编码出票',
    'Big ticket issue (no need to change)': '大编出票(无需换编)',
    'Big ticket issue (need to change)': '大编出票(需换编)',
    'No need to change the arrangement out of the ticket (no place outside)': '无需换编出票(外放无位)',
    'Original draft': '原编出票',
    'Change out of ticket': '换编出票',
    'The same region configuration can be originally issued': '相同地区配置可原编出票',
    'Yes': '是',
    'No': '否',
    'Cash': '现金',
    'Check': '支票',
    'Credit card': '信用卡',
    'New policy': '新增政策',
    'NDC(Foreign Airlines)': 'NDC(外航)',
    'official website type': '官网类型',
    'Official website of B': 'B端官网',
    'official website of C': 'C端官网',
    'C terminal website': 'C端官网网址',
    'Invoicing GDS': '开票GDS',
    'Place of bill': '开票地',
    'Ticket rescheduling': '出票改期',
    'No time difference': '出票改期无时差',
    'Time difference': '仅改期有时差',
    'Audit after 9am schedul ': '9点后审核改期',
    'Audit after 15pm schedul ': '15点后审核改期',
    'Audit after 16pm schedul': '16点后审核改期',
    'Audit after 20pm schedul ': '20点后审核改期',
    '24h ahead of schedule': '改期提前24小时',
    '48h ahead of schedule': '改期提前48小时',
    'Holiday sales': '节假日可售后',
    'Applicable airlines': '同时适用航司',
    'Unified group airlines': '统一集团的航司',
    'Example:MU/CA': '例:MU/CA',
    'Supplier OFFICE': '供应商OFFICE号',
    'Example :SHA889': '例:SHA889',
    'Invoicing PCC': '开票PCC号',
    'Example53': '例:5.3',
    'Example :200': '例:200',
    'Extra Refund Service': '另加退票费服务',
    'There is a refund service charge': '有退票服务费',
    'Refund Service': '退票费服务',
    'Example:3': '例:3',
    'Airlines & Express GDS Policy': '航司普发GDS',
    'Protocol type of policy': '政策的协议类型',
    'Please enter': '请输入',
    'Advance issuance days': '提前开票天数',
    'Minimum stay days': '最短停留天数',
    'usual billing time': '平时开票时间',
    'Maximum stay days': '最长停留天数',
    'Saturday billing time': '星期六开票时间',
    'No bill': '不开票',
    'Sunday billing time': '星期日开票时间',
    'Auto Ticketing Special Settings': '自动出票特殊设置',
    'Please enter Airport 3 code': '请输入机场三字码',
    'Transit': '中转',
    'Example :A/B/C': '例:A/B/C',
    'Not applicable to connecting airports': '不适用转机机场',
    'Applicable age': '适用年龄',
    'Optional': '不限制可不填',
    'Year': '周岁',
    'Applicable number': '适用人数',
    'Man': '人',
    'day': '天',
    'Child ticket': '儿童票',
    'Child and adult congruence': '儿童与成人一致',
    'Open no reward': '可开无奖励',
    'Do not open': '不可开',
    'Specify reward': '指定奖励',
    'Do not open without agency fee': '不可开无代理费',
    'Children do not open': '儿童不单开',
    'Children do not enjoy direct deductions': '儿童不享受直减',
    'Baby ticket': '婴儿票',
    'Additional service charge': '加收手续费',
    'Large code issue (no need to change the encoding)': '大编码出票(无需换编)',
    'Large code issue (need to Change Encoding)': '大编码出票(需换编)',
    'No bit no ticket (change when there is a bit outside)': '无位不换出票(外放有位时换编)',
    'Auto change': '自动换编',
    'Does no bit accept short editing': '无位是否接受做空编',
    'Change code does not authorize': '换编码不授权',
    'Specify Office number location': '指定Office号定位',
    'original code issue': '原编码出票',
    'Not applicable': '不适用',
    'Destination notch': '目的地缺口程',
    'Gaps in applicable policies': '适用政策内缺口',
    'Gap in applicable country': '适用国家内缺口',
    'Designated country': '指定国家',
    'unavailable': '不可用',
    'Shared flight': '共享航班',
    'Operating flights': '运营航班',
    'No reward for the whole journey': '全程无奖励',
    'Full designated reward': '全程指定奖励',
    'Shared segment no reward': '共享段无奖励',
    'Shared segment specified reward': '共享段指定奖励',
    'Partial sharing required for review': '部分共享需供审',
    'Do not open with sharing': '含共享不开',
    'Give all rewards': '给全部奖励',
    'Reward all when shared with the following airlines only': '仅和以下航司间共享时给全部奖励',
    'Example :FM or FM/AF(separated by/for multiple airlines)': '例:FM或FM/AF(多个航司时用/分隔)',
    'SPA/ combined transport gives all rewards': 'SPA/联运给全部奖励',
    'If :CZ/HU': '如:CZ/HU',
    'Air Department': '航司',
    'such as :PVG/SHA/CN': '如:PVG/SHA/CN',
    'If :CN/HK': '如:CN/HK',
    'Must be the first paragraph': '必须是首段',
    'Any segment contains': '任意段包含',
    'Allow mixing 1/2RT': '允许混舱1/2RT',
    'Only the same document number can be mixed 1/2RT': '相同文件编号才可混舱1/2RT',
    'Tariff base to be consistent': '运价基础需一致',
    'Warm reminder: Check the box slightly lower will reduce the chance of the policy being selected, please verify the policy!': '温馨提醒：勾选票面略低会减少政策被选中的机会，请核实政策!',
    'TOUR CODE contains': 'TOUR CODE中含',
    'For example :CHN5300F/*(* denotes any tourcode)': '如:CHN5300F/*(*表示任意tourcode)',
    'No agency fee': '无代理费',
    'No reward': '无奖励',
    'Only applies to the following TOUR CODE': '仅适用于以下TOUR CODE',
    'CHN5300F/SHAR001 or CHN* (beginning of CHN) or *F01 (ending of F01) or 8HN53* (baohan NH53)': 'CHN5300F/SHAR001或CHN* (CHN开头) 或*F01 (F01结尾) 或8HN53* (baohan NH53)',
    'Does the agency fee apply when the system COMMISSION is 0': '系统COMMISSION为0时代理费是否适用',
    'Round-trip must include accommodation': '往返必须包含舱位',
    'high space, such as: H/B/E/M/D/C/P/Y/M/F': '高舱位,如:H/E/M/B/D/C/P/Y/J/F',
    'Face value (excluding tax)': '票面(不含税)',
    'above': '高于',
    'Invokes only if it is greater than or equal to the amount': '大于等于该金额才开发票',
    'below': '低于',
    'Invoicing is required for less than or equal to the amount': '小于等于该金额才开发票',
    'included in tariff base': '运价基础中含',
    'Format :PR/WX/WR': '格式:PR/WX/WR',
    'Only applicable to the following tariff bases': '仅适用于以下运价基础',
    'Q3M6CN/A3M5TR or Q3*(beginning with Q3M) or *CN(ending with CN) or *R6R*(including R6R) or J(for single base rate only)': 'Q3M6CN/A3M5TR或Q3*(Q3M开头)或*CN(CN结尾)或*R6R*(包含R6R)或J(只适用于单个基础运价)',
    'outbound applicable flight': '去程适用航班',
    'Example:CA123/CA234/TG001-TG999': '例:CA123/CA234/TG001-TG999',
    'return applicable Flight': '返程适用航班',
    'Not applicable Flights': '不适用航班',
    'Format :CA123/CA234/CA7*/CA27*/TG001-TG999/ No limit': '格式:CA123/CA234/CA7*/CA27*/TG001-TG999/不限制可不填',
    'Not applicable route': '不适用航线',
    'Example:PVG-BKK/PEK-LHR': '格式:JP-JP/PVG-JP/CN-ICN',
    'Go cycle not applicable': '去程不适用周期',
    'Monday': '周一',
    'Tuesday': '周二',
    'Wednesday': '周三',
    'Thursday': '周四',
    'Friday': '周五',
    'Saturday': '周六',
    'Sunday': '周日',
    'Return not applicable period': '返程不适用周期',
    'outbound date not applicable': '去程不适用日期',
    'Return No applicable Date': '返程不适用日期',
    'Other remarks': '其他备注',
    'reset': '重置',
    'Confirm': '确定',
    'Refund service fee must be a number with a maximum of two decimal places': '退票服务费必须是数字并且小数最多两位',
    'Baggage allowance must be a number': '行李额必须是数字',
    'Days must be numbers': '天数必须是数字',
    'Abacus or Sabre': 'Abacus或Sabre',
    'International Student': '留学生',
    'Immigrant': '移民',
    'Labour': '劳工',
    'Seafarer': '海员',
    'Youth': '青年',
    'Old age': '老年',
    'to visit family': '探亲',
    'Hong Kong, Macao and Taiwan': '港澳台',
    'Foreign': '外籍',
    'non-Chinese name': '非汉字姓名',
    'Add-On': 'Add-On',
    'offshore transit': '境外中转',
    'OPEN': 'OPEN',
    'Tripartite Agreement': '三方协议',
    'Set of ticket': '套票',
    'whole lump': '整团',
    'Little tuan': '小团',
    'Please select Policy type': '请选择政策类型',
    'Please select the ticket type': '请选择票本类型',
    'Please select website type': '请选择官网类型',
    'Please select billing type': '请选择开票类型',
    'Please reschedule': '请选择出票改期',
    'Please select': '请选择',
    'Please fill in the airline': '请填写航空公司',
    'Please fill in suppliers OFFICE number ': '请填写供应商OFFICE号',
    'Please fill in the invoice OFFICE number': '请填写开票OFFICE号',
    'Please fill in the drawing PCC number': '请填写开票PCC号',
    'Please select time': '请选择时间',
    'website': '网址',
    'Please enter the minimum value': '请填写最少人数',
    'Please enter the maximum value': '请填写最多人数',
    'Number of people must be numbers': '人数必须是数字',
    'Minimum number of people applicable': '适用人数最少1人',
    'Applicable to up to 9 people': '适用人数最多9人',
    'Minimum number of people up to 8 people': '最少人数最多8人',
    'Maximum number of people Minimum 2 people': '最多人数最少2人',
    'The minimum number of people cannot exceed the maximum number of people': '最少人数不能超过最大人数'
  },
  adminLang: {
    'New': '新增',
    'Status': '状态',
    'Query': '查询',
    'Reset': '重置',
    'Number of threads': '线程数',
    'Proxy ip': '代理ip',
    'Remarks': '备注',
    'Creation time': '创建时间',
    'Operation': '操作',
    'Disable': '禁用',
    'Edit': '编辑',
    'Are you sure to delete?': '确定删除吗？',
    'Delete': '删除',
    'Log': '日志',
    'Cancel': '取消',
    'Save': '保存',
    'Please fill in the number of threads': '请填写线程数',
    'Import': '导入',
    'Reptile Number': '爬虫编号',
    'Airline': '航司',
    'Yes': '是',
    'No': '否',
    'Edit policy crawler configuration': '编辑政策爬虫配置',
    'Task start time': '任务开始时间',
    'Task end time': '任务结束时间',
    'Click to upload': '点击上传',
    'Only xlsx files can be uploaded': '只能上传xlsx文件',
    'Download Template': '下载模板',
    'Please fill in the crawler number': '请填写爬虫编号',
    'Please fill in the airline': '请填写航司',
    'Please select task start time': '请选择任务开始时间',
    'Please select task end time': '请选择任务结束时间',
    'Added policy crawler configuration': '新增政策爬虫配置',
    'Added/modified policy crawler configuration successful': '新增/修改政策爬虫配置成功',
    'Please select airline': '请选择航司',
    'Are you sure to export the data?': '确定导出数据吗？',
    'Tip': '提示',
    'OK': '确定',
    'Please select the uploaded file': '请选择上传的文件',
    'Deleted successfully': '删除成功',
    'Please fill in the mobile phone number': '请填写手机号',
    'Please fill in the correct mobile phone number': '请填写正确的手机号',
    'Modify': '修改',
    'Status Success': '状态成功',
    'Status failed': '状态失败',
    'Level': '级别',
    'Ready': '准备就绪',
    'Running': '正在运行',
    'Disabled': '已禁用',
    'Task Code': '任务代码',
    'Task name': '任务名称',
    'Task class name': '任务类名',
    'Task Cron/Update Cron': '任务Cron/更新Cron',
    'Parameter': '参数',
    'Task timeout': '任务超时时间',
    'Number of failed retries': '失败重试次数',
    'Are you sure it is enabled?': '确定启用吗？',
    'Enable': '启用',
    'Are you sure it is disabled?': '确定禁用吗？',
    'New task scheduling': '新增任务调度',
    'Edit Task Scheduling': '编辑任务调度',
    'Mission Cron': '任务Cron',
    'Cron to perform the task': '执行任务的Cron',
    'Update Cron': '更新Cron',
    'Cron that regularly updates task content': '定时更新任务内容的Cron',
    '0 is the unlimited timeout time, unit: minutes': '0为不限制超时时间，单位：分钟',
    '0 is the number of unlimited retries': '0为不限制重试次数',
    'Please fill in the task code': '请填写任务代码',
    'Please fill in the task name': '请填写任务名称',
    'Please fill in the task class name': '请填写任务类名',
    'Please fill in the task Cron': '请填写任务Cron',
    'Please enter the correct Cron expression': '请输入正确的Cron表达式',
    'Please fill in the update Cron': '请填写更新Cron',
    'Please fill in the task timeout time': '请填写任务超时时间',
    'Please fill in the number of failed retries': '请填写失败重试次数',
    'Task Scheduling Log -': '任务调度日志 - ',
    'Please enter a positive integer': '请输入正整数',
    'New task scheduling successful': '新增任务调度成功',
    'Modified task scheduling successful': '修改任务调度成功',
    'Enabled successfully': '启用成功',
    'Disable success': '禁用成功',
    'Delete task scheduling successful': '删除任务调度成功',
    'Valid': '有效',
    'Invalid': '无效',
    'Export': '导出',
    'Channel': '渠道',
    'Crawl type': '爬取类型',
    'Flight date range': '航班日期范围',
    'Route range': '航线范围',
    'Request interval': '请求间隔',
    'Whether to cache/warehousing': '是否缓存/入库',
    'Task time range': '任务时间范围',
    'Create/last update time': '创建/最后更新时间',
    'Total': '全量',
    'Increment': '增量',
    'Class': '舱位',
    'Incremental number of seats': '增量座位数',
    'Crawling space': '爬取舱位',
    'Multiple People/Separation': '多个人/分隔',
    'Flight date start number': '航班日期起始数',
    'Start from 1, the day is 1': '从1开始，当天为1',
    'Number of flight date ends': '航班日期结束数',
    'End number -1 is the end date': '结束数-1为结束日期',
    'Route start number': '航线起始数',
    '0 for all': '0为全部',
    'Number of route ends': '航线结束数',
    'Unit: milliseconds': '单位：毫秒',
    'Increase the number of people when inquiring': '查询时增加人数',
    'Whether to cache': '是否缓存',
    'Cache address': '缓存地址',
    'Cache time': '缓存时间',
    'Unit: minutes': '单位：分钟',
    'Whether to put into storage': '是否入库',
    'Delete type': '删除类型',
    'Delete by day': '按天删除',
    'Delete by route': '按航线删除',
    'Warehousing increase time': '入库增加时间',
    'Please select channel': '请选择渠道',
    'Please select crawl type': '请选择爬取类型',
    'Please fill in the incremental number of seats': '请填写增量座位数',
    'Please fill in the crawling space': '请填写爬取舱位',
    'Please fill in the starting number of the flight date': '请填写航班日期起始数',
    'Please fill in the number of flight date ends': '请填写航班日期结束数',
    'Please fill in the starting number of routes': '请填写航线起始数',
    'Please fill in the number of route ends': '请填写航线结束数',
    'Please fill in the request interval': '请填写请求间隔',
    'Please fill in the inquiry to increase the number of people': '请填写查询时增加人数',
    'Please choose whether to cache': '请选择是否缓存',
    'Please fill in the cache address': '请填写缓存地址',
    'Please fill in the cache time': '请填写缓存时间',
    'Please select whether to put into storage': '请选择是否入库',
    'Please select deletion type': '请选择删除类型',
    'Please fill in the warehousing increase time': '请填写入库增加时间',
    'Modified status successfully': '修改状态成功',
    'Failed to modify state': '修改状态失败',
    'The number of flight date ends must be greater than the number of flight date starts': '航班日期结束数必须大于航班日期起始数',
    'Airline configuration not found': '未查询到航司配置',
    'Policy crawler log -': '政策爬虫日志 - ',
    'Wrong oh, this is an error message': '错了哦，这是一条错误消息',
    'Shop': '店铺',
    'Store Code': '店铺代码',
    'Occupy space': '占座舱位',
    'Pause time': '暂停时间',
    'Abnormal airline code': '异常航司代码',
    'Exception policy code': '异常政策代码',
    'Filter Policy Code': '过滤政策代码',
    'Creation time/modification time': '创建时间/修改时间',
    'Multiple times | separated, including judgments respectively': '多个时|分隔,分别包含判断',
    'Do not account for childrens policy code': '不占儿童政策代码',
    'Active cache interface': '主动缓存接口',
    'Cache name': '缓存名',
    'Cache URL': '缓存URL',
    'Added seat-occupying crawler configuration': '新增占座爬虫配置',
    'Please fill in the active cache interface': '请填写主动缓存接口',
    'Please fill in the cache name': '请填写缓存名',
    'Please fill in the cache URL': '请填写缓存URL',
    'Deleted data successfully': '删除数据成功',
    'Added success Check the result later': '新增成功稍后查看结果',
    'Occupy crawler log -': '占座爬虫日志 - ',
    'Payment channel configuration not found': '未查询到付款渠道配置',
    'Please select a level': '请选择级别',
    'Module': '模块',
    'Event': '事件',
    'Source': '来源',
    'Title': '标题',
    'Operator': '操作人',
    'Start date': '开始日期',
    'End date': '结束日期',
    'Clear data': '清除数据',
    'Content': '内容',
    'Time': '时间',
    'Operate Time': '操作时间',
    'Type': '类型',
    'Confirm that the data is cleared according to the query conditions?': '确认按照查询条件清除数据吗？',
    'Start and end dates cannot be empty': '开始日期和结束日期不能为空',
    'End date must be greater than or equal to start date': '结束日期必须大于等于开始日期',
    'The difference between the start date and the end date cannot be greater than seven days': '开始日期和结束日期相差不能大于七天',
    'Module configuration not found': '未查询到模块配置',
    'Event configuration not queried': '未查询到事件配置',
    'Airline cannot be empty': '航司不能为空',
    'Bar data': '条数据',
    'Query cache': '查询缓存',
    'Sync cache': '同步缓存',
    'Cache key': '缓存key',
    'Confirm sync cache?': '确认同步缓存吗？',
    'Synchronization cache successful': '同步缓存成功',
    'Merchant Name': '商家名称',
    'Merchant Code': '商家编码',
    'Merchant Type': '商家类型',
    'Supplier': '供应商',
    'Purchaser': '采购商',
    'Open': '开启',
    'Close': '关闭',
    'Enterprise Type': '企业类型',
    'Full name of the company': '公司全称',
    'Company abbreviation': '公司简称',
    'Company Code': '公司编码',
    'Address': '地址',
    'Contact person': '联系人',
    'Contact FirstName': '联系人名',
    'Contact LastName': '联系人姓',
    'Contact number': '联系电话',
    'Contact email': '联系人邮箱',
    'Contact tel': '联系人区号',
    'Authorization time': '授权时间',
    'Permission Control': '权限控制',
    'Select date': '选择日期',
    'Select time': '选择时间',
    'Permission': '权限选择',
    'Home': '首页',
    'Please select at least one type': '请至少选择一个类型',
    'Please select at least one level': '请至少选择一个等级',
    'Please select at least one state': '请至少选择一个状态',
    'Please fill in the full name of the company': '请填写公司全称',
    'Please fill in the company abbreviation': '请填写公司简称',
    'Please fill in the company code': '请填写公司编码',
    'Please fill in the company address': '请填写公司地址',
    'Please fill in the contact person name': '请填写联系人姓名',
    'Please fill in the contact email': '请填写联系人邮箱',
    'Please fill in the contact area code': '请填写联系人区号',
    'Please select a date': '请选择日期',
    'Please select time': '请选择时间',
    'New merchant': '新增商家',
    'Agent Management': '代理商管理',
    'Add/modify merchant successfully': '新增/修改商家成功',
    'Edit Merchant': '编辑商家',
    'Added/modified merchant successfully!': '新增/修改商家成功！',
    'Deleted company data successfully': '删除公司数据成功',
    'admin': '运营',
    'Merchant': '商家',
    'Real name': '真实姓名',
    'Login name': '登录名',
    'Contact information': '联系方式',
    'Job number': '工号',
    'Administrator': '管理员',
    'Role name': '角色名称',
    'Department Name': '部门名称',
    'Job Title': '岗位名称',
    'Mailbox': '邮箱',
    'Gender': '性别',
    'Reset-pw': '重置密码',
    'Login must be a letter or number': '登录名必须是字母或数字',
    'Password': '密码',
    'Confirm password': '确认密码',
    'Male': '男',
    'Female': '女',
    'Confidentiality': '保密',
    'Department': '部门',
    'Please select a department': '请选择部门',
    'Post': '岗位',
    'Please select a position': '请选择岗位',
    'Character name': '角色名',
    'Please select a role': '请选择角色',
    'Normal': '正常',
    'Security Question': '密保问题',
    'Secret Answer': '密保答案',
    'Please fill in the account number': '请填写账号',
    'Account number must be a combination of numbers and letters': '账号必须是由数字和字母组合',
    'Please fill in the password': '请填写密码',
    'Please fill in the password again': '请再次填写密码',
    'The password filled in twice is inconsistent!': '两次填写密码不一致!',
    'Please fill in your real name': '请填写真实姓名',
    'Please fill in the job number': '请填写工号',
    'Please select a role name': '请选择角色名称',
    'Please select a department name': '请选择部门名称',
    'Please fill in the job title': '请填写岗位名称',
    'Deleted': '已删除',
    'Are you sure the reset password is 123456 ?': '确定重置密码为123456吗？',
    'Reset password to 123456': '已重置密码为123456。',
    'Failed to reset password': '重置密码失败，',
    'Operation failed': '操作失败',
    'The mailbox format is incorrect': '邮箱格式不正确',
    'Inconsistent password filled in twice': '两次填写密码不一致',
    'New account': '新增账号',
    'Edit account': '编辑账号',
    'Agent account management': '代理商账号管理',
    'Please select the payment time limit': '请选择支付时间限制',
    'Payment time limit': '支付时间限制',
    'Ticketing time limit': '出票时间限制',
    'Refund confirmation limit': '退票确认时间限制'
  },
  zsCurrencyList: {
    'Country name': '国家/地区名称',
    'Please enter country name': '请输入国家/地区名称',
    'Currency name': '货币名称',
    'Currency symbol': '货币符号',
    'Currency Code': '现通行货币代码',
    'Bank of China Exchange Rate': '中国银行汇率',
    'Middle Rate': '中间市场汇率',
    'Custom Exchange Rate': '自定义汇率',
    'Status': '状态',
    'Update time': '更新时间',
    'Central Bank': '中央银行',
    'URL': '网址'
  },
  flight: {
    '未知': '未知',
    'Search again': '页面停留时间过长，机票价格或已更改，请重新搜索',
    'Subject to airline regulations': '以航司规定为准',
    'Click ‘BOOK’ to view the detailed rules': '点击“预订”到订单填写页查看详细规则',
    'For more information, please visit the homepage': '更多信息请至首页查询',
    'Unlimited': '不限',
    'Not included': '无信息',
    'piece': '件',
    'size': '尺寸',
    'weight': '重量',
    'Carry-on': '手提行李',
    'Checked': '托运行李',
    'B2O': '渠道分销',
    'OSS': '渠道专享',
    'B2O_QNS': '渠道极速出票',
    'FPP_F': '头等舱',
    'CFP': '特价票',
    'BPP_B': '商务舱',
    'FXP': '特价票',
    'B2O_NMP': '旗舰店',
    'B2O_CPC': '旗舰店',
    'B2O_ASA': '金牌产品',
    'COB': '拼接报价',
    'B2O_JWP': '超值低价',
    'B2O_LPG': '优选',
    'Return and change': '退改签',
    'Baggage Allowance': '行李额',
    'Reimbursement voucher': '报销凭证',
    'Reservation Instructions': '预订须知',
    'Fare': '票价',
    'Tax': '税费',
    'Re-search flight': '重新搜索航班',
    'Short-term visa For travelers with short-term visas such as business tourism, it is recommended that you directly buy a return ticket or hold a return ticket to avoid being unable to go through the boarding and exit procedures': '短期签证：持商务、旅游等短期签证的旅客，建议您直接购买往返程票或持有返程票，以免无法办理乘机和出境手续。',
    'Passengers with Chinese mainland passports and 10-year valid B1B2 or B1/B2 US visas should confirm that they have registered for the EVUS Visa Update Electronic System before traveling to avoid being unable to enter or transit through the United States': '持中国大陆护照并获10年有效B1、 B2或B1/B2美国签证的旅客，出行前请确认已登记EVUS（签证更新电子系统），以免无法入境或过境美国。',
    'Passenger': '乘机人',
    'PassengerType': '乘客类型',
    'Adult': '成人',
    'Age 12 and older': '12岁及以上',
    '2~12 years old (excluding)': '2岁~12岁(不含)',
    'Please select passenger gender': '请选择乘客性别',
    'Male': '男',
    'Female': '女',
    'Last name': '姓(Surname)',
    'First name': '名(Given Name)',
    'Nationality': '国籍',
    'Select date of birth': '选择出生日期',
    'Please select ID type': '请选择证件类型',
    'Passport': '护照',
    'Hong Kong and Macau Pass': '港澳通行证',
    'Taiwan Travel Permit for Mainland Residents': '大陆居民往来台湾通行证',
    'ID Number': '证件号',
    'Select the valid period': '选择证件有效期',
    'Telephone No': '联系电话',
    'Children': '儿童',
    'Gender': '性别',
    'Contact person': '联系人',
    'Email for emergency contact, please fill in correctly': 'Email(用于紧急联络，请正确填写)',
    'Next step': '下一步',
    'Order Confirmation': '订单确认',
    'Date of birth': '生日',
    'Pay': '去支付',
    'day': '天',
    'hour': '时',
    'minute': '分',
    'seconds': '秒',
    'Place of issue': '证件签发国',
    'Please enter passenger last name': '请输入乘客姓',
    'Please enter passenger name': '请输入乘客名',
    'Please enter passenger nationality': '请输入乘客国籍',
    'Please select Passenger Document Type': '请选择乘客证件类型',
    'Please enter passenger Credential No': '请输入乘客证件号',
    'Please select the issuing country of the document': '请输入证件签发国',
    'Please select the valid period of the passenger document': '请选择乘客证件有效期',
    'Please select passenger birthday': '请选择乘客生日',
    'Passengers must be over 12 years old': '乘客年龄必须大于12岁',
    'Please enter the passengers mobile phone number ': '请输入乘客手机号',
    'Please enter child passenger last name': '请输入儿童乘客姓',
    'Please enter child passenger name': '请输入儿童乘客名',
    'Please select child passenger gender': '请选择儿童乘客性别',
    'Please enter the nationality of the child passenger': '请输入儿童乘客国籍',
    'Please select Child Passenger Document Type': '请选择儿童乘客证件类型',
    'Please enter Child Passenger Credential No': '请输入儿童乘客证件号',
    'Please select the valid period of the child passenger document': '请选择儿童乘客证件有效期',
    'Please select Child Passenger Birthday': '请选择儿童乘客生日',
    'Please enter the child passenger mobile phone number': '请输入儿童乘客手机号',
    'FIT Booking': '机票预订',
    'One way': '单程',
    'Round trip': '往返',
    'Departure': '出发地',
    'Destination': '目的地',
    'Departure date': '出发日期',
    'Return date': '返程日期',
    'Search': '搜  索',
    'Departure city cannot be empty': '出发城市不能为空',
    'Arrival city cannot be empty': '到达城市不能为空',
    'Please select a voyage type': '请选择航程类型',
    'Please select a departure date': '请选择出发日期',
    'Please select arrival date': '请选择到达日期',
    'Please select the number of passengers': '请选择乘客数量',
    'Filter': '筛选',
    'Clear all': '清除全部',
    'Direct flight': '直飞',
    'Transfer': '中转',
    'DptArrTime': '起抵时间',
    'Am': '上午{time}点',
    'Pm': '下午{time}点',
    'Night': '晚上{time}点',
    'PriceToHigh': '价格低-高',
    'PriceToLow': '价格高-低',
    'FlightTimeToLate': '起飞时间早-晚',
    'FlightTimeToMorning': '起飞时间晚-早',
    'ElapsedTimeToLong': '耗时短-长',
    'ElapsedTimeToShort': '耗时长-短',
    'Elapsed Time': '耗时',
    'Departure Time': '起飞时间',
    'Airline': '航司',
    'Transit city': '中转城市',
    'You have enough reasons to choose us': '您有足够的理由选择我们',
    'Service Guarantee': '服务保障',
    'One-to-one account manager 7 * 24 hours service': '一对一客户经理7*24小时服务',
    'Ticket guarantee': '出票保障',
    '100% ticket issued after payment': '支付后100%出票',
    'Travel guarantee': '出行保障',
    'If the passenger cannot handle the flight normally due to the ticket problem, the platform will bear the loss': '若因客票问题旅客无法正常办理乘机，平台承担损失',
    'Turn': '转',
    'Times': '次',
    'SELECT': '选择',
    'Class': '舱等',
    'Refund': '退票',
    'Change': '改签',
    'Refund&Change': '退改签',
    'Price': '价格',
    'People': '人',
    'Baby': '婴儿',
    'Avg tax-inclusive': '人均含税价',
    'Reservation': '预订',
    'Flight information is empty': '航班信息为空',
    'Total duration': '总时长',
    'First Class': '头等舱',
    'Business Class': '公务舱',
    'Economy Class': '经济舱',
    'Business/First Class': '公务/头等舱',
    'Economy/Excess Class': '经济/超经舱',
    'from': '起',
    'Flight details': '航班详情',
    'go trip': '去程',
    'return trip': '返程',
    'Transfer from': '转 {city} {time}',
    'stopover': '于{city}停留',
    'Previous step': '上一步',
    'Final Confirmation': '确认',
    'Please select passenger nationality': '请选择乘客国籍',
    'Please select a passenger area code': '请选择乘客区号',
    'Please enter contact last name': '请输入联系人姓',
    'Please enter contact name': '请输入联系人名',
    'Please select a contact area code': '请选择联系人区号',
    'Please enter the contact mobile phone number': '请输入联系人手机号',
    'Please enter contact email': '请输入联系人邮箱',
    'Subject to the revised flight time': '以修改航班时间为准'
  },
  refundList: {
    'Reviewer': '审核人',
    'Confirm Ticket Refund': '确认退票',
    'Are you sure you want to refund the ticket?': '确定要退票吗？',
    'Downloading, do not close or refresh the page': '正在下载，请勿关闭或刷新页面...',
    'Refund form status': '退票单状态',
    'Refund Type': '退票类型',
    'Special': '特殊',
    'Voluntary': '自愿',
    'Involuntary': '非自愿',
    'Flight change': '航变',
    'Refund due to illness': '病退',
    'Diversion': '备降',
    'Refactor full refund': '重构全退',
    'Deny boarding': '拒载',
    'Oversold': '超售',
    'Epidemic': '疫情',
    'Special event': '特殊事件',
    'Visa refused': '拒签',
    'Formal full refund': '形式全退',
    'Void ticket‌': '废票',
    'Platform ticket number': '出票单号',
    'Platform refund order number': '退票单号',
    'Flight number': '航班号',
    'Passenger': '乘机人',
    'Start date': '开始日期',
    'End date': '结束日期',
    'Auto refresh': '自动刷新',
    'Query': '查询',
    'Reset': '重置',
    'Refund time': '退票时间',
    'Refund Date': '退票日期',
    'Abnormal refund': '退票异常',
    'Abnormal reject': '异常驳回',
    'Refund passenger card has been changed': '已改签退乘机人卡',
    'PNR/Route': 'PNR/行程',
    'Refund Fee': '退票费',
    'Ticket Refund Amount': '应退金额',
    'Receivable Amount': '应收金额',
    'Refund Type/Reason': '退票类型/退票原因',
    'Source/Latest Refund': '退票来源/最晚退票时间',
    'Refund profit': '退票利润',
    'Lock single': '锁单人',
    'Unlock': '解锁',
    'View': '查看',
    'Handle': '处理',
    'Refund slip log': '退票单日志',
    'Order number': '订单号',
    'Operator': '操作人',
    'Refund Applicant': '退票申请人',
    'Refund Persons': '退票人',
    'Dispatch': '派单',
    'Account number': '账号',
    'Cancel': '取消',
    'Pending process': '待处理',
    'Completed': '退票完成',
    'Failed': '退票失败',
    'Please select an account': '请选择账号',
    'Please select the verification type': '请选择核账类型',
    'Refund remarks:': '退票备注：',
    'Refund Remarks': '退票备注',
    'Is ExChange': '是否改签',
    'Financial Notes:': '财务备注：',
    'The refund slip has been approved': '退票单已被',
    'Lock': '锁定',
    'Unlocked successful': '解锁成功',
    'Unlock failed': '解锁失败',
    'Start and end dates cannot be null': '开始日期和结束日期不能为空',
    'The verification end date must be greater than or equal to the start date': '核账结束日期必须大于等于开始日期',
    'The difference between the start date and the end date cannot be greater than 365 days': '开始日期和结束日期相差不能大于365天',
    'Order dispatched successfully': '派单成功',
    'Please wait': '请稍候...',
    'Ticket Refund Application': '退票申请',
    'Submit request': '提交退票',
    'Save ticket refund': '保存退票单',
    'Refund Order Information': '退票单信息',
    'Ticket number': '出票单号',
    'Refund order number': '退票单号',
    'Query Interface': '查询接口',
    'Segment Information': '航段信息',
    'Ticketing segment information': '出票航段信息',
    'Segment': '航段',
    'Type': '类型',
    'Status': '状态',
    'Airlines': '航司',
    'Itinerary': '行程',
    'Flight date': '航班日期',
    'Cabin': '舱位',
    'Refund flight info': '退票航段信息',
    'Passenger Information': '乘客信息',
    'Original passenger info': '出票乘客信息',
    'Passenger status': '乘客状态',
    'Passenger name': '乘客姓名',
    'Sex': '性别',
    'Male': '男',
    'Female': '女',
    'Price': '票面价',
    'Taxes and Fees': '税费',
    'Total selling price': '销售总价',
    'Please enter a refund fee': '请输入退票费',
    'Please enter the refund amount': '请输入退款金额',
    'Refund passenger info': '退票乘客信息',
    'Refund Information': '退票信息',
    'Please select': '请选择',
    'Reason for refund': '退票原因',
    'Please enter content': '请输入内容',
    'Total refund fee': '总退票费',
    'Total refund': '总退款',
    'Refund flight segment cannot be empty': '退票航段不能为空',
    'Refund passengers cannot be empty': '退票乘机人不能为空',
    'Please enter': '请输入',
    'Platform refund fee': '退票费',
    'Purchase refund fee': '采购退票费',
    'Purchase recovery': '采购回款',
    'Profit': '利润',
    'Please enter the total refund charge': '请输入总退票费',
    'Please select a refund type': '请选择退票类型',
    'Please enter the total refund amount': '请输入应退总金额',
    'Refund form submitted successfully': '保存退票单成功',
    'Tips': '提示',
    'Successfully obtained ticketing information': '获取出票信息成功',
    'Successfully obtained refund information': '获取退票信息成功',
    'Please enter the correct number': '请输入正确的数字',
    'Normal': '正常',
    'Issue tickets': '出票',
    'Refund': '退票',
    'Change book': '改签',
    'Changed': '已改签',
    'Exception': '异常',
    'Ticket refund': '已退票',
    'Ticket refund application': '退票申请',
    'Refund Details': '退票单详情',
    'Modification': '修改',
    'Secondary Reason for Reject': '拒绝二级原因',
    'Total ticket price': '出票单总价',
    'Ticket time': '出票时间',
    'Children': '儿童',
    'Operation': '操作',
    'Purchase Amount': '采购金额',
    'Change': '改',
    'Ticket number verification': '票号验证',
    'Refund rejected': '拒绝退票',
    'Unlock and handle': '解锁并处理',
    'Airline refund rules': '航司退改规则',
    'Please enter the refund order number': '请输入退票单号',
    'Total refund amount': '应退总金额',
    'Total receivable amount': '应收总金额',
    'Ticket Remarks': '出票备注',
    'Save refund notes': '保存退票备注',
    'Save Ticket Notes': '保存出票备注',
    'Save financial notes': '保存财务备注',
    'Order log': '订单日志',
    'Edit Products': '编辑产品',
    'Policy Type': '政策类型',
    'Clearance Products': '清仓产品',
    'Business travel products': '商旅产品',
    'Transit': '中转',
    'Transit products': '中转产品',
    'Charter airline': '包机',
    'Cut position': '切位',
    'Airline VIP': '航司VIP',
    'General Policy': '普通政策',
    'Prepayment Policy': '预付政策',
    'Team Policy': '团队政策',
    'Special Policy': '特价政策',
    'K-bit policy': 'K位政策',
    'Fixed price': '固定价格',
    'Applicable spaces': '适用舱位',
    'Directly connected': '直连',
    'Type of sale': '销售类型',
    'Solid hatch': '固舱',
    'See hatch': '见舱',
    'Policy code format': '政策代码格式',
    'None': '无',
    'Additional airline code': '追加航司代码',
    'Additional delivery time (time and space)': '追加投放时间（时分）',
    'Delivery Type': '投放类型',
    'Total + increment': '全量+增量',
    'Full quantity only': '仅全量',
    'Increment only': '仅增量',
    'Delete policy on increment': '增量时删除政策',
    'Yes': '是',
    'No': '否',
    'Delete type': '删除类型',
    'By policy code': '按政策代码',
    'By delivery time': '按投放时间',
    'Reimbursement Type': '报销类型',
    'Invoice': '发票',
    'Itinerary + Difference Invoice': '行程单+差额发票',
    'Office number': 'office号',
    'IATA number': 'IATA号',
    'Drop in superior cabinet': '投放上级舱位',
    'Reservation': '订位',
    'Machine Wine Package': '机酒套餐',
    'Sharing': '共享',
    'Support stopping': '支持经停',
    'Support children': '支持儿童',
    'Tariff rules': '运价规则',
    'Return and Change ID': '退改签ID',
    'Place a Fare': '投放票面价',
    'Price Type': '票面价类型',
    'Official website price': '官网价',
    'Settlement price': '结算价',
    'Specify Fare': '指定票面价',
    'Y cabin discount': 'Y舱折扣',
    'Special Ticket Instructions': '特殊票务说明',
    'Minimum age limit': '最小年龄限制',
    'Maximum age limit': '最大年龄限制',
    'Refund Review': '退票审核',
    'Audit Results': '审核结果',
    'Do not pass': '不通过',
    'Please select a reason for rejection': '请选择拒绝原因',
    'Provide involuntary supporting materials': '提供非自愿证明材料',
    'Cancel Retention Change': '取消留改',
    'Ticket number is not OPEN status': '票号非OPEN状态',
    'The policy does not match and cannot be refunded': '政策不符无法全退',
    'Exchange for a refund': '换开退票',
    'Partial refund': '部分退票',
    'Other': '其他',
    'Secondary Reason for Rejection': '二级拒绝原因',
    'Please select a secondary reason for rejection': '请选择二级拒绝原因',
    'Insufficient materials for involuntary refunds': '非自愿退票材料不足',
    'The content of the involuntary refund materials': '非自愿退票材料内容不清',
    'The supplier contacts the airline to change the visa and needs a refund from the airline': '供应商联系航司改签，需航司退款',
    'The guest contacts the airline to change the booking and needs a refund from the airline': '客人联系航司改签，需航司退款',
    'The changed ticket number is required': '需提供改签后票号',
    'Does not comply with special policies': '不符合特殊政策',
    'Does not meet the rules of aeronautical change': '不符合航变规则',
    'Protection flight confirmed': '已确认保护航班',
    'Ticket checked in': '客票已值机',
    'Airline has retreated': '航司已退客',
    'Need to unhook': '需解挂',
    'Follow the used segment ticket number USED': '关注已使用段票号USED',
    'Can t refund a single paragraph ': '无法单退一段 ',
    'Wrong payment amount': '收付金额错',
    'No refund policy needs to be cancelled and changed': '无退票政策需取消留改',
    'Itinerary to be voided': '需作废行程单',
    'Ctrip asks to refuse an order': '携程要求拒单',
    'Vulnerable ticket': '可废票',
    'Associated child and infant tickets cannot be refundable single': '关联儿童、婴儿机票无法单退',
    'Only vouchers can be refunded': '只能退代金券',
    'Charter flights are non-refundable': '包机无法退票',
    'Ticket has expirated': '客票已过期',
    'Ticket desk collapse/airline bankruptcy': '票台倒闭/航司破产',
    'Remarks': '备注',
    'Affirmation': '确定',
    'Turn to an appeal': '转为申诉单',
    'Type of appeal': '申诉类型',
    'Platform Refund': '平台补退',
    'Quality inspection': '质检',
    'Our company appeals': '我司申诉',
    'Appeal Amount': '申诉金额',
    'Appeal Remarks': '申诉备注',
    'Attachments': '附件',
    'Click to upload': '点击上传',
    'Save': '保存',
    'Abnormal verification': '核销异常',
    'Please enter the purchase refund fee': '请输入采购退票费',
    'Please enter purchase rebate': '请输入采购回款',
    'Rejected verification': '核销驳回',
    'Reason for rejection': '驳回原因',
    'Has the ticket been refunded': '是否已退票',
    'Please enter airline refund charge': '请输入航司退票费',
    'Please enter airline return': '请输入航司回款',
    'Exception Note': '异常备注',
    'Submit': '提交',
    'Verification channel': '验证渠道',
    'Where to go': '去哪儿',
    'Departure airport code': '出发机场代码',
    'Arrival airport code': '到达机场代码',
    'Departure time': '起飞时间',
    'Ticket number status': '票号状态',
    'Fare price': '票价',
    'China Eastern Airlines NDC Refund': '东航NDC退票',
    'Is it refundable?': '是否可退',
    'Refundable': '可退',
    'Non-refundable': '不可退',
    'Non-refundable cause': '不可退原因',
    'Refund confirmation': '退票确认',
    'Adult cabin': '成人舱位',
    'Children s Cabin ': '儿童舱位 ',
    'Select flight date': '选择航班日期',
    'Select departure time': '选择起飞时间',
    'Arrival time': '到达时间',
    'Select time of arrival': '选择到达时间',
    'Modify the latest refund time': '修改最晚退票时间',
    'Latest refund time': '最晚退票时间',
    'Please select profit type': '请选择盈利类型',
    'Airline cannot be empty': '航司不能为空',
    'Departure airport code cannot be empty': '出发机场代码不能为空',
    'Arrival airport code cannot be empty': '到达机场代码不能为空',
    'Flight number cannot be empty': '航班号不能为空',
    'Adult cabin cannot be empty': '成人舱位不能为空',
    'Children s cabin cannot be empty ': '儿童舱位不能为空 ',
    'Please select a flight date': '请选择航班日期',
    'Please select departure time': '请选择起飞时间',
    'Please select an arrival time': '请选择到达时间',
    'The latest refund time cannot be empty': '最晚退票时间不能为空',
    'Please select the refund form status': '请选择退票单状态',
    'Please select appeal type': '请选择申诉类型',
    'Please select a passenger': '请选择乘机人',
    'Please fill in the appeal amount': '请填写申诉金额',
    'Please fill in the remarks': '请填写备注',
    'Please fill in the reason for rejection': '请填写驳回原因',
    'Please select whether the ticket has been refunded': '请选择是否已退票',
    'Please fill in the exception notes': '请填写异常备注',
    'Voyage': '航变退',
    'Segment back': '接段退',
    'Material return': '材料退',
    'Voluntary refund': '自愿退',
    'Modify the latest refund time successfully': '修改最晚退票时间成功',
    'Modified segment information successfully': '修改航段信息成功',
    'Switched off': '已换开',
    'Ticket used': '客票已使用',
    'Passenger is boarding': '旅客已登机',
    'Checking in': '正在办理值机',
    'Ticket Valid': '客票有效',
    'The ticket has been exchanged for a paper ticket': '客票已换开为纸票',
    'Ticket has been refunded': '客票已退',
    'Ticket has been suspended': '客票已挂起',
    'Void': '作废',
    'The format of the ticket number is wrong, it can only be 6, 7, and 13': '票号格式不对，只能是6位、7位、13位',
    'Deleted attachment successful': '删除附件成功',
    'Failed to delete attachment, reason:': '删除附件失败，原因：',
    'Exceptionally successful verification': '核销异常成功',
    'The verification was rejected successfully': '核销驳回成功',
    'The verification failed due to:': '核销驳回失败，原因：',
    'Airline Refund Fee': '航司退票费',
    'Airline returns': '航司回款',
    'The abnormal operation of the refund was successful': '退票异常操作成功',
    'The abnormal operation of refund failed. Reason:': '退票异常操作失败，原因：',
    'Abnormal rejection operation successful': '异常驳回操作成功',
    'Abnormal rejection operation failed, reason:': '异常驳回操作失败，原因：',
    'Please select the passenger who needs to refund the ticket': '请选择需要退票的乘机人',
    'Select the passenger, please enter the refund fee': '选中乘机人请输入退票费',
    'Select the passenger, please enter the refund amount': '选中乘机人请输入退票金额',
    'Please select the flight segment that needs to be refunded': '请选择需要退票的航段',
    'Please enter the reason for the refund': '请输入退票原因',
    'Please enter a refund rates': '请输入退票费率',
    'Please enter refund and return': '请输入退票回款',
    'Please enter refund profit': '请输入退票利润',
    'Submit refund successfully': '提交退票成功',
    'Modified the refund form successfully': '修改退票单成功',
    'Confirm the refund form status to change': '确认退票单状态改为',
    'Is it?': '吗？',
    'Modified the status of the refund form successfully': '修改退票单状态成功',
    'Failed to modify the status of the refund form. Reason:': '修改退票单状态失败，原因：',
    'Modify the refund form status and the order is successful': '修改退票单状态订单成功',
    'The order failed to modify the status of the refund form. Reason:': '修改退票单状态订单失败，原因：',
    'Modify the refund status successfully': '修改退票状态成功',
    'Failed to modify the refund status, reason:': '修改退票状态失败，原因：',
    'Are you sure you want to return the order?': '确定返单吗？',
    'Are you sure the status of the refund order is changed to refund and cancel?': '确定退票单状态改为退票取消吗？',
    'Good to go': '退票审核成功',
    'The refund review failed. Reason:': '退票审核失败，原因：',
    'Refund completed successfully': '退款完成成功',
    'Refund completion failed, reason:': '退款完成失败，原因：',
    'Confirm that the refund is complete?': '确认退款完成吗？',
    'Refund failed, reason:': '退款失败，原因：',
    'Confirm review confirmation?': '确认复核确认吗？',
    'Review confirmed successful': '复核确认成功',
    'Review confirmation failed, reason:': '复核确认失败，原因：',
    'Confirm the verification of the refund?': '确认核销退票吗？',
    'Successful verification of refund': '核销退票成功',
    'The verification of the refund failed. Reason:': '核销退票失败，原因：',
    'Please enter the platform refund verification amount': '请输入平台退款核账金额',
    'Please enter the platform refund verification time': '请输入平台退款核账时间',
    'Save the platform refund and verify the account successfully': '保存平台退款核账成功',
    'The save platform refund verification failed. Reason:': '保存平台退款核账失败，原因：',
    'Please enter the purchase refund verification amount': '请输入采购回款核账金额',
    'Please enter the time of the purchase refund bill': '请输入采购回款账单时间',
    'Save the purchase receipt and verify the account successfully': '保存采购回款核账成功',
    'Failed to save the purchase receipt for verification. Reason:': '保存采购回款核账失败，原因：',
    'Delete the platform refund and verify the account successfully': '删除平台退款核账成功',
    'Delete platform refund verification failed, reason:': '删除平台退款核账失败，原因：',
    'Delete the purchase receipt and verify the account successfully': '删除采购回款核账成功',
    'Delete the purchase receipt verification failed. Reason:': '删除采购回款核账失败，原因：',
    'The platform refund amount and time cannot be empty!': '平台退款金额和时间不能为空！',
    'The purchase refund amount and time cannot be empty!': '采购回款金额和时间不能为空！',
    'Settlement was abnormally successful': '结算异常成功',
    'Settlement failed abnormally, reason:': '结算异常失败，原因：',
    'Settlement exception handled successfully': '结算异常已处理成功',
    'The settlement exception has been handled and failed. Reason:': '结算异常已处理失败，原因：',
    'The refund amount and time cannot be empty!': '回款金额和时间不能为空！',
    'Payment successful': '回款成功',
    'The refund failed. Reason:': '回款失败，原因：',
    'Refund successful': '退票成功',
    'Are you sure you want to close the current page?': '确定关闭当前页面吗？',
    'Are you sure to unlock and close?': '确定解锁并关闭吗？',
    'Unlocked and processed successfully': '解锁并处理成功',
    'Modify the remarks form successfully': '修改备注成功',
    'Failed to modify the remarks on the refund form. Reason:': '修改退票单备注失败，原因：',
    'The remarks on the refund form cannot be empty!': '修改退票单备注失败，原因：退票单备注不可为空！',
    'Modify the ticket and note successfully': '修改出票单备注成功',
    'Failed to modify the remarks on the ticket. Reason:': '修改出票单备注失败，原因：',
    'Failed to modify the ticketing remarks. Reason: The ticketing remarks cannot be empty!': '修改出票单备注失败，原因：出票单备注不可为空！',
    'Modified Financial Remarks Successfully': '修改财务备注成功',
    'Failed to modify financial remarks, reason:': '修改财务备注失败，原因：',
    'Failed to modify financial remarks. Reason: Financial remarks cannot be empty!': '修改财务备注失败，原因：财务备注不可为空！',
    'Product information is empty': '产品信息为空',
    'China Eastern Airlines NDC refund successfully': '东航NDC退票成功',
    'China Eastern Airlines NDC refund failed, reason:': '东航NDC退票失败，原因：',
    'Parameter error, please resubmit': '参数错误，请重新提交。',
    'Normal refund': '正常退票',
    'Repeat/Cancel Refund': '重复/取消退票',
    'Special operation refund': '特殊操作退票',
    'Refund Reissue': '退票重出',
    'No refund reminder time set': '未设置时间',
    'After flight': '航后',
    'Confirm': '确认',
    'Refund time has passed': '已超过退票时间',
    'Confirmation Countdown': '确认倒计时'
  },
  change: {
    'Up to three files can be chosen': '最多可选择三个文件',
    'Order payment expired': '已过支付有效期',
    'Payment countdown': '支付倒计时',
    'Re-Submit': '重新提交',
    'Deadline': '最晚时间',
    'Pending review': '待审核',
    'Pending ticket issuance': '待出票',
    'Pending payment': '待支付',
    'Completed': '改签完成',
    'Exchange Status': '改签单状态',
    'Exchange Type': '改签类型',
    'Ticket number': '出票单号',
    'Exchange No': '改签单号',
    'Original PNR': '原PNR',
    'Flight number': '航班号',
    'Passenger': '乘机人',
    'Change Start': '改签开始日期',
    'Change End': '改签结束日期',
    'Auto refresh': '自动刷新',
    'Query': '查询',
    'Reset': '重置',
    'Exchange Time': '改签时间',
    'New ticket number': '新票号',
    'Latest Exchange': '最晚改签时间',
    'Change flight information': '改签航班信息',
    'Exchange Type/Reason': '改签类型/改签原因',
    'Exchange Amount': '改签金额',
    'Lock single': '锁单人',
    'Unlock': '解锁',
    'View': '查看',
    'Handle': '处理',
    'Go to pay': '去支付',
    'Change the signing log': '改签单日志',
    'Order number': '订单号',
    'Operator': '操作人',
    'Exchange Account': '改签账号',
    'Dispatch': '派单',
    'Account number': '账号',
    'Cancel': '取消',
    'Please select the verification type': '请选择核账类型',
    'Please select an account': '请选择账号',
    'Unknown': '未知',
    'Voluntary': '自愿',
    'Involuntary': '非自愿',
    'Failed': '改签失败',
    'The order has been changed': '改签单已被',
    'Lock': '锁定',
    'Unlocked successful': '解锁成功',
    'Unlock failed': '解锁失败！',
    'Start and end dates cannot be null': '开始日期和结束日期不能为空',
    'The verification end date must be greater than or equal to the start date': '核账结束日期必须大于等于开始日期',
    'Inquire about abnormal employee dispatch orders': '查询员工派单异常。',
    'The difference between the start date and the end date cannot be greater than 365 days': '开始日期和结束日期相差不能大于365天',
    'Change details': '改签详情',
    'Exchange Order Information': '改签单信息',
    'Please select': '请选择',
    'Change PNR': '改签PNR',
    'Modification': '修改',
    'Segment Information': '航段信息',
    'Original flight info': '原航段信息',
    'Original passenger': '原乘机人',
    'Exchanged passenger': '改签乘机人',
    'Segment': '航段',
    'Type': '类型',
    'Status': '状态',
    'Itinerary': '行程',
    'Flight date': '航班日期',
    'Cabin': '舱位',
    'Adult': '成人',
    'Children': '儿童',
    'Operation': '操作',
    'Exchanged flight info': '新航段信息',
    'Passenger Information': '乘客信息',
    'Change method': '改签方式',
    'Not changed': '未改签',
    'Normal change': '正常改签',
    'Special change': '特殊改签',
    'Refund return': '退票重出',
    'Passenger name': '乘客姓名',
    'Price': '票面价',
    'Taxes and Fees': '税费',
    'Total selling price': '销售总价',
    'Purchase Amount': '采购金额',
    'Original PNR/New PNR': '原PNR/新PNR',
    'Please enter a new PNR': '请输入新PNR',
    'Original ticket number/new ticket number': '原票号/新票号',
    'Please enter a new ticket number': '请输入新票号',
    'Rescheduling Fee': '改期费',
    'Please enter rescheduling charge': '请输入改期费',
    'Fare difference': '舱差',
    'Please enter the fare difference': '请输入舱差',
    'Profit': '利润',
    'Please enter purchase rebate': '请输入采购回款',
    'Save the change': '保存改签',
    'Change Review': '改签审核',
    'Refuse to change': '拒绝改签',
    'Refuse to ticket': '拒绝出票',
    'Change Information': '改签信息',
    'Confirm change': '确认改签',
    'Please enter the order number': '请输入单号',
    'Reason for change': '改签原因',
    'Total Rescheduling Fee': '总改期费',
    'Total fare difference': '总舱差',
    'Change the amount receivable': '改签应收金额',
    'Change the total settlement price': '改签结算总价',
    'After adding the purchase record, the payment amount is automatically assigned to this field': '新增采购记录后支付金额自动赋值到该字段',
    'Please enter content': '请输入内容',
    'Change total profit': '改签总利润',
    'Exchange Remarks': '改签备注',
    'Save Exchange Remarks': '保存改签备注',
    'Order log': '订单日志',
    'Please select a passenger': '请选择乘机人',
    'Procurement channels': '采购渠道',
    'Please select a purchasing channel': '请选择采购渠道',
    'Payment Channels': '付款渠道',
    'Please select a payment channel': '请选择付款渠道',
    'Please select a type': '请选择类型',
    'Expenditure': '支出',
    'Income': '收入',
    'Purchase space': '采购舱位',
    'Purchase order number': '采购订单号',
    'Purchase account': '采购账号',
    'Purchase Password': '采购密码',
    'Payment Password': '支付密码',
    'Transaction No': '交易流水号',
    'Purchase Fare': '采购票面价',
    'Payment Amount': '支付金额',
    'Offer Type': '优惠类型',
    'Please select offer type': '请选择优惠类型',
    'Red Packet': '红包',
    'Coupon': '优惠券',
    'Stored value card': '储值卡',
    'Integral': '积分',
    'Discount Amount': '优惠金额',
    'Offer logo': '优惠标识',
    'Purchase Remarks': '采购备注',
    'Agency Fee': '代理费',
    'Agency rates': '代理费率',
    'Save': '保存',
    'Product name': '产品名称',
    'Policy Type': '政策类型',
    'Clearance Products': '清仓产品',
    'Business travel products': '商旅产品',
    'Transit': '中转',
    'Transit products': '中转产品',
    'Charter airline': '包机',
    'Cut position': '切位',
    'Airline VIP': '航司VIP',
    'Special': '特价',
    'General Policy': '普通政策',
    'Prepayment Policy': '预付政策',
    'Team Policy': '团队政策',
    'Special Policy': '特价政策',
    'K-bit policy': 'K位政策',
    'Fixed price': '固定价格',
    'Applicable spaces': '适用舱位',
    'Directly connected': '直连',
    'Type of sale': '销售类型',
    'Solid hatch': '固舱',
    'See hatch': '见舱',
    'Policy code': '政策代码',
    'Policy code format': '政策代码格式',
    'None': '无',
    'Additional airline code': '追加航司代码',
    'Additional delivery time (time and space)': '追加投放时间（时分）',
    'Delivery Type': '投放类型',
    'Total + increment': '全量+增量',
    'Full quantity only': '仅全量',
    'Increment only': '仅增量',
    'Delete policy on increment': '增量时删除政策',
    'Yes': '是',
    'No': '否',
    'Delete type': '删除类型',
    'By policy code': '按政策代码',
    'By delivery time': '按投放时间',
    'Reimbursement Type': '报销类型',
    'Invoice': '发票',
    'Itinerary + Difference Invoice': '行程单+差额发票',
    'Office number': 'office号',
    'IATA number': 'IATA号',
    'Drop in superior cabinet': '投放上级舱位',
    'Reservation': '订位',
    'Machine Wine Package': '机酒套餐',
    'Share': '共享',
    'Support stopping': '支持经停',
    'Support children': '支持儿童',
    'Tariff rules': '运价规则',
    'Return and Change ID': '退改签ID',
    'Place a Fare': '投放票面价',
    'Price Type': '票面价类型',
    'Official website price': '官网价',
    'Settlement price': '结算价',
    'Specify Fare': '指定票面价',
    'Y cabin discount': 'Y舱折扣',
    'Special Ticket Instructions': '特殊票务说明',
    'Minimum age limit': '最小年龄限制',
    'Maximum age limit': '最大年龄限制',
    'Turn to an appeal': '转为申诉单',
    'Type of appeal': '申诉类型',
    'Platform Refund': '平台补退',
    'Quality inspection': '质检',
    'Our company appeals': '我司申诉',
    'Appeal Amount': '申诉金额',
    'Appeal Remarks': '申诉备注',
    'Attachments': '附件',
    'Click to upload': '点击上传',
    'Only supports': '仅支持',
    'Upload up to 3 files': '最多可上传3个文件',
    'Change Cancel': '改签取消',
    'Reject reason': '取消原因',
    'Affirmation': '确定',
    'Airlines': '航司',
    'Departure airport code': '出发机场代码',
    'Arrival airport code': '到达机场代码',
    'Adult cabin': '成人舱位',
    'Children s Cabin': '儿童舱位',
    'Select flight date': '选择航班日期',
    'Departure time': '起飞时间',
    'Select departure time': '选择起飞时间',
    'Arrival time': '到达时间',
    'Select time of arrival': '选择到达时间',
    'Reason for rejection': '拒绝原因',
    'Verification channel': '验证渠道',
    'Where to go': '去哪儿',
    'Ticket number status': '票号状态',
    'Fare price': '票价',
    'Modify the latest change time': '修改最晚改签时间',
    'Purchase channel cannot be empty': '采购渠道不能为空',
    'Type cannot be null': '类型不能为空',
    'Purchase order number cannot be null': '采购订单号不能为空',
    'The transaction serial number cannot be null': '交易流水号不能为空',
    'Payment amount cannot be empty': '支付金额不能为空',
    'The discount amount cannot be empty, it can be 0': '优惠金额不能为空,可为0',
    'Please select a refund method': '请选择退款方式',
    'Please fill in the reason for rejection': '请填写驳回原因',
    'Please select appeal type': '请选择申诉类型',
    'Please fill in the appeal amount': '请填写申诉金额',
    'Airline cannot be empty': '航司不能为空',
    'please enter a number': '请输入数字',
    'Charge': '留钱',
    'Please Fill in': '请填写',
    'Departure airport code cannot be empty': '出发机场代码不能为空',
    'Arrival airport code cannot be empty': '到达机场代码不能为空',
    'Flight number cannot be empty': '航班号不能为空',
    'Adult cabin cannot be empty': '成人舱位不能为空',
    'Children s cabin cannot be empty': '儿童舱位不能为空',
    'Please select a flight date': '请选择航班日期',
    'Please select departure time': '请选择起飞时间',
    'Please select an arrival time': '请选择到达时间',
    'Please select the latest change time': '请选择最晚改签时间',
    'Please select flight segment': '请选择航段',
    'Modify the latest change time successfully': '修改最晚改签时间成功',
    'Success~': '成功啦~',
    'Please enter the correct number': '请输入正确的数字',
    'Are you sure you want to close the current page?': '确定关闭当前页面吗？',
    'Tips': '提示',
    'Are you sure to unlock and close?': '确定解锁并关闭吗？',
    'Flight number cannot be less than three': '航班号不能小于三位',
    'Departure airport code must be three digitals': '出发机场代码必须是三位',
    'Arrival airport code must be three digitals': '到达机场代码必须是三位',
    'Selected passengers and flight segments have been changed, please select again': '选中乘机人和航段有已改签完成，请重新选择！',
    'New PNR': '新PNR',
    'Platform rescheduling fee': '平台改期费',
    'Platform Upgrade Fee': '平台舱差',
    'Purchase Rescheduling Fee': '采购改期费',
    'Purchase fare difference': '采购舱差',
    'Purchase refund fee': '采购退票费',
    'Purchase recovery': '采购回款',
    'Please enter the total platform rescheduling fee': '请输入平台总改期费',
    'Please enter the total platform fare difference': '请输入平台总舱差',
    'Please enter the change amount receivable': '请输入改签应收金额',
    'Please enter the total settlement price': '请输入改签结算总价',
    'Please enter the total profit of the change': '请输入改签总利润',
    'Change the signature and save it successfully': '改签单保存成功',
    'Confirm that the review is complete?': '确认审核完成吗？',
    'Submit': '提交',
    'Review completed successfully': '审核完成成功',
    'Audit completion failed, reason:': '审核完成失败，原因：',
    'Change rejected successfully': '改签拒绝成功',
    'Change rejection failed, reason:': '改签拒绝失败，原因：',
    'The platform refund amount and time cannot be empty': '平台退款金额和时间不能为空！',
    'Settlement was abnormally successful': '结算异常成功',
    'Settlement failed abnormally, reason:': '结算异常失败，原因：',
    'Settlement exception handled successfully': '结算异常已处理成功',
    'The settlement exception has been handled and failed. Reason:': '结算异常已处理失败，原因：',
    'Audit completed successfully': '核账完成成功',
    'The verification failed. Reason:': '核账完成失败，原因：',
    'Payment successful': '回款成功',
    'The refund failed. Reason:': '回款失败，原因：',
    'Please fill in the reason for cancelation': '请填写取消原因',
    'Reject successfully': '拒绝成功',
    'Unable to perform rejection，reason：': '无法操作拒绝，原因：',
    'Converted to appeal form successfully': '转为申诉单成功',
    'Please select the passenger who needs to be rescheduled': '请选择需要改签的乘机人',
    'Please enter the rescheduling fee': '选中乘机人请输入改期费',
    'Please enter the upgrade fee for the selected passenger': '选中乘机人请输入舱差',
    'Please select the flight segment to be rebooked': '请选择需改签的航段',
    'Please enter the': '请输入第',
    'Flight number to change flight information': '个改签航班信息的航班号',
    'Departure point for changing flight information': '个改签航班信息的出发地',
    'Arrival place for changing flight information': '个改签航班信息的到达地',
    'Flight dates for changing flight information': '个改签航班信息的航班日期',
    'Take-off and landing time for changing flight information': '个改签航班信息的起降时间',
    'Class code for changing flight information': '个改签航班信息的舱位代码',
    'Please enter the change order number': '请输入改签单号',
    'Please enter Change PNR': '请输入改签PNR',
    'Please select a change type': '请选择改签类型',
    'Please enter the reason for the change': '请输入改签原因',
    'Please enter the total rescheduling charge': '请输入总改期费',
    'Please enter the total fare difference': '请输入总舱差',
    'Please enter the amount receivable': '请输入应收金额',
    'Please enter the change ticket settlement price': '请输入改签出票结算价',
    'Please enter change profit': '请输入改签利润',
    'Submit change successfully': '提交改签成功',
    'New purchase record successful': '新增采购记录成功！',
    'Deleted purchase record successfully': '删除采购记录成功',
    'Modify the remarks form successfully': '修改备注成功',
    'Failed to modify the remarks on the refund form. Reason:': '修改退票单备注失败，原因：',
    'The remarks on the refund form cannot be empty': '修改退票单备注失败，原因：退票单备注不可为空！',
    'Modified Financial Remarks Successfully': '修改财务备注成功',
    'Failed to modify financial remarks, reason:': '修改财务备注失败，原因：',
    'Failed to modify financial remarks. Reason: Financial remarks cannot be empty': '修改财务备注失败，原因：财务备注不可为空！',
    'Modify and change the order status and the order is successful': '修改改签单状态订单成功',
    'The order failed to modify and change the signing status. Reason:': '修改改签单状态订单失败，原因：',
    'Modified segment information successfully': '修改航段信息成功',
    'Product information is empty': '产品信息为空',
    'Parameter error, please resubmit': '参数错误，请重新提交',
    'Ticket Change Application': '改签申请',
    'Get change information': '获取改签信息',
    'Ticketing segment information': '出票航段信息',
    'Original passenger info': '出票乘客信息',
    'Change passenger info': '改签乘客信息',
    'Next step': '下一步',
    'The passenger cannot be empty': '乘机人不能为空',
    'Payment channel cannot be empty': '付款渠道不能为空',
    'Purchase account cannot be empty': '采购账号不能为空',
    'Purchase password cannot be null': '采购密码不能为空',
    'The discount amount cannot be empty': '优惠金额不能为空',
    'Change flight segment cannot be empty': '改签航段不能为空',
    'Change the passenger cannot be empty': '改签乘机人不能为空',
    'The new ticket number is incorrect': '新票号不正确',
    'Please enter the total platform change fee': '请输入平台总改签费',
    'Save and change the order successfully': '保存改签单成功',
    'Successfully obtained ticketing information': '获取出票信息成功',
    'Get the change information successfully': '获取改签信息成功',
    'Purchase type cannot be empty': '采购类型不能为空！',
    'The purchasing channel cannot be empty': '采购渠道不能为空！',
    'The payment channel cannot be empty': '付款渠道不能为空！',
    'The purchase account cannot be empty': '采购账号不能为空！',
    'Purchase password cannot be empty': '采购密码不能为空！',
    'The purchase order number cannot be empty': '采购订单号不能为空！',
    'The transaction serial number cannot be empty': '交易流水号不能为空！'
  },
  tableHeader: {
    'Pax': '乘机人',
    'Order No': '订单号',
    'Total Amount': '总金额',
    'Route': '行程信息',
    'Status': '状态',
    'Locker': '锁单人',
    'Departure Airport': '出发机场',
    'Arrival Airport': '到达机场',
    'Airport': '机场',
    'Country': '国家',
    'Currency': '币种',
    'Symbol': '符号',
    'CNY': '中国银行汇率',
    'Exchange Rate': '汇率',
    'Full Name': '全称',
    'Abbreviation': '简称',
    'Refund No': '退票单号',
    'Cabin': '舱位',
    'Departure\/Arrival': '出发到达'
  },
  adjustPrice: {
    'Target Purchasers': '投放采购商',
    'Departure City': '出发城市',
    'Arrival City': '到达城市',
  },
  flightChange: {
    'City': '城市',
    'Departure city code': '出发城市代码',
    'Arrival city code': '到达城市代码',
    'Original Flight': '原航班',
    'New Flight': '新航班',
    'Flight Change': '航变',
    'Flight Change Date': '航变日期',
    'Batch OP': '批量操作',
    'Original Departure\\Arrival Time': '原出发\\到达时间',
    'New Departure\\Arrival Time': '新出发\\到达时间',
    'Original Flight No': '原航班号',
    'New Flight No': '新航班号',
    'Original Departure\\Arrival City': '原出发\\到达城市',
    'New Departure\\Arrival City': '新出发\\到达城市',
    'Original Departure\\Arrival Tower': '原出发\\到达航站楼',
    'New Departure\\Arrival Tower':'新出发\\到达航站楼',
    'Original Flight Date': '原航班日期',
    'New Flight Date': '新航班日期',
    'Operating Time': '处理时间',
    'Operator': '处理人',
    '未知': '未知',
    '取消': '取消',
    '更改': '更改',
    '保护': '保护',
    '航班变更': '航班变更',
    '出发时间变更': '出发时间变更',
    '到达时间变更': '到达时间变更',
    '出发机场变更': '出发机场变更',
    '到达机场变更': '到达机场变更',
    '航班号变更': '航班号变更',
    '无航变': '无航变',
    '出发航站楼变更': '出发航站楼变更',
    '到达航站楼变更': '到达航站楼变更',
    '取消后恢复': '取消后恢复',
    '取消错误的航变通知': '取消错误的航变通知',
    '待通知': '待通知',
    '通知成功': '通知成功',
    '通知失败': '通知失败',
    '已过期': '已过期',
    '人工已处理': '人工已处理',
    '人工已删除': '人工已删除',
    '系统处理状态': '系统处理状态',
    '正常通知': '正常通知',
    '拒绝通知': '拒绝通知'
  }
}



// WEBPACK FOOTER //
// ./src/language/myZh.js